// Lesson 3 - Community Dental Health I

export const questions = {
  "1. Introduction to Public Health": [
    {
      id: 91001,
      question: "Which of the following best describes the WHO definition of health?",
      options: [
        "A state of complete physical, mental, and social well-being, not merely the absence of disease",
        "The absence of disease and infirmity in an individual at any given time",
        "The ability to function at work without physical limitations or pain",
        "A condition measured by normal laboratory values and absence of clinical symptoms"
      ],
      correctAnswer: 0
    },
    {
      id: 91002,
      question: "According to the WHO, public health is defined as:",
      options: [
        "A clinical service focused on treating individuals with chronic diseases",
        "The art and science of preventing disease, prolonging life, and promoting health through organized societal efforts",
        "A professional discipline focused on diagnosing and managing acute infectious conditions",
        "A government policy that regulates healthcare spending and hospital access"
      ],
      correctAnswer: 1
    },
    {
      id: 91003,
      question: "Which organization defined dental public health as the science and art of preventing and controlling dental diseases and promoting dental health through organized community efforts?",
      options: [
        "World Health Organization (WHO)",
        "Canadian Dental Association (CDA)",
        "American Association of Public Health Dentistry (AAPHD)",
        "Canadian Association of Public Health Dentistry (CAPHD)"
      ],
      correctAnswer: 2
    },
    {
      id: 91004,
      question: "According to the Canadian Dental Association, oral health is best described as:",
      options: [
        "Regular attendance at dental appointments and compliance with professional oral hygiene instructions",
        "A condition in which all teeth are present and free from cavities or visible gum inflammation",
        "A state free from tooth decay, periodontal disease, and oral cancer affecting chewing ability",
        "A state of oral and related tissues contributing to well-being, allowing one to speak, eat, and socialize without pain or embarrassment"
      ],
      correctAnswer: 3
    },
    {
      id: 91005,
      question: "According to the Canadian Association of Public Health Dentistry (CAPHD), dental public health serves:",
      options: [
        "The community as the patient, through research, health promotion, education, and group care programs",
        "Individual patients in private dental clinics through preventive care approaches",
        "Insurance companies by providing cost-effective treatment protocols for dental diseases",
        "Dental professionals by offering continuing education and licensing support"
      ],
      correctAnswer: 0
    },
    {
      id: 91006,
      question: "Which of the following is NOT listed as a purpose of public health?",
      options: [
        "Preventing epidemics and the spread of disease",
        "Providing individual surgical interventions for patients with acute illness",
        "Promoting and encouraging healthy behaviors and mental health",
        "Responding to disasters and assisting communities in recovery"
      ],
      correctAnswer: 1
    },
    {
      id: 91007,
      question: "What is a Public Health Unit (PHU) in Ontario?",
      options: [
        "A hospital department that manages population-wide chronic disease programs",
        "A provincial government ministry responsible for regulating health professionals",
        "An official health agency established by municipalities to provide community health programs with qualified staff",
        "A non-profit organization that delivers dental care to low-income families in rural areas"
      ],
      correctAnswer: 2
    },
    {
      id: 91008,
      question: "Looking at disease trends from 1900 to 2010, which statement is most accurate?",
      options: [
        "Overall death rates increased due to the emergence of new infectious diseases globally",
        "Cancer rates decreased substantially due to advances in chemotherapy and radiation",
        "Infectious diseases like tuberculosis and pneumonia remained the top causes of death",
        "Infectious diseases declined significantly while chronic diseases like heart disease and cancer became leading causes"
      ],
      correctAnswer: 3
    },
    {
      id: 91009,
      question: "Which of the following is a characteristic used to identify a public health problem?",
      options: [
        "Prevalence of the problem, its impact on individuals, and its impact on society",
        "The availability of clinical trials and peer-reviewed research funding streams",
        "The number of hospital beds available and average patient wait times in a region",
        "The cost of surgical interventions and number of licensed specialists available"
      ],
      correctAnswer: 0
    },
    {
      id: 91010,
      question: "Which of the following best describes the \"impact on society\" criterion of a public health problem?",
      options: [
        "The number of affected individuals who seek clinical treatment annually",
        "The financial burden on society and reduced productivity from people being unable to work",
        "The availability of vaccines and preventive medications in community pharmacies",
        "The degree to which a disease reduces individual quality of life and self-esteem"
      ],
      correctAnswer: 1
    },
    {
      id: 91011,
      question: "In the context of dental public health, which represents the BEST example of an ideal public health solution for dental caries?",
      options: [
        "Providing free individual dental checkups to all residents twice per year",
        "Training more dental specialists and expanding private dental insurance coverage",
        "Water fluoridation, dental sealants, fluoride varnish, oral health education, and community screening",
        "Encouraging patients to brush and floss through targeted social media campaigns"
      ],
      correctAnswer: 2
    },
    {
      id: 91012,
      question: "Which column correctly pairs a clinical practice step with its public health equivalent?",
      options: [
        "Patient = Research; Examination = Evaluation; Diagnosis = Screening programs",
        "Treatment = Funds; Diagnosis = Survey; Patient = Program planning activities",
        "Fee/payment = Assurance; Diagnosis = Policy; Treatment planning = Analysis",
        "Patient = Community; Examination = Survey/Assessment; Treatment = Program implementation"
      ],
      correctAnswer: 3
    },
    {
      id: 91013,
      question: "In the comparison between clinical practice and public health, what is the public health equivalent of a clinical \"diagnosis\"?",
      options: [
        "Analysis of collected community health data and problem identification",
        "Survey/Assessment of community needs and health status",
        "Program planning for the delivery of health interventions",
        "Program evaluation and review of health outcome measures"
      ],
      correctAnswer: 0
    },
    {
      id: 91014,
      question: "What are the three core functions of public health?",
      options: [
        "Prevention, Treatment, and Rehabilitation of disease",
        "Assessment, Policy Development, and Assurance",
        "Research, Education, and Community Advocacy programs",
        "Monitoring, Reporting, and Enforcement of health laws"
      ],
      correctAnswer: 1
    },
    {
      id: 91015,
      question: "What does the \"Assessment\" core function of public health involve?",
      options: [
        "Funding community programs that provide direct services to underserved populations",
        "Developing legislation to regulate food safety and environmental hazard exposure",
        "Systematically collecting, assembling, analyzing, and sharing community health information",
        "Enforcing public health laws and ensuring compliance by healthcare providers"
      ],
      correctAnswer: 2
    },
    {
      id: 91016,
      question: "Which of the following best describes the \"Policy Development\" core function of public health?",
      options: [
        "Agencies collect health statistics and share epidemiological data widely with all stakeholders",
        "Agencies directly provide healthcare services to communities in urgent need",
        "Agencies train and certify community health workers and dental hygienists",
        "Agencies use scientific knowledge to guide the development of comprehensive public health policy"
      ],
      correctAnswer: 3
    },
    {
      id: 91017,
      question: "Which of the following best describes the \"Assurance\" core function of public health?",
      options: [
        "Agencies ensure services are provided through regulation, encouraging others, or direct service, guaranteeing them to every community member",
        "Each agency conducts annual health surveys to identify existing gaps in care",
        "Agencies write legislation and lobby for changes to existing healthcare policy",
        "Agencies publish reports on disease trends and recommend updates to clinical guidelines"
      ],
      correctAnswer: 0
    },
    {
      id: 91018,
      question: "Using the childhood obesity example, which action falls under the \"Assessment\" core function?",
      options: [
        "Passing legislation banning junk food advertisements targeting children in media",
        "Collecting data on childhood BMI rates and analyzing trends across school districts",
        "Funding school nutrition programs and providing healthy meal subsidies to families",
        "Linking obese children to community weight management programs and services"
      ],
      correctAnswer: 1
    },
    {
      id: 91019,
      question: "When was the World Health Organization (WHO) founded, and where is it headquartered?",
      options: [
        "Founded in 1950, headquartered in Brussels, Belgium",
        "Founded in 1945, headquartered in New York, United States",
        "Founded in 1948, headquartered in Geneva, Switzerland",
        "Founded in 1960, headquartered in Paris, France"
      ],
      correctAnswer: 2
    },
    {
      id: 91020,
      question: "Which of the following is a current priority of the WHO?",
      options: [
        "Regulating pharmaceutical drug pricing in developed nations",
        "Managing national hospital systems in low-income countries",
        "Standardizing dental licensure requirements across all member countries",
        "Communicable diseases such as HIV/AIDS, Ebola, malaria, and tuberculosis"
      ],
      correctAnswer: 3
    },
    {
      id: 91021,
      question: "What is the primary role of the Centers for Disease Control and Prevention (CDC)?",
      options: [
        "Protecting Americans from health threats by conducting science and providing health information",
        "Regulating food and drug safety through inspections and clinical trials",
        "Training epidemiologists and public health nurses for state health departments",
        "Developing national dental health insurance policies for underserved populations"
      ],
      correctAnswer: 0
    },
    {
      id: 91022,
      question: "Which of the following is an example of Canadian public health agencies mentioned in the lecture?",
      options: [
        "Canadian Dental Hygienists Association, Health Canada, and Cancer Care Ontario",
        "Public Health Agency of Canada (PHAC), Public Health Ontario, and Toronto Public Health",
        "Ontario Medical Association, Registered Nurses' Association of Ontario, and Public Health Ontario",
        "Canadian Institute for Health Information and the Canadian Dental Association"
      ],
      correctAnswer: 1
    },
    {
      id: 91023,
      question: "Which of the following correctly differentiates public health from clinical practice?",
      options: [
        "Public health uses clinical examinations, while private practice relies on community surveys",
        "Public health is funded through patient fees, while clinical care is funded through government grants",
        "Public health focuses on communities using program evaluation, while clinical practice focuses on individual patients using patient evaluation",
        "Public health is delivered by dentists only, while clinical practice involves the full dental team"
      ],
      correctAnswer: 2
    },
    {
      id: 91024,
      question: "According to the WHO's definition, which patient scenario indicates POOR oral health?",
      options: [
        "A patient who has all teeth present with minor surface staining from coffee or tea",
        "A patient who visits the dentist annually but has slight gingival inflammation",
        "A patient who experiences mild sensitivity when consuming cold beverages occasionally",
        "A patient limited in biting, chewing, or speaking due to untreated periodontal disease or tooth loss"
      ],
      correctAnswer: 3
    },
    {
      id: 91025,
      question: "Which of the following public health wheel functions falls under \"Policy Development\"?",
      options: [
        "Develop Policies and Mobilize Community Partnerships",
        "Monitor Health and Evaluate program outcomes regularly",
        "Diagnose and Investigate community health problems systematically",
        "Link to Services and Assure a Competent Workforce"
      ],
      correctAnswer: 0
    },
    {
      id: 91026,
      question: "Which function on the public health wheel falls under the \"Assurance\" core function?",
      options: [
        "Diagnose and Investigate community health concerns in detail",
        "Link to Services and Assure a Competent Workforce",
        "Mobilize Community Partnerships for collaborative health promotion",
        "Inform, Educate, and Empower individuals and communities broadly"
      ],
      correctAnswer: 1
    },
    {
      id: 91027,
      question: "The WHO has played a leading historical role in which of the following achievements?",
      options: [
        "The introduction of water fluoridation programs at a global scale",
        "The founding of the first international dental public health association",
        "The eradication of smallpox worldwide",
        "The development of antiretroviral therapy protocols for HIV patients"
      ],
      correctAnswer: 2
    },
    {
      id: 91028,
      question: "Which action best represents the \"Assurance\" core function applied to childhood obesity?",
      options: [
        "Studying national trends in childhood BMI and tracking caloric intake data",
        "Advocating for school nutrition policies based on available scientific evidence",
        "Passing laws requiring clear nutrition labeling on all school cafeteria food items",
        "Ensuring obese children are connected to nutrition services available in every community"
      ],
      correctAnswer: 3
    },
    {
      id: 91029,
      question: "Which of the following is NOT listed as a current WHO priority area?",
      options: [
        "Development of standardized dental examination protocols worldwide",
        "Nutrition, food security, and healthy eating habits",
        "Sexual and reproductive health, development, and aging",
        "Substance abuse and occupational health and safety"
      ],
      correctAnswer: 0
    },
    {
      id: 91030,
      question: "Which of the following best explains why dental caries qualifies as a public health problem?",
      options: [
        "It is rare in the general population but very costly to treat when it occurs",
        "It is highly prevalent, impacts individuals' ability to eat and speak, and creates significant societal costs",
        "It can only be treated in specialist settings, making it inaccessible to most people",
        "It primarily affects elderly individuals and requires complex surgical treatment"
      ],
      correctAnswer: 1
    },
    {
      id: 91031,
      question: "The WHO defines health as simply the absence of disease or infirmity.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91032,
      question: "Dental public health serves the community as the patient rather than the individual.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91033,
      question: "Clinical practice uses program evaluation, while public health uses patient evaluation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91034,
      question: "The three core functions of public health are Assessment, Policy Development, and Assurance.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91035,
      question: "The WHO was founded in 1948 and is headquartered in Geneva, Switzerland.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
  ],
  "2. Research and Design Studies (Part 1)": [
    {
      id: 91036,
      question: "Which of the following best defines public health?",
      options: [
        "The art and science of diagnosing and treating individual patients in clinical settings",
        "The art and science of preventing disease, prolonging life, and promoting health through the organized efforts of society",
        "The study of biological processes and how they relate to human anatomy and physiology",
        "The management and administration of hospitals and healthcare facilities"
      ],
      correctAnswer: 1
    },
    {
      id: 91037,
      question: "Which branch of public health focuses on the collection, analysis, interpretation, and presentation of data that affects health outcomes?",
      options: [
        "Epidemiology",
        "Occupational health",
        "Biostatistics",
        "Social and behavioral sciences"
      ],
      correctAnswer: 2
    },
    {
      id: 91038,
      question: "What is the definition of epidemiology?",
      options: [
        "The study of medications and their effects on the human body in controlled laboratory settings",
        "The process of collecting and organizing health-related statistics for government planning purposes",
        "The study of psychological and sociological factors that influence individual health behaviors",
        "The study of the frequency and distribution of disease, disability, and death in the population, including causes, control, and determinants of health"
      ],
      correctAnswer: 3
    },
    {
      id: 91039,
      question: "Which of the following questions does epidemiology aim to answer?",
      options: [
        "What is the recommended daily intake of vitamins for a healthy adult?",
        "How many dental procedures are performed each year in North America?",
        "Who is affected by a disease, when does it occur, and where does it occur?",
        "What surgical techniques are most effective for treating oral cancer?"
      ],
      correctAnswer: 2
    },
    {
      id: 91040,
      question: "Which term describes the proportion of individuals in a population who have a disease or characteristic at a given point in time?",
      options: [
        "Incidence",
        "Prevalence",
        "Mortality rate",
        "Case fatality rate"
      ],
      correctAnswer: 1
    },
    {
      id: 91041,
      question: "Which term refers to the number of NEW cases of a disease that develop in a given period of time?",
      options: [
        "Prevalence",
        "Burden of disease",
        "Incidence",
        "Endemic rate"
      ],
      correctAnswer: 2
    },
    {
      id: 91042,
      question: "The burden of disease concept is estimated by adding together:",
      options: [
        "The total number of hospital visits and the total cost of treatment per year",
        "The number of years of life lost due to early death and the years lived with disability caused by the disease",
        "The incidence rate and the prevalence rate of a disease in a given population",
        "The number of endemic cases and the number of epidemic cases in a region"
      ],
      correctAnswer: 1
    },
    {
      id: 91043,
      question: "John Snow is historically known as:",
      options: [
        "The founder of modern dentistry and oral health science",
        "The creator of the first randomized controlled trial in medicine",
        "The father of epidemiology, who traced a cholera outbreak to a contaminated water pump",
        "The first scientist to identify the bacterial cause of tuberculosis"
      ],
      correctAnswer: 2
    },
    {
      id: 91044,
      question: "Which term describes a disease or condition that is consistently present in a specific population or geographic area at a predictable rate?",
      options: [
        "Epidemic",
        "Endemic",
        "Pandemic",
        "Outbreak"
      ],
      correctAnswer: 1
    },
    {
      id: 91045,
      question: "What distinguishes a pandemic from an epidemic?",
      options: [
        "A pandemic affects only one country, while an epidemic spreads to multiple continents",
        "A pandemic is caused by bacteria, while an epidemic is caused by viruses",
        "A pandemic has spread across multiple countries or continents affecting large numbers of people, while an epidemic is a sudden increase above expected cases in specific areas",
        "A pandemic is always more fatal than an epidemic, regardless of geography"
      ],
      correctAnswer: 2
    },
    {
      id: 91046,
      question: "Which of the following best defines \"research\"?",
      options: [
        "The routine collection of patient health data for billing and administrative purposes",
        "Creative and systematic work undertaken to increase the stock of knowledge and devise new applications",
        "The process of applying established clinical guidelines to treat patients with known conditions",
        "Observations made by healthcare workers during routine patient care visits"
      ],
      correctAnswer: 1
    },
    {
      id: 91047,
      question: "What is evidence-based decision making in health care?",
      options: [
        "Making clinical decisions based solely on the personal experience and intuition of the clinician",
        "Using only government-approved treatment protocols when treating patients in any clinical setting",
        "The use of the best evidence currently available to answer questions about the care of individual patients",
        "Relying on patient preferences and anecdotal reports when selecting treatment approaches"
      ],
      correctAnswer: 2
    },
    {
      id: 91048,
      question: "In the scientific method, what is the correct order of steps after formulating a research problem?",
      options: [
        "Collect data → Analyze results → Review literature → Develop hypothesis → Draw conclusions",
        "Review literature → Develop hypothesis → Collect data → Analyze results → Draw conclusions → Communicate findings",
        "Develop hypothesis → Review literature → Analyze results → Collect data → Draw conclusions → Communicate findings",
        "Analyze results → Collect data → Develop hypothesis → Review literature → Draw conclusions → Communicate findings"
      ],
      correctAnswer: 1
    },
    {
      id: 91049,
      question: "Which type of quantitative research study involves random assignment of participants to experimental and control groups?",
      options: [
        "Cross-sectional study",
        "Prospective cohort study",
        "Retrospective cohort study",
        "Randomized controlled trial"
      ],
      correctAnswer: 3
    },
    {
      id: 91050,
      question: "In the hierarchy of evidence, which study design is considered to provide the HIGHEST quality of evidence?",
      options: [
        "Well-designed cohort studies",
        "One or more randomized controlled trials",
        "Systematic review with meta-analysis and Cochrane reviews",
        "Well-designed case control studies"
      ],
      correctAnswer: 2
    },
    {
      id: 91051,
      question: "Which of the following study designs is at the LOWEST level of the evidence hierarchy (highest bias)?",
      options: [
        "Cross-sectional studies and uncontrolled experimental studies",
        "Non-human (animal) research and expert opinion or case reports",
        "Systematic reviews without meta-analysis",
        "Well-designed cohort studies"
      ],
      correctAnswer: 1
    },
    {
      id: 91052,
      question: "In epidemiological research, \"exposure\" refers to:",
      options: [
        "The health event or disease outcome being studied in a research population",
        "The statistical method used to analyze relationships between variables",
        "Factors or conditions that may increase the risk of developing a health condition, such as smoking or poor diet",
        "The process of publishing research findings in peer-reviewed journals"
      ],
      correctAnswer: 2
    },
    {
      id: 91053,
      question: "Which study design collects data from a population at a single point in time, often using surveys or questionnaires?",
      options: [
        "Prospective cohort study",
        "Randomized controlled trial",
        "Retrospective cohort study",
        "Cross-sectional study"
      ],
      correctAnswer: 3
    },
    {
      id: 91054,
      question: "Cross-sectional studies are particularly valuable for determining:",
      options: [
        "The incidence of new cases developing over a long follow-up period",
        "The causal relationship between a specific exposure and a health outcome",
        "The prevalence of a condition in a population at a given time",
        "The effectiveness of a new drug compared to a placebo"
      ],
      correctAnswer: 2
    },
    {
      id: 91055,
      question: "In a prospective cohort study, which of the following is known at the start of the study?",
      options: [
        "The outcome, but not the exposure",
        "Both the exposure and the outcome",
        "Neither the exposure nor the outcome",
        "The exposure, but not the outcome"
      ],
      correctAnswer: 3
    },
    {
      id: 91056,
      question: "A retrospective cohort study (case-control study) is one where:",
      options: [
        "The exposure is known at the start, and researchers follow participants forward in time to observe outcomes",
        "Participants are randomly assigned to treatment and control groups to test an intervention",
        "The outcome is known, and researchers look backward to identify the exposures that may have caused it",
        "A single population is surveyed at one point in time to measure both exposure and outcome"
      ],
      correctAnswer: 2
    },
    {
      id: 91057,
      question: "What is the key difference between causation and association?",
      options: [
        "Causation requires a large sample size, while association can be detected with a small sample",
        "Causation means one event directly leads to another, while association means two events occur together without necessarily one causing the other",
        "Association requires experimental evidence, while causation can be established through observation alone",
        "Causation is measured using correlation coefficients, while association is measured using p-values"
      ],
      correctAnswer: 1
    },
    {
      id: 91058,
      question: "A systematic review differs from a meta-analysis in that:",
      options: [
        "A systematic review uses animal studies, while a meta-analysis uses only human studies",
        "A systematic review comprehensively identifies and synthesizes existing evidence, while a meta-analysis statistically combines results of multiple studies to estimate overall effect size",
        "A meta-analysis is qualitative, while a systematic review always produces a quantitative result",
        "A systematic review is conducted by a single researcher, while a meta-analysis requires a team of at least five researchers"
      ],
      correctAnswer: 1
    },
    {
      id: 91059,
      question: "Which sampling method gives every individual in a population an equal chance of being selected, making it ideal for minimizing bias?",
      options: [
        "Convenience sample",
        "Purposive sample",
        "Stratified sample",
        "Random sample"
      ],
      correctAnswer: 3
    },
    {
      id: 91060,
      question: "Which sampling method divides the population into subgroups and takes random samples from each subgroup to ensure representation?",
      options: [
        "Convenience sample",
        "Stratified sample",
        "Purposive sample",
        "Systematic sample"
      ],
      correctAnswer: 1
    },
    {
      id: 91061,
      question: "A researcher selects every 10th person from a patient registry to participate in a study. This is an example of:",
      options: [
        "Purposive sampling",
        "Convenience sampling",
        "Systematic sampling",
        "Stratified sampling"
      ],
      correctAnswer: 2
    },
    {
      id: 91062,
      question: "Which sampling method involves selecting participants based on availability or ease of access, and may introduce bias?",
      options: [
        "Systematic sample",
        "Random sample",
        "Stratified sample",
        "Convenience sample"
      ],
      correctAnswer: 3
    },
    {
      id: 91063,
      question: "The number of dental procedures performed in a clinic per day is an example of which type of data?",
      options: [
        "Continuous numerical data",
        "Ordinal categorical data",
        "Nominal categorical data",
        "Discrete numerical data"
      ],
      correctAnswer: 3
    },
    {
      id: 91064,
      question: "Classifying dental disease severity as mild, moderate, or severe is an example of which type of data?",
      options: [
        "Discrete numerical data",
        "Continuous numerical data",
        "Ordinal categorical data",
        "Nominal categorical data"
      ],
      correctAnswer: 2
    },
    {
      id: 91065,
      question: "Which of the following is an example of nominal categorical data?",
      options: [
        "The duration of a dental procedure in minutes",
        "A patient's blood pressure measurement",
        "The type of dental care received or a patient's ethnic background",
        "The severity of periodontal disease rated as mild, moderate, or severe"
      ],
      correctAnswer: 2
    },
    {
      id: 91066,
      question: "A p-value less than 0.05 indicates that:",
      options: [
        "The study had a very large sample size and results are therefore reliable",
        "The observed results are unlikely to have occurred by chance and are considered statistically significant",
        "The clinical effect size is large enough to be meaningful in real-world patient care",
        "The null hypothesis has been confirmed and no further research is needed"
      ],
      correctAnswer: 1
    },
    {
      id: 91067,
      question: "What is the difference between statistical significance and clinical significance?",
      options: [
        "Statistical significance applies to laboratory studies, while clinical significance applies to community-based research",
        "Statistical significance is determined by sample size alone, while clinical significance is determined by study design",
        "Statistical significance refers to whether the observed effect is likely real, while clinical significance considers whether the effect is large enough to be meaningful in practice",
        "Statistical significance is only relevant in randomized controlled trials, while clinical significance applies to all study types"
      ],
      correctAnswer: 2
    },
    {
      id: 91068,
      question: "Which organization must researchers apply to before conducting research involving human participants?",
      options: [
        "The World Health Organization (WHO)",
        "The Centers for Disease Control and Prevention (CDC)",
        "The Research Ethics Board (REB)",
        "The American Dental Association (ADA)"
      ],
      correctAnswer: 2
    },
    {
      id: 91069,
      question: "Which ethical standard requires that participants receive full disclosure of the research plan, including risks and benefits, before agreeing to participate?",
      options: [
        "Social justice",
        "Voluntary participation",
        "Confidentiality and anonymity",
        "Informed consent"
      ],
      correctAnswer: 3
    },
    {
      id: 91070,
      question: "Which ethical principle states that participation in research must be completely voluntary and participants may withdraw at any time without penalty?",
      options: [
        "Social justice",
        "Voluntary participation",
        "Respect and dignity",
        "Informed consent"
      ],
      correctAnswer: 1
    },
    {
      id: 91071,
      question: "Which ethical principle requires that participants' identities are protected during and after a study, including when reporting results?",
      options: [
        "Informed consent",
        "Protection of human research participants",
        "Confidentiality and anonymity",
        "Voluntary participation"
      ],
      correctAnswer: 2
    },
    {
      id: 91072,
      question: "Which of the following is considered research misconduct?",
      options: [
        "Reporting unexpected negative findings from a study",
        "Publishing research that challenges established clinical guidelines",
        "Falsifying or fabricating data, plagiarism, and misrepresenting study results",
        "Using a convenience sample instead of a random sample in a study"
      ],
      correctAnswer: 2
    },
    {
      id: 91073,
      question: "In a research publication, the section that provides a brief summary of the study's objectives, methods, results, and conclusions is called the:",
      options: [
        "Introduction",
        "Discussion",
        "Methodology",
        "Abstract"
      ],
      correctAnswer: 3
    },
    {
      id: 91074,
      question: "In a research publication, where would you find the interpretation of results compared with previous research?",
      options: [
        "Abstract",
        "Methodology",
        "Discussion",
        "Introduction"
      ],
      correctAnswer: 2
    },
    {
      id: 91075,
      question: "Which section of a research publication describes the research design, methods, and materials used in the study?",
      options: [
        "Abstract",
        "Results",
        "Conclusion",
        "Methodology"
      ],
      correctAnswer: 3
    },
    {
      id: 91076,
      question: "Which section of a research publication lists all sources cited in the paper?",
      options: [
        "Discussion",
        "References",
        "Conclusion",
        "Introduction"
      ],
      correctAnswer: 1
    },
    {
      id: 91077,
      question: "What is correlation in statistical terms?",
      options: [
        "A method to assign participants randomly to experimental and control groups",
        "The measure of how well a sample represents the broader population from which it was drawn",
        "A statistical technique showing whether and how strongly pairs of variables are related, expressed as a coefficient ranging from -1.0 to +1.0",
        "A test used to determine whether a p-value is statistically significant or due to random chance"
      ],
      correctAnswer: 2
    },
    {
      id: 91078,
      question: "If a correlation coefficient (r) is close to 0, what does this indicate?",
      options: [
        "There is a strong positive relationship between the two variables being studied",
        "There is a strong negative (inverse) relationship between the two variables",
        "The result is statistically significant and clinically meaningful",
        "There is little to no relationship between the two variables being studied"
      ],
      correctAnswer: 3
    },
    {
      id: 91079,
      question: "Which of the following best describes an ecological study in epidemiological research?",
      options: [
        "A study that follows a group of exposed individuals over time to measure incidence of disease",
        "A descriptive observational study that analyzes data at the population or group level rather than individual level",
        "An experimental study that assigns communities to different interventions and measures outcomes",
        "A study design where participants are selected based on whether they already have the disease"
      ],
      correctAnswer: 1
    },
    {
      id: 91080,
      question: "In a randomized controlled trial, the control group typically receives:",
      options: [
        "The same intervention as the experimental group but administered by a different researcher",
        "A higher dose of the experimental treatment to compare dose-response relationships",
        "A placebo or no intervention, allowing researchers to compare outcomes with the experimental group",
        "A previously approved standard treatment regardless of the study's research question"
      ],
      correctAnswer: 2
    },
    {
      id: 91081,
      question: "Which of the following is a characteristic advantage of cross-sectional studies?",
      options: [
        "They can establish causation between exposure and outcome more reliably than cohort studies",
        "They require long follow-up periods, making them more thorough than other study designs",
        "They are cheap and quick to conduct and can identify multiple outcomes and exposures simultaneously",
        "They eliminate the possibility of recall bias since data is collected at a single point in time"
      ],
      correctAnswer: 2
    },
    {
      id: 91082,
      question: "Epidemiology answers questions about how common a disease is, who is affected, when it occurs, and where it occurs.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91083,
      question: "Incidence measures the total number of existing cases of a disease present in a population at a given time, while prevalence measures only new cases.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91084,
      question: "In the hierarchy of evidence, randomized controlled trials provide stronger evidence and less bias than cross-sectional studies.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91085,
      question: "A p-value greater than 0.05 is typically considered statistically significant in health research.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91086,
      question: "Research ethics require that all human participants provide voluntary, informed consent and that their confidentiality be protected before, during, and after a study.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
  ],
  "2. Research and Design Studies (Part 2)": [
    {
      id: 91087,
      question: "Before reading a clinical research paper, which of the following elements should you note first?",
      options: [
        "The statistical methods used in the study",
        "The publication, title, authors, and date",
        "The conclusions drawn by the researchers",
        "The data collection instruments described"
      ],
      correctAnswer: 1
    },
    {
      id: 91088,
      question: "What does the Introduction of a clinical research paper primarily convey?",
      options: [
        "A comprehensive breakdown of every result found in the study",
        "A summary of limitations discovered after the study was completed",
        "A description of data collection timing and instrument reliability",
        "The purpose of the study and why it contributes to scientific knowledge"
      ],
      correctAnswer: 3
    },
    {
      id: 91089,
      question: "Which section of a clinical research paper first appears and provides the reader with an overview before they read the full paper?",
      options: [
        "Discussion",
        "Introduction",
        "Abstract",
        "Materials and Methods"
      ],
      correctAnswer: 2
    },
    {
      id: 91090,
      question: "In the context of clinical research, \"Treatment\" refers to which of the following?",
      options: [
        "The clinical procedures and/or test materials administered to subjects",
        "The criteria used to determine whether a study endpoint was reached",
        "The final conclusions drawn from the statistical analysis",
        "The process by which subjects are randomly assigned to groups"
      ],
      correctAnswer: 0
    },
    {
      id: 91091,
      question: "Which study design involves subjects receiving their respective treatments simultaneously without switching?",
      options: [
        "Parallel design",
        "Split-mouth design",
        "Stratified randomization",
        "Crossover design"
      ],
      correctAnswer: 0
    },
    {
      id: 91092,
      question: "In a crossover study design, what happens after the initial treatment phase?",
      options: [
        "The study endpoint is measured and the study concludes immediately",
        "Subjects are re-randomized into entirely new treatment groups",
        "A washout period occurs and then groups switch treatments",
        "All subjects are given the placebo treatment permanently"
      ],
      correctAnswer: 2
    },
    {
      id: 91093,
      question: "The split-mouth design is described as a dental-specific study design. How is each subject's mouth organized within this design?",
      options: [
        "Only one quadrant is treated while the remaining three serve as controls",
        "The mouth is divided into units, and each subject receives all treatments",
        "Subjects are grouped by dental arch, upper versus lower teeth",
        "One side receives the placebo and the other side receives no intervention"
      ],
      correctAnswer: 1
    },
    {
      id: 91094,
      question: "Which of the following best describes a Placebo Control Group in a clinical study?",
      options: [
        "Subjects who receive the treatment currently under investigation",
        "Subjects who receive a treatment known to produce a positive result",
        "Subjects who receive an inert treatment with no active ingredients",
        "Subjects who are excluded from the study due to screening criteria"
      ],
      correctAnswer: 2
    },
    {
      id: 91095,
      question: "What is the role of a Positive Control Group in a clinical study?",
      options: [
        "To receive a treatment already known to yield a positive result",
        "To receive no treatment at all during the study period",
        "To test a new experimental compound not yet studied",
        "To receive the same inert treatment as the placebo group"
      ],
      correctAnswer: 0
    },
    {
      id: 91096,
      question: "Why do researchers randomly divide research subjects into treatment groups before administering treatments?",
      options: [
        "To ensure each group has an equal number of male and female subjects",
        "To make certain that the grouping itself is not the cause of observed results",
        "To simplify the statistical analysis performed at the end of the study",
        "To allow subjects to choose the treatment they are most comfortable with"
      ],
      correctAnswer: 1
    },
    {
      id: 91097,
      question: "In Simple Randomization, how are research subjects assigned to treatment groups?",
      options: [
        "Subjects self-select into groups based on their treatment preference",
        "They are first stratified by demographic characteristics, then randomized",
        "Researchers randomly assign each subject to a group without prior stratification",
        "They are assigned based on their geographic location or clinic of origin"
      ],
      correctAnswer: 2
    },
    {
      id: 91098,
      question: "How does Stratified Randomization differ from Simple Randomization?",
      options: [
        "Subjects are first divided by characteristics such as gender before being randomized",
        "It does not use random assignment; researchers manually select subjects",
        "Subjects are randomly assigned without any consideration of their characteristics",
        "Only one stratum is used and all subjects are assigned to a single group"
      ],
      correctAnswer: 0
    },
    {
      id: 91099,
      question: "Blinding in clinical research is best described as a technique used to minimize what?",
      options: [
        "The time required to complete data collection during a clinical trial",
        "The impact of psychological bias on study results",
        "The cost associated with administering multiple treatments simultaneously",
        "The number of subjects required to achieve statistical significance"
      ],
      correctAnswer: 1
    },
    {
      id: 91100,
      question: "In a Double Blind study, who is unaware of which treatment each subject receives?",
      options: [
        "Only the subject is unaware; the examiner knows the treatment allocation",
        "Neither the subject nor the examiner knows the treatment allocation",
        "Only the examiner is unaware; the subject knows their own treatment",
        "Both the subject and the sponsor are unaware, but the examiner knows"
      ],
      correctAnswer: 1
    },
    {
      id: 91101,
      question: "In an Open Label study, who is aware of which treatment each subject receives?",
      options: [
        "Both the subject and the examiner are aware of the treatment allocation",
        "Only an independent third-party reviewer is aware of the treatment allocation",
        "Neither the subject nor the examiner is aware of the treatment allocation",
        "Only the subject is aware; the examiner remains blinded throughout"
      ],
      correctAnswer: 0
    },
    {
      id: 91102,
      question: "Which of the following is a component of the Data Collection section that helps demonstrate reproducibility of results?",
      options: [
        "Description of the treatment dosage and frequency of administration",
        "The p-value threshold used to determine statistical significance",
        "Intra-rater and inter-rater reliability of data collection instruments",
        "The washout period duration between treatment phases"
      ],
      correctAnswer: 2
    },
    {
      id: 91103,
      question: "An \"endpoint\" in a clinical study is best defined as which of the following?",
      options: [
        "The criteria used to determine whether a treatment is effective",
        "The section of the paper where final conclusions are presented",
        "The final statistical technique applied to analyze collected data",
        "The last date on which data was collected from research subjects"
      ],
      correctAnswer: 0
    },
    {
      id: 91104,
      question: "In the presentation, which example was given to illustrate what an endpoint might look like?",
      options: [
        "Decrease in patient-reported pain following a periodontal scaling procedure",
        "Improvement in oral hygiene index scores following flossing instruction",
        "Reduction in plaque scores after using an experimental toothpaste",
        "Reduction in gingivitis when testing the effectiveness of an antimicrobial mouthrinse"
      ],
      correctAnswer: 3
    },
    {
      id: 91105,
      question: "The P-value in statistical design is used to assess which of the following?",
      options: [
        "Whether the sample size was large enough to detect treatment differences",
        "Whether the treatment group assignment was properly randomized",
        "Whether a result is statistically significant",
        "Whether the blinding procedure was successfully maintained throughout"
      ],
      correctAnswer: 2
    },
    {
      id: 91106,
      question: "If a study reports a p-value of 0.05, what does this mean regarding the probability that the treatment caused the observed results?",
      options: [
        "There is a 95% probability that the treatment was responsible for the observed results",
        "There is a 50% probability that observed results were due to chance alone",
        "There is a 5% probability that the treatment was responsible for the observed results",
        "There is a 95% probability that observed results were due to chance alone"
      ],
      correctAnswer: 0
    },
    {
      id: 91107,
      question: "According to the Sample Size Guide, which situation calls for a LARGE sample size?",
      options: [
        "A pilot study exploring a new treatment or research area",
        "Assessing rare occurrences in the general population",
        "Homogeneous populations with little variability relative to treatment",
        "Studies with very small expected differences between treatment groups"
      ],
      correctAnswer: 1
    },
    {
      id: 91108,
      question: "According to the Sample Size Guide, which situation is most appropriate for a SMALL sample size?",
      options: [
        "Heterogeneous populations with great variability or diversity",
        "Assessing for small differences between treatment groups",
        "Studies involving rare occurrences in a large population",
        "Pilot study exploring a new treatment or research area"
      ],
      correctAnswer: 3
    },
    {
      id: 91109,
      question: "After reading the Materials and Methods section, which of the following is a critical thinking question you should ask yourself?",
      options: [
        "What was the study design — parallel, crossover, double blind, or single blind?",
        "Are the references cited in the paper recent and up to date?",
        "Did the conclusion logically follow from the data presented in results?",
        "What research influenced the authors to engage in this described study?"
      ],
      correctAnswer: 0
    },
    {
      id: 91110,
      question: "What is the primary purpose of the Results section of a clinical research paper?",
      options: [
        "To describe the limitations of the study and suggest future research",
        "To interpret the data and relate it back to existing scientific knowledge",
        "To list the authors' recommendations for future clinical practice",
        "To summarize the study's findings without introducing data interpretations"
      ],
      correctAnswer: 3
    },
    {
      id: 91111,
      question: "After reading the Results section, which of the following is a key critical thinking question?",
      options: [
        "Are the references cited in the paper recent and up to date?",
        "Was a statistical method used to ensure an adequate sample size?",
        "Did the conclusion directly answer the research question posed?",
        "What research influenced the authors' decision to conduct the study?"
      ],
      correctAnswer: 1
    },
    {
      id: 91112,
      question: "What does the Discussion section of a clinical research paper primarily provide?",
      options: [
        "A complete list of all references consulted during the research process",
        "A description of the treatment groups and their assigned interventions",
        "A raw summary of data collected without any author commentary",
        "The authors' interpretation of study results and how they fit existing knowledge"
      ],
      correctAnswer: 3
    },
    {
      id: 91113,
      question: "Which of the following is something the Discussion section may address?",
      options: [
        "The demographic characteristics and screening criteria of the research subjects",
        "The frequency and dosage of the treatment administered to each group",
        "Limitations of the study and suggestions for topics of further research",
        "The timing and instruments used during the data collection phase"
      ],
      correctAnswer: 2
    },
    {
      id: 91114,
      question: "After reading the Discussion section, which critical thinking question is most relevant?",
      options: [
        "Was a statistical method used to ensure an adequate sample size?",
        "What limitations, if any, were described about the study?",
        "Are the references cited in the paper recent and up to date?",
        "What was the number of study subjects included in the research?"
      ],
      correctAnswer: 1
    },
    {
      id: 91115,
      question: "According to the presentation, the Conclusion section should be directly related to which of the following?",
      options: [
        "The statistical techniques selected to analyze the data collected",
        "The demographic characteristics of the subjects enrolled in the study",
        "The data collection methods and instruments used during the study",
        "The research question or hypothesis posed at the start of the study"
      ],
      correctAnswer: 3
    },
    {
      id: 91116,
      question: "After reading the Conclusion, which critical thinking question is most appropriate?",
      options: [
        "Are the references cited in the paper recent and up to date?",
        "What research influenced the authors to engage in this described study?",
        "Did the results support the conclusion drawn by the authors?",
        "Were the treatment group subjects properly screened and randomized?"
      ],
      correctAnswer: 2
    },
    {
      id: 91117,
      question: "What are the two main benefits of the References section described in the presentation?",
      options: [
        "Verifying author credentials and confirming journal publication standards",
        "Identifying conflicting studies and determining sample size appropriateness",
        "Evaluating the statistical methods and confirming the endpoint measures",
        "Looking up additional information and understanding the types of sources the author relies on most"
      ],
      correctAnswer: 3
    },
    {
      id: 91118,
      question: "When critically examining the References section, what key question should you ask?",
      options: [
        "Are the references recent and up to date?",
        "Did the authors use a double-blind or single-blind design?",
        "Were the data collection instruments valid and reliable?",
        "Did the conclusion directly answer the hypothesis?"
      ],
      correctAnswer: 0
    },
    {
      id: 91119,
      question: "According to the Professional Application section, why is the ability to critically read clinical papers important?",
      options: [
        "It qualifies clinicians to serve as examiners in future clinical research studies",
        "It allows clinicians to avoid reading papers they professionally disagree with",
        "It ensures clinicians can publish their own research in peer-reviewed journals",
        "It helps clinicians make evidence-based decisions and give patients the best care"
      ],
      correctAnswer: 3
    },
    {
      id: 91120,
      question: "The presentation advises that when product representatives visit clinicians, what should clinicians request?",
      options: [
        "A free sample of the product to test on patients in their practice",
        "A comparison of the product with all competitor products on the market",
        "References and data supporting product efficacy and safety",
        "Permission to independently conduct a trial with their own patients"
      ],
      correctAnswer: 2
    },
    {
      id: 91121,
      question: "According to the presentation's three-part framework, which of the following is NOT one of the three aspects of a clinical research paper to explore?",
      options: [
        "Critically Reading and Evaluating the Content",
        "The Funding Sources Behind the Research",
        "Professional Application of the Information",
        "The Context of a Clinical Research Paper"
      ],
      correctAnswer: 1
    },
    {
      id: 91122,
      question: "Which of the following best captures what the title of a clinical research paper is expected to do?",
      options: [
        "Summarize the main conclusion reached by the research team",
        "Indicate the journal in which the paper was published",
        "Describe the content of the paper clearly and succinctly",
        "List all of the authors who contributed to the paper"
      ],
      correctAnswer: 2
    },
    {
      id: 91123,
      question: "Which of the following is NOT listed as an element typically addressed in the Materials and Methods section?",
      options: [
        "Research subjects and sample size",
        "Treatment dosage and frequency",
        "Statistical design and data collection",
        "Authors' interpretation of the study findings"
      ],
      correctAnswer: 3
    },
    {
      id: 91124,
      question: "After reading the Introduction, which critical thinking question is most appropriate to ask?",
      options: [
        "What questions are the authors answering through the study?",
        "Were the subjects randomly assigned to treatment groups?",
        "Were the data collection instruments valid and reliable?",
        "Did the conclusion logically follow from the data presented?"
      ],
      correctAnswer: 0
    },
    {
      id: 91125,
      question: "Which of the following best describes what the Conclusion section should NOT do?",
      options: [
        "Be supported by data presented and analyzed in the Results and Discussion",
        "Address the research question or hypothesis posed by the authors",
        "Provide conclusions that logically follow from data in the Results section",
        "Introduce findings or interpretations that are unsupported by study data"
      ],
      correctAnswer: 3
    },
    {
      id: 91126,
      question: "Which section of the Materials and Methods describes the demographic characteristics of subjects, sample size, and screening criteria?",
      options: [
        "Research Subjects",
        "Study Design",
        "Statistical Design",
        "Treatment Group Assignment"
      ],
      correctAnswer: 0
    },
    {
      id: 91127,
      question: "The Abstract section of a clinical research paper provides the authors' detailed interpretation of the study results.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91128,
      question: "In a Crossover study design, after the washout period, each group of subjects switches to the opposite treatment.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91129,
      question: "A Positive Control Group is subjected to an inert treatment with no active ingredients.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91130,
      question: "In a Double Blind study, both the subject and the examiner are unaware of which treatment each subject receives.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91131,
      question: "The Results section of a clinical research paper is where the authors provide their interpretation of the data collected.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91132,
      question: "A p-value of 0.05 means there is a 5% probability that the observed results were due to chance.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
  ],
  "3. Determinants of Health (Part 1)": [
    {
      id: 91133,
      question: "Which broad category of health determinants refers to the personal actions individuals take that influence their own health?",
      options: [
        "Individual behavior",
        "Health services",
        "Biology and genetics",
        "Social determinants"
      ],
      correctAnswer: 0
    },
    {
      id: 91134,
      question: "According to the Canadian Medical Association, what percentage of health outcomes is attributed to \"Your Life\" (social determinants)?",
      options: [
        "10%",
        "25%",
        "15%",
        "50%"
      ],
      correctAnswer: 3
    },
    {
      id: 91135,
      question: "Which of the following is an example of a health services determinant of health?",
      options: [
        "A family history of cleft palate affecting tooth development",
        "Availability of oral health workforce in rural communities",
        "Choosing to quit smoking to reduce periodontal disease risk",
        "Concentrated poverty limiting access to nutritious food"
      ],
      correctAnswer: 1
    },
    {
      id: 91136,
      question: "Which term refers to the economic and sociological combined total measure of a person's work experience and social position based on income, education, and occupation?",
      options: [
        "Health disparity index",
        "Social exclusion measure",
        "Socioeconomic status (SES)",
        "Community health quotient"
      ],
      correctAnswer: 2
    },
    {
      id: 91137,
      question: "Health disparities are defined as preventable differences in the burden of disease or opportunities to achieve optimal health. Which populations are most affected?",
      options: [
        "Populations with high income and advanced levels of education",
        "Socially disadvantaged populations defined by race, income, geography, or other factors",
        "Individuals living in metropolitan areas with full dental coverage",
        "Populations with access to multiple healthcare providers and specialists"
      ],
      correctAnswer: 1
    },
    {
      id: 91138,
      question: "What is the definition of health equity as described in the lecture?",
      options: [
        "Providing identical healthcare resources to every person in society regardless of need",
        "Every person having the opportunity to attain full health potential without social disadvantage",
        "Measuring health outcomes using standardized national benchmarks",
        "Eliminating all chronic diseases through government policy initiatives"
      ],
      correctAnswer: 1
    },
    {
      id: 91139,
      question: "According to the Canadian Medical Association framework, what percentage of health is attributed to \"Your Biology\" (biology and genetics)?",
      options: [
        "15%",
        "25%",
        "10%",
        "50%"
      ],
      correctAnswer: 0
    },
    {
      id: 91140,
      question: "Which of the following is classified as a physical social determinant of health?",
      options: [
        "Concentrated poverty in a neighbourhood limiting healthcare access",
        "Quality of schools and educational institutions in a community",
        "Familial transmission of caries-associated bacteria between family members",
        "Ramps and sidewalk cuts for individuals with physical disabilities"
      ],
      correctAnswer: 3
    },
    {
      id: 91141,
      question: "The common risk factor approach in dentistry is based on which core concept?",
      options: [
        "Dental diseases are exclusively caused by poor individual oral hygiene habits",
        "Oral diseases require entirely separate treatment strategies from systemic diseases",
        "Interprofessional collaboration is only needed in hospital-based dental settings",
        "Dental diseases share risk factors with other systemic diseases such as CVD and obesity"
      ],
      correctAnswer: 3
    },
    {
      id: 91142,
      question: "Which of the following is an example of a biology and genetics determinant specifically relevant to oral health?",
      options: [
        "Transportation options to reach dental clinics in remote areas",
        "Dental insurance coverage and reimbursement rates for procedures",
        "Congenitally missing teeth or cleft lip and palate as inherited conditions",
        "Changing one's diet to reduce the risk of developing dental caries"
      ],
      correctAnswer: 2
    },
    {
      id: 91143,
      question: "In the \"Equality vs. Equity\" concept, what does equity mean in the context of healthcare?",
      options: [
        "Giving all patients the same number of appointments regardless of their need",
        "Providing disadvantaged individuals with additional support to achieve equal outcomes",
        "Treating all patients with identical clinical procedures and materials used",
        "Distributing healthcare funding equally across all geographic regions"
      ],
      correctAnswer: 1
    },
    {
      id: 91144,
      question: "Which of the following groups is listed as a marginalized or vulnerable population in Canada?",
      options: [
        "Middle-class urban professionals with employer health benefits plans",
        "University-educated individuals working in regulated industries full-time",
        "First Nations/Indigenous peoples, refugees, and low-income/working poor",
        "Individuals living in metropolitan areas with comprehensive dental coverage"
      ],
      correctAnswer: 2
    },
    {
      id: 91145,
      question: "According to the social determinants of health definition, health-affecting circumstances are shaped by:",
      options: [
        "Individual lifestyle choices and personal motivation to stay healthy",
        "Random genetic variation occurring across different population groups",
        "Access to private health insurance and employer wellness programs",
        "The distribution of money, power, and resources at global, national, and local levels"
      ],
      correctAnswer: 3
    },
    {
      id: 91146,
      question: "Which of the following initiatives is described in the lecture as addressing social determinants of health?",
      options: [
        "Raising minimum wage to improve financial security for low-income workers",
        "Expanding dental school curricula to include more clinical practice hours",
        "Increasing the number of dental hygienists working in urban city centres",
        "Introducing community water fluoridation programs in rural municipalities"
      ],
      correctAnswer: 0
    },
    {
      id: 91147,
      question: "In the type 2 diabetes example, which factor represents a social determinant influencing the patient's health risk?",
      options: [
        "His genetic predisposition to type 2 diabetes inherited from family members",
        "His heavy carbohydrate diet as a result of personal food preferences made",
        "His working and living environment that promotes a sedentary lifestyle",
        "His age and biological sex as non-modifiable intrinsic risk factors"
      ],
      correctAnswer: 2
    },
    {
      id: 91148,
      question: "According to the Canadian Medical Association framework, what percentage of health is attributed to \"Your Environment\" (air quality and civic infrastructure)?",
      options: [
        "25%",
        "15%",
        "20%",
        "10%"
      ],
      correctAnswer: 3
    },
    {
      id: 91149,
      question: "Which of the following best describes what \"determinants of health\" means?",
      options: [
        "The range of personal, social, economic, and environmental factors that influence health status",
        "Clinical diagnoses used to predict a patient's future disease burden over time",
        "A list of modifiable risk factors targeted by individual behaviour change programs",
        "Biological markers measured in laboratory tests to assess a patient's outcomes"
      ],
      correctAnswer: 0
    },
    {
      id: 91150,
      question: "Practicing adequate oral hygiene is listed under which category of health determinants?",
      options: [
        "Social determinants related to community and environmental conditions",
        "Biology and genetics including inherited predispositions to disease",
        "Individual behavior involving personal actions that influence health",
        "Health services including access and quality of available care"
      ],
      correctAnswer: 2
    },
    {
      id: 91151,
      question: "Which risk factors are shared between dental diseases and cardiovascular disease (CVD), as highlighted by the common risk factor approach?",
      options: [
        "Fluoride exposure, water quality, and levels of air pollution",
        "Sugary foods, smoking, and stress affecting multiple body systems",
        "Genetic mutations, immune deficiencies, and developmental birth defects",
        "Income level, housing instability, and social exclusion from services"
      ],
      correctAnswer: 1
    },
    {
      id: 91152,
      question: "The lecture states that health disparities are directly related to which underlying cause?",
      options: [
        "The historical and current unequal distribution of social, political, economic, and environmental resources",
        "Insufficient individual motivation to adopt healthy personal behaviours consistently",
        "Lack of personal responsibility for managing and preventing chronic disease",
        "Geographic isolation that prevents individuals from accessing advanced medical technology"
      ],
      correctAnswer: 0
    },
    {
      id: 91153,
      question: "Health disparities are unavoidable differences in disease burden that cannot be prevented by social or policy changes.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91154,
      question: "The Canadian Medical Association identifies \"Your Life\" (social determinants) as the largest single contributor to health outcomes, accounting for 50% of health.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91155,
      question: "The common risk factor approach proposes that dental diseases and systemic diseases such as cardiovascular disease share common risk factors, making an interprofessional approach most effective.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91156,
      question: "Health equity means providing exactly the same resources to every individual in a society, regardless of their level of need or disadvantage.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91157,
      question: "According to the Canadian Medical Association, biology and genetics account for a larger share of health outcomes than social determinants.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91158,
      question: "Socioeconomic status (SES) is measured using a combination of income, education, and occupation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91159,
      question: "Indigenous peoples in Canada are identified in this lecture as one of the marginalized or vulnerable populations who may experience worse health outcomes due to historical and ongoing social determinants.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "3. Determinants of Health (Part 2)": [
    {
      id: 91160,
      question: "According to the paper, social determinants of health for Aboriginal peoples are categorized into which three levels?",
      options: [
        "Proximal, intermediate, and distal levels of determinants",
        "Biological, behavioral, and environmental levels of influence",
        "Individual, community, and national levels of policy impact",
        "Physical, mental, and spiritual dimensions of wellbeing"
      ],
      correctAnswer: 0
    },
    {
      id: 91161,
      question: "What does the Community Well-Being (CWB) index measure to assess community health?",
      options: [
        "Physical fitness, mental health, spiritual wellbeing, and cultural retention rates",
        "Access to healthcare, clean water, nutritious food, and transportation systems",
        "Rates of disease, disability, violence, and early death in a community",
        "Income, education, housing quantity and quality, and labour force characteristics"
      ],
      correctAnswer: 3
    },
    {
      id: 91162,
      question: "According to Table 1, which community type had the lowest Community Well-Being score in 2001?",
      options: [
        "Inuit communities, with a score of 0.63 in the 2001 index",
        "Other Canadian communities, with a score of 0.77 in the 2001 index",
        "Métis communities, with a score of 0.58 in the 2001 index",
        "First Nations communities, with a score of 0.66 in the 2001 index"
      ],
      correctAnswer: 3
    },
    {
      id: 91163,
      question: "According to Table 2, how does the daily smoking rate of First Nation adults on reserve compare to non-Aboriginal adults in Canada?",
      options: [
        "First Nation adults smoke at a rate more than twice that of non-Aboriginal adults",
        "First Nation adults smoke at a rate approximately equal to that of non-Aboriginal adults",
        "First Nation adults smoke at a rate about 25% higher than non-Aboriginal adults",
        "First Nation adults smoke at a rate about 50% higher than non-Aboriginal adults"
      ],
      correctAnswer: 0
    },
    {
      id: 91164,
      question: "What does Table 3 show about smoking rates among First Nation mothers on reserve during pregnancy?",
      options: [
        "First Nation mothers: 36.6%; all Canadian mothers: 19.4% smoked during pregnancy",
        "First Nation mothers: 19.4%; all Canadian mothers: 36.6% smoked during pregnancy",
        "First Nation mothers: 32.2%; all Canadian mothers: 15.0% smoked during pregnancy",
        "First Nation mothers: 15.0%; all Canadian mothers: 32.2% smoked during pregnancy"
      ],
      correctAnswer: 0
    },
    {
      id: 91165,
      question: "According to Table 5, what percentage of on-reserve dwellings required major repairs compared to Canadian dwellings overall?",
      options: [
        "On reserve: 31.7%; Canadian overall: 26.9% needed major repairs",
        "On reserve: 24.0%; Canadian overall: 65.6% needed major repairs",
        "On reserve: 33.6%; Canadian overall: 7.5% needed major repairs",
        "On reserve: 7.5%; Canadian overall: 33.6% needed major repairs"
      ],
      correctAnswer: 2
    },
    {
      id: 91166,
      question: "According to Table 6, which Aboriginal group is most likely to live in crowded housing conditions in Canada?",
      options: [
        "Inuit people, who are 10 times more likely than non-Aboriginal Canadians to be in crowded housing",
        "Off-reserve Aboriginal people, who face the greatest crowding compared to non-Aboriginal Canadians",
        "First Nations people, who are 10 times more likely than non-Aboriginal Canadians to be in crowded housing",
        "Métis people, who are 10 times more likely than non-Aboriginal Canadians to be in crowded housing"
      ],
      correctAnswer: 0
    },
    {
      id: 91167,
      question: "What health outcomes has crowded housing been specifically linked to, according to the paper?",
      options: [
        "Diabetes, cardiovascular disease, obesity, and reduced life expectancy in communities",
        "Infectious disease transmission, respiratory infections, injuries, mental health problems, and family tensions",
        "Dental caries, periodontal disease, oral cancer, and cleft palate in Aboriginal populations",
        "Asthma, chronic ear infections, learning disabilities, and allergies exclusively in children"
      ],
      correctAnswer: 1
    },
    {
      id: 91168,
      question: "According to Table 7, what was the unemployment rate for Aboriginal people compared to non-Aboriginal people in Canada in 2001?",
      options: [
        "Aboriginal: 14.0%; non-Aboriginal: 7.1%, a two-fold difference in unemployment rates",
        "Aboriginal: 19.1%; non-Aboriginal: 7.1%, meaning Aboriginal unemployment was nearly three times higher",
        "Aboriginal: 22.2%; non-Aboriginal: 14.0%, reflecting inequalities in labour force participation",
        "Aboriginal: 7.1%; non-Aboriginal: 19.1%, with non-Aboriginal rates being higher overall"
      ],
      correctAnswer: 1
    },
    {
      id: 91169,
      question: "According to Table 8, what was the median total income for North American Indians compared to non-Aboriginal Canadians in 2000?",
      options: [
        "North American Indian: $12,263; non-Aboriginal: $22,431, roughly half the non-Aboriginal median",
        "North American Indian: $22,431; non-Aboriginal: $33,416, a significant but smaller income gap",
        "North American Indian: $13,525; non-Aboriginal: $43,486, a gap of over $30,000 in income",
        "North American Indian: $16,342; non-Aboriginal: $34,778, representing a two-fold difference"
      ],
      correctAnswer: 0
    },
    {
      id: 91170,
      question: "What does Table 9 reveal about self-reported fair or poor health at low income levels for Aboriginal and non-Aboriginal Canadians?",
      options: [
        "Aboriginal: 26%; non-Aboriginal: 16%, with the gap disappearing at the lowest income level",
        "Aboriginal: 34%; non-Aboriginal: 25%, with the gap remaining significant across all income levels",
        "Aboriginal: 14%; non-Aboriginal: 9%, showing higher rates for both groups at high income levels",
        "Aboriginal: 25%; non-Aboriginal: 34%, showing Aboriginal people report better health at low income"
      ],
      correctAnswer: 1
    },
    {
      id: 91171,
      question: "What does the paper identify as the approximate percentage of Aboriginal youth who drop out of high school?",
      options: [
        "75% of Aboriginal youth drop out or are pushed out of high school across Canada",
        "50% of Aboriginal youth drop out or are pushed out of high school across Canada",
        "25% of Aboriginal youth drop out or are pushed out of high school across Canada",
        "35% of Aboriginal youth drop out or are pushed out of high school across Canada"
      ],
      correctAnswer: 1
    },
    {
      id: 91172,
      question: "According to Table 12, how did food insecurity rates compare between Aboriginal off-reserve people and all Canadians in 1998-99?",
      options: [
        "Aboriginal off-reserve: 10%; all Canadians: 27%, meaning Canadians had higher food insecurity",
        "Aboriginal off-reserve: 58%; all Canadians: 35%, with social assistance households being highest",
        "Aboriginal off-reserve: 35%; all Canadians: 10%, reflecting low income effects on food access",
        "Aboriginal off-reserve: 27%; all Canadians: 10%, meaning Aboriginal people were nearly three times more affected"
      ],
      correctAnswer: 3
    },
    {
      id: 91173,
      question: "Which of the following is listed as a barrier to accessing health services for First Nation adults living on reserve, according to Table 14?",
      options: [
        "Lack of interest in preventive care and general reluctance to seek professional medical help",
        "Shortage of traditional healers and lack of awareness about available healthcare resources",
        "Waiting lists too long, services not available in the area, and inability to afford transport costs",
        "Distance from urban centres, language barriers, and low health literacy across communities"
      ],
      correctAnswer: 2
    },
    {
      id: 91174,
      question: "How does the paper describe intermediate determinants in relation to proximal determinants of health?",
      options: [
        "Intermediate determinants are biological factors that strengthen or reinforce proximal determinants",
        "Intermediate determinants are the origin of proximal determinants, such as poverty rooted in lack of community infrastructure",
        "Intermediate determinants directly cause disease while proximal determinants shape community wellbeing",
        "Intermediate determinants are individual-level factors that develop before proximal determinants"
      ],
      correctAnswer: 1
    },
    {
      id: 91175,
      question: "What did Chandler and Lalonde's landmark 1998 study find about cultural continuity among First Nations in British Columbia?",
      options: [
        "Cultural continuity was unrelated to health outcomes but strongly correlated with educational attainment",
        "Cultural continuity, including land title and self-government, was associated with lower rates of suicide",
        "Cultural continuity reduced chronic disease rates but had no measurable effect on mental health outcomes",
        "Cultural continuity improved access to healthcare and reduced systemic barriers to treatment"
      ],
      correctAnswer: 1
    },
    {
      id: 91176,
      question: "According to the paper, which determinant is cited as the most important determinant of health among Aboriginal peoples?",
      options: [
        "Self-determination, which influences all other determinants including education and housing",
        "Access to culturally appropriate healthcare systems within Aboriginal communities",
        "Education and literacy as the foundation for employment and income security",
        "Adequate housing and safe physical environments for all community members"
      ],
      correctAnswer: 0
    },
    {
      id: 91177,
      question: "According to Table 20, what was the most frequently mentioned element of residential school experiences contributing to negative health impacts among survivors?",
      options: [
        "Physical abuse, reported by 69.2% of residential school survivors in the survey",
        "Loss of language, reported by 71.1% of residential school survivors in the survey",
        "Isolation from family, reported by 81.3% of residential school survivors in the survey",
        "Harsh discipline, reported by 78.0% of residential school survivors in the survey"
      ],
      correctAnswer: 2
    },
    {
      id: 91178,
      question: "According to Table 21, what percentage of First Nation adults on reserve reported experiencing racism in the 12 months prior to the survey?",
      options: [
        "Approximately 37.9% reported experiencing racism in the prior 12 months",
        "Approximately 48.4% reported experiencing racism, with no effect on self-esteem reported",
        "Approximately 18.9% reported experiencing racism with some effect on their self-esteem",
        "Approximately 27.0% reported experiencing racism with a strong effect on their self-esteem"
      ],
      correctAnswer: 0
    },
    {
      id: 91179,
      question: "What is the Integrated Life Course and Social Determinants Model of Aboriginal Health (ILCSDAH)?",
      options: [
        "A government policy framework allocating funding for Aboriginal health based on life stage needs",
        "A clinical model integrating Western medicine with traditional Aboriginal healing practices together",
        "A conceptual model using nested spheres to depict life stages, socio-political contexts, and determinants of health",
        "A statistical tool developed to measure Aboriginal health outcomes against national population benchmarks"
      ],
      correctAnswer: 2
    },
    {
      id: 91180,
      question: "According to the paper, what percentage of the Aboriginal population is under the age of 25?",
      options: [
        "Almost 75% of the Aboriginal population is under the age of 25 in Canada",
        "Almost 60% of the Aboriginal population is under the age of 25 in Canada",
        "Almost 50% of the Aboriginal population is under the age of 25 in Canada",
        "Almost 40% of the Aboriginal population is under the age of 25 in Canada"
      ],
      correctAnswer: 1
    },
    {
      id: 91181,
      question: "According to Table 16, what was the overall percentage of First Nations people with knowledge of an Aboriginal language in 2006?",
      options: [
        "Approximately 44% of First Nations people had knowledge of an Aboriginal language in 2006",
        "Approximately 50% of First Nations people had knowledge of an Aboriginal language in 2006",
        "Approximately 12% of First Nations people had knowledge of an Aboriginal language in 2006",
        "Approximately 29% of First Nations people had knowledge of an Aboriginal language in 2006"
      ],
      correctAnswer: 3
    },
    {
      id: 91182,
      question: "According to Table 25, which long-term health condition is most disproportionately prevalent among First Nation adults on reserve compared to other Canadian adults?",
      options: [
        "Arthritis or rheumatism, at 25.3% in First Nations versus 19.1% in other Canadian adults",
        "High blood pressure, at 20.4% in First Nations versus 16.4% in other Canadian adults",
        "Diabetes, at 19.7% in First Nations versus 5.2% in other Canadian adults, nearly four times higher",
        "Chronic back pain, at 16.7% in First Nations versus 21.4% in other Canadian adults overall"
      ],
      correctAnswer: 2
    },
    {
      id: 91183,
      question: "How does the paper describe colonialism's role as a distal determinant of health?",
      options: [
        "Colonialism affects health only through psychological trauma and has no measurable economic impact",
        "Colonialism directly causes disease but does not substantially influence social or economic determinants",
        "Colonialism creates social inequalities that trickle down to construct unfavourable intermediate and proximal determinants",
        "Colonialism affects health exclusively through loss of language and the disruption of cultural practices"
      ],
      correctAnswer: 2
    },
    {
      id: 91184,
      question: "According to the paper, what is the holistic concept of health embraced by Indigenous peoples?",
      options: [
        "A biomedical model that focuses on physical wellbeing and the absence of diagnosed disease",
        "A community-centred model that prioritizes collective wellbeing over individual health outcomes",
        "A preventive model that emphasizes lifestyle choices as the primary determinant of good health",
        "A model encompassing physical, spiritual, emotional, and mental dimensions and their interrelatedness"
      ],
      correctAnswer: 3
    },
    {
      id: 91185,
      question: "According to the paper's discussion of educational systems, what type of program has demonstrated the most favourable return on investment among Aboriginal children?",
      options: [
        "High school retention programs that incorporate Indigenous cultural content into standard curricula",
        "Post-secondary scholarship programs that increase Aboriginal university enrollment and completion",
        "Community mentorship programs that connect Aboriginal youth with professional role models",
        "Preschool programs that support early childhood development among Aboriginal children"
      ],
      correctAnswer: 3
    },
    {
      id: 91186,
      question: "According to the paper, the unemployment rate for Aboriginal people in Canada is approximately two to three times higher than for non-Aboriginal Canadians.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91187,
      question: "The paper states that approximately 50% of Aboriginal youth drop out or are pushed out of high school, leading to diminished literacy, employment, and increased poverty.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91188,
      question: "According to Table 6, Métis people in Canada are as likely as Inuit people to live in crowded housing conditions.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91189,
      question: "The paper identifies self-determination as the least important determinant of health among Aboriginal peoples.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91190,
      question: "Chandler and Lalonde's 1998 study found that cultural continuity — including land title and self-government — was associated with lower rates of suicide among First Nations in British Columbia.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "4. Dental Indices (Part 1)": [
    {
      id: 91191,
      question: "Which of the following best describes the purpose of the \"Assessment\" core function in public health?",
      options: [
        "Identifying community health needs through one-time or continuous data collection",
        "Developing laws and regulations to improve community health outcomes",
        "Ensuring that services are provided to meet community health goals",
        "Funding healthcare programs for underserved populations"
      ],
      correctAnswer: 0
    },
    {
      id: 91192,
      question: "What is a surveillance system in the context of public health?",
      options: [
        "A periodic survey tool used by dental hygienists to screen elementary school children",
        "A method of comparing individual patient outcomes across different dental offices",
        "A database used exclusively by governments to record dental treatment outcomes",
        "Functional capacity for data collection, analysis, and dissemination linked to public health programs"
      ],
      correctAnswer: 3
    },
    {
      id: 91193,
      question: "Which of the following correctly lists the three core functions of public health?",
      options: [
        "Prevention, education, and policy enforcement",
        "Assessment, policy development, and assurance",
        "Monitoring, evaluation, and program implementation",
        "Assessment, surveillance, and treatment"
      ],
      correctAnswer: 1
    },
    {
      id: 91194,
      question: "Which of the following is an example of a continuous assessment in public health surveillance?",
      options: [
        "Conducting a national oral health survey every ten years across provinces",
        "Distributing mailed questionnaires to households in a specific region",
        "Monitoring hospital admissions for a specific disease on an ongoing basis",
        "Performing a one-time cross-sectional study of caries prevalence in children"
      ],
      correctAnswer: 2
    },
    {
      id: 91195,
      question: "What is the primary purpose of measuring and monitoring dental diseases at a population level?",
      options: [
        "To replace clinical examinations with survey data for individual patients",
        "To train dental hygienists in new clinical techniques and procedures",
        "To reduce the number of dental practitioners needed in underserved regions",
        "To identify community needs, track disease trends, and evaluate program impacts"
      ],
      correctAnswer: 3
    },
    {
      id: 91196,
      question: "Which data collection method involves analyzing existing patient records rather than conducting new examinations?",
      options: [
        "Health record survey",
        "Health examination survey",
        "Questionnaire survey",
        "Health interview survey"
      ],
      correctAnswer: 0
    },
    {
      id: 91197,
      question: "Administrative data collected in Canada is primarily used for which of the following purposes?",
      options: [
        "Providing statistical analysis of individual treatment outcomes for dental practices",
        "Recording registrations, transactions, and evaluating program administration outputs",
        "Replacing clinical oral health examinations in national health studies",
        "Tracking dental hygienist performance across provincial health authorities"
      ],
      correctAnswer: 1
    },
    {
      id: 91198,
      question: "Why is observation alone considered insufficient for building medical and health science evidence?",
      options: [
        "Observations are too time-consuming to be practical in clinical settings",
        "Observations rely on patient self-reporting and are therefore unreliable",
        "Observations must be transformed into precise, reproducible measurements to generate valid evidence",
        "Observations are only valid when conducted by licensed dentists rather than hygienists"
      ],
      correctAnswer: 2
    },
    {
      id: 91199,
      question: "Which two qualities must the process of measurement satisfy to be considered scientifically sound?",
      options: [
        "Judgability (adequate and appropriate) and reproducibility (can be repeated)",
        "Simplicity of the scoring criteria and broad geographic application",
        "Acceptance by regulatory bodies and peer-reviewed publication",
        "Speed and affordability of the measurement process"
      ],
      correctAnswer: 0
    },
    {
      id: 91200,
      question: "What is a dental index?",
      options: [
        "An expression of clinical observation in numeric values used to describe the status of an individual or group",
        "A written description of a patient's oral health used to guide treatment planning",
        "A photographic record of clinical conditions used in epidemiological studies",
        "A standardized form used by dental hygienists to report treatment outcomes"
      ],
      correctAnswer: 0
    },
    {
      id: 91201,
      question: "Which of the following is a key advantage of using a dental index over descriptive language?",
      options: [
        "Indices allow clinicians to skip the need for a clinical examination entirely",
        "Indices provide more consistency and less subjectivity when describing conditions",
        "Indices eliminate the need for calibration between examiners",
        "Indices are legally required for all public health reporting in Canada"
      ],
      correctAnswer: 1
    },
    {
      id: 91202,
      question: "A reversible index differs from an irreversible index in which of the following ways?",
      options: [
        "A reversible index measures permanent structural damage, while irreversible measures inflammation",
        "A reversible index is used for caries only, while an irreversible index is used for periodontal disease",
        "A reversible index score can change over time, while an irreversible index score cannot decrease",
        "A reversible index requires probing, while an irreversible index relies on radiographic data"
      ],
      correctAnswer: 2
    },
    {
      id: 91203,
      question: "Which classification of dental indices is based on the extent to which areas of the oral cavity are assessed?",
      options: [
        "Reversible versus irreversible indices",
        "Disease versus treatment indices",
        "Primary versus secondary surveillance indices",
        "Simplified versus full mouth indices"
      ],
      correctAnswer: 3
    },
    {
      id: 91204,
      question: "Which of the following is an example of a \"treatment\" index based on the entity measured classification?",
      options: [
        "The gingival or sulcular bleeding index",
        "The D component of the DMFT index",
        "The OHI-S plaque debris index",
        "The F (filled) component of the DMFT index"
      ],
      correctAnswer: 3
    },
    {
      id: 91205,
      question: "Which characteristic of an ideal index refers to its ability to measure what it is actually intended to measure?",
      options: [
        "Reliability",
        "Sensitivity",
        "Utility",
        "Validity"
      ],
      correctAnswer: 3
    },
    {
      id: 91206,
      question: "Which characteristic of an ideal index describes the ability to measure consistently at different times and under different conditions?",
      options: [
        "Validity",
        "Acceptability",
        "Reliability",
        "Clinical significance"
      ],
      correctAnswer: 2
    },
    {
      id: 91207,
      question: "Which characteristic of an ideal index refers to it being easy and simple to conduct in field settings?",
      options: [
        "Sensitivity",
        "Utility",
        "Quantifiability",
        "Acceptability"
      ],
      correctAnswer: 1
    },
    {
      id: 91208,
      question: "An index that is \"accurate but unreliable\" is best described as which of the following?",
      options: [
        "The ideal scenario where measurements are both consistent and correct",
        "A tool that measures correctly but does not provide consistent results over time or with different examiners",
        "A tool that provides consistent results but does not measure the correct value",
        "A tool that provides both inconsistent and incorrect measurements"
      ],
      correctAnswer: 1
    },
    {
      id: 91209,
      question: "In the DMFT index, what does the letter \"M\" represent?",
      options: [
        "Mobility of the tooth due to periodontal disease",
        "Missing teeth due to caries",
        "Monitored surfaces with early caries lesions",
        "Mesial surfaces scored during the examination"
      ],
      correctAnswer: 1
    },
    {
      id: 91210,
      question: "Which of the following indices is used specifically for primary (deciduous) dentition caries recording?",
      options: [
        "DMFT",
        "DMFS",
        "dmft or deft",
        "PUFA"
      ],
      correctAnswer: 2
    },
    {
      id: 91211,
      question: "The PUFA index measures which of the following conditions?",
      options: [
        "Plaque, ulceration, fluorosis, and abscess formation on tooth surfaces",
        "Pocket depth, ulceration, furcation involvement, and attachment loss",
        "Plaque accumulation, calculus, fistula, and alveolar bone loss",
        "Pulp involvement, ulceration, fistula, and abscess resulting from untreated decay"
      ],
      correctAnswer: 3
    },
    {
      id: 91212,
      question: "In the PUFA index, a score of \"A\" is recorded when which of the following is observed?",
      options: [
        "Visible opening of the pulp chamber due to severe caries",
        "Traumatic ulceration of soft tissue caused by sharp edges of a dislocated tooth",
        "A pus-releasing sinus tract related to a tooth with pulp involvement",
        "A pus-containing swelling related to a tooth with pulpal involvement"
      ],
      correctAnswer: 3
    },
    {
      id: 91213,
      question: "Which periodontal index assesses probing depths and bleeding and was developed to obtain more uniform worldwide epidemiologic data?",
      options: [
        "Gingival Index (GI) by Loe and Silness",
        "Periodontal Index (PI) by Russell",
        "Community and Periodontal Index of Treatment Needs (CPITN)",
        "Eastman Interdental Bleeding Index (EIBI)"
      ],
      correctAnswer: 2
    },
    {
      id: 91214,
      question: "The Gingival Index (GI) developed by Loe and Silness assesses which of the following?",
      options: [
        "Presence of inflammation and bleeding in the interdental area upon toothpick insertion",
        "Severity of gingivitis based on color, consistency, and bleeding on probing",
        "Severity of gingival inflammation, pocket depth, and level of gingival attachment",
        "Periodontal health through probing depths, bleeding, and presence of hard deposits"
      ],
      correctAnswer: 1
    },
    {
      id: 91215,
      question: "Which periodontal index assesses the severity of gingival inflammation without the use of probing?",
      options: [
        "Gingival Bleeding Index (GBI)",
        "Modified Gingival Index (MGI)",
        "Periodontal Disease Index (PDI)",
        "Periodontal Index (PI) by Russell"
      ],
      correctAnswer: 3
    },
    {
      id: 91216,
      question: "The Ramfjord teeth used in several periodontal indices include which set of teeth?",
      options: [
        "Teeth 11, 16, 26, 31, 36, and 46",
        "Teeth 14, 17, 21, 34, 37, and 41",
        "Teeth 16, 21, 24, 36, 41, and 44",
        "Teeth 13, 16, 23, 33, 36, and 43"
      ],
      correctAnswer: 2
    },
    {
      id: 91217,
      question: "Which oral hygiene index combines both a debris index and a calculus index into a single score?",
      options: [
        "Gingival Bleeding Index (GBI)",
        "Plaque Index (PI) by Silness and Loe",
        "Oral Hygiene Index – Simplified (OHI-S)",
        "Periodontal Screening and Recording (PSR)"
      ],
      correctAnswer: 2
    },
    {
      id: 91218,
      question: "In the OHI-S debris scoring criteria, a score of \"0\" is assigned when which of the following is present?",
      options: [
        "No debris or stain present on the tooth surface",
        "Soft debris covering not more than one-third of the tooth surface",
        "Soft debris covering more than one-third but not more than two-thirds of the surface",
        "Soft debris covering more than two-thirds of the exposed tooth surface"
      ],
      correctAnswer: 0
    },
    {
      id: 91219,
      question: "In the OHI-S debris scoring criteria, a score of \"1\" is assigned when which of the following is present?",
      options: [
        "No debris or stain is visible anywhere on the tooth surface",
        "Soft debris covering not more than one-third of the tooth surface, or extrinsic stain without debris",
        "Soft debris covering more than one-third but not more than two-thirds of the surface",
        "Soft debris covering more than two-thirds of the exposed tooth surface"
      ],
      correctAnswer: 1
    },
    {
      id: 91220,
      question: "According to the OHI-S calculus criteria, a score of \"3\" is recorded when which condition is present?",
      options: [
        "Individual flecks of subgingival calculus around the cervical portion only",
        "Supragingival calculus covering more than one-third but under two-thirds of the surface",
        "No calculus visible but bleeding on probing is present at the site",
        "Supragingival calculus covering more than two-thirds of the surface or a continuous heavy band of subgingival calculus"
      ],
      correctAnswer: 3
    },
    {
      id: 91221,
      question: "In Dean's Fluorosis Index, which category describes enamel that is smooth, glossy, and pale creamy-white translucent?",
      options: [
        "Normal",
        "Questionable",
        "Very Mild",
        "Mild"
      ],
      correctAnswer: 0
    },
    {
      id: 91222,
      question: "In Dean's Fluorosis Index, the \"Severe\" category is best described as which of the following?",
      options: [
        "Small opaque, paper-white areas covering less than 25% of the tooth surface",
        "Opaque white areas covering less than 50% of the tooth surface",
        "All tooth surfaces affected with marked wear on biting surfaces; brown stain may be present",
        "All tooth surfaces affected with discrete or confluent pitting and brown stain present"
      ],
      correctAnswer: 3
    },
    {
      id: 91223,
      question: "Poor oral health has been associated with which of the following systemic and social consequences?",
      options: [
        "Increased academic performance and reduced emergency department visits",
        "Lower self-esteem, systemic diseases, sleep deprivation, and unemployment",
        "Improved nutrition and increased confidence in daily activities",
        "Reduced healthcare costs and improved family relationships"
      ],
      correctAnswer: 1
    },
    {
      id: 91224,
      question: "Which of the following best describes the Oral Health Impact Profile (OHIP-14)?",
      options: [
        "A clinical index used by hygienists to score plaque and calculus accumulation levels",
        "A rapid visual screening tool used in school settings to detect gross dental lesions",
        "A 14-item questionnaire measuring how oral conditions affect daily functioning and well-being",
        "A fluorosis index measuring the severity of enamel defects on a six-point scale"
      ],
      correctAnswer: 2
    },
    {
      id: 91225,
      question: "The OHIP-14 questionnaire asks patients to report on experiences over what time period?",
      options: [
        "The past week",
        "The past month",
        "The past six months",
        "The past 12 months"
      ],
      correctAnswer: 3
    },
    {
      id: 91226,
      question: "Which of the following is NOT one of the questions included in the OHIP-14?",
      options: [
        "Have you had trouble pronouncing any words?",
        "Have you experienced bleeding gums during toothbrushing?",
        "Have you been self-conscious?",
        "Have you been totally unable to function?"
      ],
      correctAnswer: 1
    },
    {
      id: 91227,
      question: "The Basic Screening Survey (BSS) is best described as which of the following?",
      options: [
        "A rapid visual assessment using a dental mirror to detect gross dental and oral lesions",
        "A detailed periodontal examination using a calibrated probe and radiographs",
        "A comprehensive caries risk assessment tool administered by questionnaire",
        "A fluorosis screening protocol requiring specialized ultraviolet lighting equipment"
      ],
      correctAnswer: 0
    },
    {
      id: 91228,
      question: "In the context of school-based dental screenings, what is the primary role of the registered dental hygienist performing a BSS?",
      options: [
        "To identify obvious painful conditions, notify parents, and recommend additional services",
        "To provide restorative treatment for cavities found during the screening visit",
        "To diagnose and document all dental conditions requiring specialist referral",
        "To administer fluoride treatments and place sealants on all eligible teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 91229,
      question: "Which of the following is an example of a public health \"indicator\" related to access to preventive treatment?",
      options: [
        "The percentage of the population with dental insurance coverage",
        "The number of teeth sealed in a target population",
        "The percentage of the population who visited a health care professional in the last year",
        "The percentage of the population receiving fluoridated water"
      ],
      correctAnswer: 1
    },
    {
      id: 91230,
      question: "Which of the following examples best represents an indicator of \"access to care\"?",
      options: [
        "The number of teeth sealed in a target population",
        "The percentage of edentulous individuals in a community",
        "The percentage of the population who visited a health care professional within the last year",
        "The percentage of the population who receive fluoridated water"
      ],
      correctAnswer: 2
    },
    {
      id: 91231,
      question: "Surveillance is defined as the ongoing systematic collection, analysis, and interpretation of health data aimed at timely dissemination to responsible parties who plan and evaluate public health programs.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91232,
      question: "The term \"measurement\" in health sciences refers only to physical measurements such as probing depth and does not include subjective measures like pain or anxiety.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91233,
      question: "A dental index allows for more consistency and less subjectivity compared to using descriptive words to document oral health conditions.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91234,
      question: "An irreversible index is one where the score can increase or decrease over time depending on treatment and disease progression.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91235,
      question: "In the DMFT index, the \"D\" component represents disease, the \"M\" component represents missing teeth due to caries, and the \"F\" component represents treatment (filled).",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91236,
      question: "The PUFA index is used to measure early-stage caries before cavitation occurs in the enamel layer.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91237,
      question: "Dean's Fluorosis Index classifies \"Severe\" fluorosis as all tooth surfaces affected with discrete or confluent pitting and brown stain present.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91238,
      question: "Poor oral health has been linked only to physical health consequences and has no impact on social or psychological outcomes such as self-esteem or employment.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91239,
      question: "The Basic Screening Survey (BSS) is a comprehensive diagnostic examination requiring radiographs and a full periodontal probing chart.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91240,
      question: "Indicators in public health are values such as the percentage of the population with insurance that may reflect the presence of health or disease risk factors in a community.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
  ],
  "3. Determinants of Health (Part 3)": [
    {
      id: 91241,
      question: "What is the central focus of the mission of public health?",
      options: [
        "Treating individual patients in private clinical settings only",
        "Maximizing revenue for hospitals and healthcare insurers",
        "Preventing disease and providing an environment for healthy living",
        "Training dentists to open more private dental practices"
      ],
      correctAnswer: 2
    },
    {
      id: 91242,
      question: "Which organization established and administers the Certified in Public Health (CPH) examination?",
      options: [
        "The Commission on Dental Accreditation standards office",
        "The National Board of Public Health Examiners",
        "The American Dental Hygienists' Association leadership board",
        "The Centers for Disease Control and Prevention division"
      ],
      correctAnswer: 1
    },
    {
      id: 91243,
      question: "The CPH examination ensures competency of graduates from programs accredited by which body?",
      options: [
        "The National Commission for Health Education Credentialing",
        "The American Dental Education Association curriculum board",
        "The Association of State and Territorial Dental Directors",
        "The Council on Education for Public Health (CEPH)"
      ],
      correctAnswer: 3
    },
    {
      id: 91244,
      question: "The NCHEC provides the Certified Health Education Specialist (CHES) credential and which advanced credential?",
      options: [
        "Master Certified Health Education Specialist (MCHES)",
        "Advanced Registered Public Health Educator (ARPHE)",
        "Senior Community Oral Health Specialist (SCOHS)",
        "Certified Dental Public Health Practitioner (CDPHP)"
      ],
      correctAnswer: 0
    },
    {
      id: 91245,
      question: "The tasks needed to master the CHES and MCHES examinations are organized within how many areas of responsibility?",
      options: [
        "Ten areas",
        "Eight areas",
        "Four areas",
        "Six areas"
      ],
      correctAnswer: 1
    },
    {
      id: 91246,
      question: "The Council on Linkages core competencies for public health professionals are divided into how many domains?",
      options: [
        "Twelve domains",
        "Eight domains",
        "Three domains",
        "Five domains"
      ],
      correctAnswer: 1
    },
    {
      id: 91247,
      question: "According to the chapter, what is the main aim of health educators?",
      options: [
        "To diagnose oral diseases and prescribe medications to patients",
        "To enforce penalties on communities lacking fluoridated water",
        "To set insurance reimbursement rates for dental procedures",
        "To promote healthy behaviors and empower people to adopt and maintain them"
      ],
      correctAnswer: 3
    },
    {
      id: 91248,
      question: "According to CODA standards, dental hygiene graduates must be able to do which of the following?",
      options: [
        "Perform complex oral surgeries within hospital operating rooms",
        "Independently set state-level public health law and policy",
        "Manufacture and distribute fluoride supplements to schools",
        "Assess community needs, plan and implement a program, and evaluate it"
      ],
      correctAnswer: 3
    },
    {
      id: 91249,
      question: "What are the three core functions of public health that shape its basic practice?",
      options: [
        "Research, publication, and academic instruction",
        "Funding, marketing, and staffing of health clinics",
        "Assessment, policy development, and assurance",
        "Diagnosis, treatment, and rehabilitation of patients"
      ],
      correctAnswer: 2
    },
    {
      id: 91250,
      question: "Which statement best describes assessment as a core public health function?",
      options: [
        "The marketing of new dental products to the general public",
        "The systematic collection and analysis of data on community health",
        "The direct provision of restorative dental care to individuals",
        "The enforcement of laws regulating private dental practices"
      ],
      correctAnswer: 1
    },
    {
      id: 91251,
      question: "Epidemiology is best defined as the study of which of the following?",
      options: [
        "The distribution and determinants of health-related states in populations",
        "The chemical composition of pharmaceutical drugs in a lab",
        "The financial accounting practices used by health agencies",
        "The repair of dental equipment used in mobile clinics"
      ],
      correctAnswer: 0
    },
    {
      id: 91252,
      question: "The epidemiologic triangle depicts disease as the outcome of which interacting factors?",
      options: [
        "Federal, state, and local government factors",
        "Income, education, and employment factors",
        "Host, agent, and environmental factors",
        "Primary, secondary, and tertiary factors"
      ],
      correctAnswer: 2
    },
    {
      id: 91253,
      question: "In the epidemiologic triangle, the host refers to which of the following?",
      options: [
        "The physical and social surroundings that influence disease",
        "The biological or mechanical means of causing the disease",
        "The individual potentially affected by the disease in question",
        "The length of time before symptoms or recovery occur"
      ],
      correctAnswer: 2
    },
    {
      id: 91254,
      question: "Which of the following best describes agent factors in the epidemiologic triangle?",
      options: [
        "The economic and sociocultural conditions surrounding people",
        "The individual person who is susceptible to a given disease",
        "The duration of time it takes for an epidemic to develop",
        "The biologic or mechanical means of causing disease or injury"
      ],
      correctAnswer: 3
    },
    {
      id: 91255,
      question: "Environmental factors in the epidemiologic triangle include which of the following components?",
      options: [
        "The host's individual beliefs, values, habits, and customs",
        "Specific bacteria such as Streptococcus mutans and Lactobacillus",
        "Physical, sociocultural, sociopolitical, and economic components",
        "Tooth enamel structure and the flow and composition of saliva"
      ],
      correctAnswer: 2
    },
    {
      id: 91256,
      question: "In the epidemiologic triangle, what does the element of time represent?",
      options: [
        "The cost in dollars of treating a population's disease burden",
        "The number of staff required to run a public health program",
        "The geographic distance between patients and dental clinics",
        "The length of time for damage, symptoms, recovery, or epidemic onset"
      ],
      correctAnswer: 3
    },
    {
      id: 91257,
      question: "In the U.S. population, most oral diseases such as dental caries and periodontitis are considered to be what?",
      options: [
        "Endemic",
        "Pandemic",
        "Eradicated",
        "Sporadic"
      ],
      correctAnswer: 0
    },
    {
      id: 91258,
      question: "Eradication of a disease, the stated ideal, requires which of the following?",
      options: [
        "Complete elimination of all government health regulations",
        "A firm understanding of the causative agents and factors",
        "Restricting the disease only to rural farming communities",
        "Limiting data collection to qualitative interviews alone"
      ],
      correctAnswer: 1
    },
    {
      id: 91259,
      question: "The 1948 World Health Organization definition describes health as which of the following?",
      options: [
        "The financial ability to afford private medical treatment",
        "A condition achieved only through individual lifestyle choices",
        "A complete absence of any disease, infirmity, or disability",
        "A state of complete physical, social, and mental well-being"
      ],
      correctAnswer: 3
    },
    {
      id: 91260,
      question: "The Ottawa Charter for Health Promotion describes prerequisites for health that include which set?",
      options: [
        "Peace, shelter, education, food, income, and social justice",
        "Diagnosis, treatment, billing, and insurance reimbursement",
        "Surgery, medication, hospitalization, and rehabilitation",
        "Profit, marketing, competition, and corporate growth"
      ],
      correctAnswer: 0
    },
    {
      id: 91261,
      question: "Health promotion, as described in the Ottawa Charter, is best defined as which process?",
      options: [
        "Requiring people to follow strict government health mandates",
        "Enabling people to increase control over and improve their health",
        "Restricting the sale of unhealthy foods within communities",
        "Providing surgical treatment to people with advanced disease"
      ],
      correctAnswer: 1
    },
    {
      id: 91262,
      question: "Which concept emerged as multifactorial perspectives of health and disease grew?",
      options: [
        "The web of causation",
        "The deficiency-based assessment model",
        "The windshield survey method",
        "The single-cause theory of disease transmission"
      ],
      correctAnswer: 0
    },
    {
      id: 91263,
      question: "Which of the following is one of the categories used to organize the determinants of health?",
      options: [
        "Funding, staffing, marketing, scheduling, and billing of clinics",
        "Diagnosis, prevention, treatment, evaluation, and rehabilitation",
        "Primary, secondary, tertiary, formative, and summative review",
        "Policymaking, social, health services, individual behavior, and biology"
      ],
      correctAnswer: 3
    },
    {
      id: 91264,
      question: "Which of the following is an example of the policymaking determinant of health?",
      options: [
        "Limited availability of dentists who speak a patient's language",
        "Community water fluoridation enacted to prevent dental caries",
        "A patient who inherits a predisposition to a dental condition",
        "A person choosing to quit smoking to reduce their cancer risk"
      ],
      correctAnswer: 1
    },
    {
      id: 91265,
      question: "Social determinants of health are best described as which of the following?",
      options: [
        "The inherited biological make-up of an individual's body",
        "The federal and state laws that regulate individual behavior",
        "Conditions in which people are born, live, learn, work, and age",
        "The personal daily actions that influence one's own health"
      ],
      correctAnswer: 2
    },
    {
      id: 91266,
      question: "Which of the following is an example of the individual behavior determinant of health?",
      options: [
        "An inherited condition such as congenitally missing teeth",
        "Practicing adequate oral hygiene with suitable supplies",
        "The availability of an oral health workforce in rural areas",
        "A city ordinance prohibiting smoking in public buildings"
      ],
      correctAnswer: 1
    },
    {
      id: 91267,
      question: "Which of the following is an example of the biology and genetics determinant of health?",
      options: [
        "Inherited conditions such as cleft lip or congenitally missing teeth",
        "Access to dental providers who speak the patient's language",
        "Changing one's diet to reduce the risk of dental caries",
        "A state law requiring that seat belts be worn in vehicles"
      ],
      correctAnswer: 0
    },
    {
      id: 91268,
      question: "Which of the following falls under the health services determinant of health?",
      options: [
        "A school policy banning sugary snacks at school parties",
        "An individual's frequency of brushing and flossing at home",
        "Insurance and dental insurance coverage availability",
        "A family history of diabetes or heart disease in relatives"
      ],
      correctAnswer: 2
    },
    {
      id: 91269,
      question: "Health inequities are best defined as which of the following?",
      options: [
        "Random natural differences in health that cannot be changed",
        "Unfair, unjust, unnecessary, and avoidable differences in health",
        "Equal distribution of health resources across all populations",
        "Differences caused solely by individual genetic make-up"
      ],
      correctAnswer: 1
    },
    {
      id: 91270,
      question: "Which of the following is one of the five key areas to address social determinants of health?",
      options: [
        "Surgical capacity, including operating rooms and staff",
        "Pharmaceutical supply, including drug manufacturing rates",
        "Private profit, including corporate revenue and growth",
        "Economic stability, including poverty and employment"
      ],
      correctAnswer: 3
    },
    {
      id: 91271,
      question: "Under social determinants of health, the neighborhood and built environment area includes which factor?",
      options: [
        "Health insurance coverage and access to primary care",
        "Availability of healthy foods and access to transportation",
        "High school graduation and enrollment in higher education",
        "Social cohesion, civic participation, and discrimination"
      ],
      correctAnswer: 1
    },
    {
      id: 91272,
      question: "What is the first step of the community health program planning process?",
      options: [
        "Developing measurable process and outcome objectives",
        "Assessing the community to identify the primary health issues",
        "Evaluating the interventions and using results to improve them",
        "Implementing the selected health interventions in the field"
      ],
      correctAnswer: 1
    },
    {
      id: 91273,
      question: "Which statement best characterizes the community health program planning process?",
      options: [
        "It applies only to large state-level programs and nothing smaller",
        "It excludes evaluation because outcomes cannot be measured",
        "It is a continuous process that can be subdivided into detailed steps",
        "It is a one-time event completed and never revisited again"
      ],
      correctAnswer: 2
    },
    {
      id: 91274,
      question: "A community oral health assessment is best described as a process that is which of the following?",
      options: [
        "Focused only on the financial profit of dental providers",
        "Community-oriented and community-directed in its approach",
        "Limited strictly to counting the number of local dentists",
        "Directed entirely by outside federal agencies without local input"
      ],
      correctAnswer: 1
    },
    {
      id: 91275,
      question: "Why are assets-oriented assessment methods generally preferred over deficiency-based approaches?",
      options: [
        "They require no community participation or local engagement",
        "They focus only on problems and ignore community strengths",
        "They are faster because they skip the data collection phase",
        "They serve communities better and produce more sustainable outcomes"
      ],
      correctAnswer: 3
    },
    {
      id: 91276,
      question: "What is the first phase of the community needs assessment process?",
      options: [
        "Cultivate partnerships and select an advisory committee",
        "Collect data from primary and secondary sources",
        "Prioritize issues and report the assessment findings",
        "Organize, review, and analyze the collected data"
      ],
      correctAnswer: 0
    },
    {
      id: 91277,
      question: "A coalition is best defined as which of the following?",
      options: [
        "A private company that markets dental products to consumers",
        "A single government agency that funds all health programs",
        "An alliance of groups and individuals working toward a common goal",
        "A law that requires communities to fluoridate their water"
      ],
      correctAnswer: 2
    },
    {
      id: 91278,
      question: "A community partnership is best described as which of the following?",
      options: [
        "A competition between agencies for limited government funding",
        "An individual effort by one dentist to improve a neighborhood",
        "An arrangement among groups that combine resources for a common goal",
        "A legal contract that prevents organizations from collaborating"
      ],
      correctAnswer: 2
    },
    {
      id: 91279,
      question: "In community health, empowerment refers to which of the following?",
      options: [
        "Granting all decision-making authority to outside consultants",
        "Removing community members from the assessment process",
        "Enabling the community to take control and make its own decisions",
        "Restricting health information to professionals only"
      ],
      correctAnswer: 2
    },
    {
      id: 91280,
      question: "What is the main purpose of the self-assessment phase (Phase 2) of the needs assessment?",
      options: [
        "To collect clinical oral health data from the population directly",
        "To publish the final findings to community stakeholders",
        "To prioritize the oral health issues facing the community",
        "To identify goals and define the purpose of the needs assessment"
      ],
      correctAnswer: 3
    },
    {
      id: 91281,
      question: "A community snapshot is best described as which of the following?",
      options: [
        "A brief overview describing community traits and health indicators",
        "A final executive summary delivered at the end of the assessment",
        "A detailed statistical report with all primary and secondary data",
        "A clinical survey measuring dental caries in schoolchildren"
      ],
      correctAnswer: 0
    },
    {
      id: 91282,
      question: "Secondary data are best described as which of the following?",
      options: [
        "Data that cannot be expressed numerically in any form",
        "Data collected directly from the source through new interviews",
        "Clinical measurements taken during an oral health survey",
        "Previously collected data compiled from existing sources"
      ],
      correctAnswer: 3
    },
    {
      id: 91283,
      question: "Primary data are best described as which of the following?",
      options: [
        "Existing data already gathered and reported by other agencies",
        "Data that describe only the history and traditions of a community",
        "Reports compiled solely from newspapers and social media",
        "Data collected directly from the source, such as through surveys"
      ],
      correctAnswer: 3
    },
    {
      id: 91284,
      question: "Quantitative data are best described as which of the following?",
      options: [
        "Information that is objective, measurable, and expressed as amounts",
        "Information reflecting the quality or nature of a health problem",
        "Information gathered only through personal interviews and focus groups",
        "Descriptions of community traditions and historical narratives"
      ],
      correctAnswer: 0
    },
    {
      id: 91285,
      question: "Qualitative data are best described as which of the following?",
      options: [
        "Employment figures and the number of schools in a county",
        "Information that cannot be numerically measured but adds meaning",
        "Demographic statistics expressed as quantities or amounts",
        "Numerical counts of births, deaths, and disease prevalence rates"
      ],
      correctAnswer: 1
    },
    {
      id: 91286,
      question: "Which data collection method is generally the most costly and time-consuming?",
      options: [
        "A telephone interview conducted by phone",
        "A mailed survey sent to community households",
        "A person-to-person interview with individuals",
        "A windshield tour of the neighborhood"
      ],
      correctAnswer: 2
    },
    {
      id: 91287,
      question: "In data analysis, the term significance means which of the following?",
      options: [
        "The resulting information truly reflects that a problem exists",
        "The data require no review for possible errors or bias",
        "The data were collected faster than in previous assessments",
        "The findings are kept confidential from the community members"
      ],
      correctAnswer: 0
    },
    {
      id: 91288,
      question: "Phase 6 of the needs assessment consists of which two key actions?",
      options: [
        "Collecting primary data and collecting secondary data",
        "Cultivating partnerships and selecting an advisory committee",
        "Prioritizing the issues and reporting the assessment findings",
        "Designing the assessment and evaluating the assessment process"
      ],
      correctAnswer: 2
    },
    {
      id: 91289,
      question: "Prioritization of issues is best described as which of the following?",
      options: [
        "A method that ignores the availability of funding and workforce",
        "A random selection of issues with no community involvement",
        "A process that excludes the advisory committee from decisions",
        "An impartial, balanced process deciding the order of importance"
      ],
      correctAnswer: 3
    },
    {
      id: 91290,
      question: "When communicating assessment outcomes, why is it important to prepare an executive summary?",
      options: [
        "To replace the need for any charts, graphs, tables, or maps",
        "To hide the limitations of the data from the target audience",
        "To succinctly highlight the key findings of the assessment",
        "To restrict the findings to oral health professionals only"
      ],
      correctAnswer: 2
    },
    {
      id: 91291,
      question: "Which term refers to the comprehensive, detailed description of the community?",
      options: [
        "Community profile",
        "Community snapshot",
        "Community asset map",
        "Primary data collection"
      ],
      correctAnswer: 0
    },
    {
      id: 91292,
      question: "After completing the evaluation in Phase 7, the needs assessment process loops back to which phase?",
      options: [
        "Phase 4, to collect new primary data",
        "Phase 1, to cultivate partnerships again",
        "Phase 6, to re-prioritize the issues",
        "Phase 2, to re-establish the assessment purpose"
      ],
      correctAnswer: 3
    },
    {
      id: 91293,
      question: "A critique of the assessment conducted at the end of the process is an example of which evaluation?",
      options: [
        "Summative evaluation providing a record of lessons learned",
        "Financial evaluation of the program's annual budget",
        "Clinical evaluation of individual patients' oral health",
        "Formative evaluation performed throughout the process"
      ],
      correctAnswer: 0
    },
    {
      id: 91294,
      question: "What role are dental hygienists in public health expected to play in community oral health assessments?",
      options: [
        "A leadership role in conducting the assessments",
        "No role, since assessments are done only by physicians",
        "A role restricted to cleaning teeth in private offices",
        "A role limited strictly to billing and scheduling"
      ],
      correctAnswer: 0
    },
    {
      id: 91295,
      question: "What are the main purposes of a community oral health assessment?",
      options: [
        "To increase the private profits of local dental practices only",
        "To identify factors affecting oral health and available resources",
        "To replace the need for any oral health improvement plan",
        "To eliminate community members from health decision-making"
      ],
      correctAnswer: 1
    },
    {
      id: 91296,
      question: "According to the chapter, a community oral health assessment is virtually useless unless what occurs?",
      options: [
        "The findings are reported only to outside federal agencies",
        "The information is used to develop and implement programs",
        "The data are kept private and never shared with anyone",
        "The assessment is repeated every single week without changes"
      ],
      correctAnswer: 1
    },
    {
      id: 91297,
      question: "Which of the following is an example of quantitative data?",
      options: [
        "Personal observations recorded during participant observation",
        "The history and traditions of a particular community",
        "Descriptions gathered from a community focus group discussion",
        "Incidence or prevalence rates of disease in a population"
      ],
      correctAnswer: 3
    },
    {
      id: 91298,
      question: "Which of the following is identified as a source of information for a community oral health assessment?",
      options: [
        "Federal, state, and local government agencies and reports",
        "Solely advertisements for commercial dental products",
        "Only data invented by the advisory committee members",
        "Exclusively the personal opinions of a single dentist"
      ],
      correctAnswer: 0
    },
    {
      id: 91299,
      question: "Community assessment data can be meaningfully compared with which of the following?",
      options: [
        "Previous years from the same community and surrounding areas",
        "Random numbers generated without any defined source",
        "Only data from a single household within the community",
        "Data from unrelated industries with no health relevance"
      ],
      correctAnswer: 0
    },
    {
      id: 91300,
      question: "The concepts of health and disease prevention have expanded from an individual focus toward what?",
      options: [
        "A focus limited only to acute infectious diseases",
        "A purely financial and profit-driven healthcare model",
        "A human ecologic approach considering broad influences",
        "A model that ignores social and environmental factors"
      ],
      correctAnswer: 2
    },
    {
      id: 91301,
      question: "Assessment is one of the three core functions of public health, along with policy development and assurance.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91302,
      question: "In the epidemiologic triangle, the agent refers to the individual person who is potentially affected by the disease.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91303,
      question: "Social determinants of health are primarily responsible for health inequities among populations.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91304,
      question: "Quantitative data refer to information that cannot be numerically measured or analyzed.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91305,
      question: "The first phase of the community needs assessment is to cultivate partnerships and select an advisory committee.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91306,
      question: "A person-to-person interview is generally the least costly and least time-consuming data collection method.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
  ],
  "4. Dental Indices (Part 2)": [
    {
      id: 91307,
      question: "Public health surveillance is best defined as which of the following?",
      options: [
        "The one-time provision of clinical dental treatment to individual patients",
        "The enforcement of laws that regulate private dental office practices",
        "The marketing of new dental products to consumers across the nation",
        "The ongoing systematic collection, analysis, and interpretation of health data"
      ],
      correctAnswer: 3
    },
    {
      id: 91308,
      question: "Which of the following are the four critical processes of surveillance?",
      options: [
        "Diagnosis, treatment, billing, and rehabilitation of patients",
        "Data collection, analysis, interpretation, and dissemination",
        "Funding, staffing, scheduling, and marketing of programs",
        "Screening, referral, prevention, and clinical examination"
      ],
      correctAnswer: 1
    },
    {
      id: 91309,
      question: "Which of the following is a stated function of public health surveillance?",
      options: [
        "To replace the need for any clinical dental care in communities",
        "To set the prices charged by private dentists for their services",
        "To serve as an early warning system for impending health emergencies",
        "To eliminate the role of government in public health entirely"
      ],
      correctAnswer: 2
    },
    {
      id: 91310,
      question: "In what year was the first landmark report of the Healthy People initiative issued?",
      options: [
        "1989",
        "1979",
        "1999",
        "1969"
      ],
      correctAnswer: 1
    },
    {
      id: 91311,
      question: "Healthy People objectives are established for what length of time each cycle?",
      options: [
        "Ten-year national health objectives",
        "Five-year national health objectives",
        "Two-year national health objectives",
        "Twenty-year national health objectives"
      ],
      correctAnswer: 0
    },
    {
      id: 91312,
      question: "Healthy People 2030 is which edition of the program?",
      options: [
        "The fifth edition of the program",
        "The third edition of the program",
        "The second edition of the program",
        "The fourth edition of the program"
      ],
      correctAnswer: 0
    },
    {
      id: 91313,
      question: "Which agency oversaw and managed the development of Healthy People 2030?",
      options: [
        "The National Cancer Institute Surveillance Program alone",
        "The Federal Interagency Workgroup on Healthy People 2030 (FIW)",
        "The World Health Organization Tobacco Free Initiative",
        "The Association of State and Territorial Dental Directors only"
      ],
      correctAnswer: 1
    },
    {
      id: 91314,
      question: "Which of the following is a component of the Healthy People 2030 framework?",
      options: [
        "A list of approved private dental products for nationwide sale",
        "A schedule of fees that dentists must charge for procedures",
        "A vision statement, mission statement, principles, and overarching goals",
        "A directory of every licensed dentist working in the country"
      ],
      correctAnswer: 2
    },
    {
      id: 91315,
      question: "What does the Healthy People 2030 framework embrace as its approach to health improvement?",
      options: [
        "The elimination of all government involvement in health policy",
        "A reliance only on private-sector profit to drive improvements",
        "The determinants of health and the integration of health policies",
        "A focus solely on treating disease rather than preventing it"
      ],
      correctAnswer: 2
    },
    {
      id: 91316,
      question: "As defined for Healthy People 2030, a health disparity refers to which of the following?",
      options: [
        "Any random natural difference in health that cannot be modified",
        "A difference caused entirely by an individual's genetic make-up",
        "An equal distribution of health resources across all populations",
        "A health difference that is unfair due to social or economic disadvantage"
      ],
      correctAnswer: 3
    },
    {
      id: 91317,
      question: "Health equity is best described as which of the following?",
      options: [
        "A way to eliminate the need for any public health surveillance",
        "A goal entailing special efforts to improve health of the disadvantaged",
        "A method of restricting health services to wealthy populations only",
        "A guarantee that all people will have identical health outcomes"
      ],
      correctAnswer: 1
    },
    {
      id: 91318,
      question: "Approximately what proportion of the Healthy People 2030 objectives clearly address health equity?",
      options: [
        "About 70%",
        "About 10%",
        "About 30%",
        "About 50%"
      ],
      correctAnswer: 2
    },
    {
      id: 91319,
      question: "How many core measurable objectives does Healthy People 2030 contain?",
      options: [
        "455 core objectives",
        "255 core objectives",
        "355 core objectives",
        "555 core objectives"
      ],
      correctAnswer: 2
    },
    {
      id: 91320,
      question: "The Healthy People 2030 objectives are organized by how many topic areas?",
      options: [
        "62 topic areas",
        "72 topic areas",
        "42 topic areas",
        "52 topic areas"
      ],
      correctAnswer: 0
    },
    {
      id: 91321,
      question: "The leading health indicators (LHIs) are best described as which of the following?",
      options: [
        "A smaller set of high-priority health issues for the decade",
        "A list of all private dental insurers in the country",
        "A set of fees charged for dental services in clinics",
        "A complete list of every objective across all topic areas"
      ],
      correctAnswer: 0
    },
    {
      id: 91322,
      question: "How many leading health indicators (LHIs) are identified for this decade?",
      options: [
        "33 LHIs",
        "23 LHIs",
        "43 LHIs",
        "13 LHIs"
      ],
      correctAnswer: 1
    },
    {
      id: 91323,
      question: "Which statement describes a characteristic of the leading health indicators?",
      options: [
        "They focus on upstream measures like risk factors and behaviors",
        "They focus only on disease outcomes rather than risk factors",
        "They exclude any focus on social determinants of health",
        "They remain identical and unchanged from one decade to the next"
      ],
      correctAnswer: 0
    },
    {
      id: 91324,
      question: "Oral Conditions in Healthy People 2030 is best described as which of the following?",
      options: [
        "One of the 62 topic areas by which objectives are organized",
        "A survey conducted only in long-term care nursing facilities",
        "A private organization that sells dental products nationally",
        "A clinical index used to score caries on individual teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 91325,
      question: "Which Healthy People 2030 Oral Conditions objective is identified as a leading health indicator?",
      options: [
        "Increasing the proportion of persons with dental insurance",
        "Reducing the consumption of calories from added sugars",
        "Reducing the proportion of adults with moderate periodontitis",
        "Increasing the proportion who use the oral healthcare system (OH-8a)"
      ],
      correctAnswer: 3
    },
    {
      id: 91326,
      question: "The National Oral Health Surveillance System (NOHSS) was established through collaboration between which entities?",
      options: [
        "The CDC Division of Oral Health and the ASTDD",
        "The World Health Organization and the National Cancer Institute",
        "The Federal Interagency Workgroup and the Agency for Quality",
        "The American Dental Association and private insurance companies"
      ],
      correctAnswer: 0
    },
    {
      id: 91327,
      question: "What is the NOHSS designed to monitor?",
      options: [
        "The number of dental schools accredited within each U.S. state",
        "The burden of oral disease, use of care, and water fluoridation status",
        "The profits earned by private dental practices each fiscal year",
        "The retail prices of toothpaste and other oral hygiene products"
      ],
      correctAnswer: 1
    },
    {
      id: 91328,
      question: "Oral health indicators tracked by the NOHSS are best described as which of the following?",
      options: [
        "A complete clinical diagnosis and treatment plan for each patient",
        "A list of fees charged by dentists for preventive services",
        "A standard set of minimal quantifiable characteristics of a population",
        "A ranking of states by their total dental workforce numbers"
      ],
      correctAnswer: 2
    },
    {
      id: 91329,
      question: "What makes the National Health and Nutrition Examination Survey (NHANES) unique?",
      options: [
        "It relies entirely on data invented by survey administrators",
        "It collects data only from private dental insurance claims",
        "It combines interviews with physical (oral) examinations",
        "It examines only the teeth of children attending Head Start"
      ],
      correctAnswer: 2
    },
    {
      id: 91330,
      question: "The Behavioral Risk Factor Surveillance System (BRFSS) is best described as which of the following?",
      options: [
        "A clinical examination performed only in nursing facilities",
        "A registry tracking only oral and pharyngeal cancer deaths",
        "A state-specific telephone survey assessing health behaviors",
        "A household survey relying solely on physical examinations"
      ],
      correctAnswer: 2
    },
    {
      id: 91331,
      question: "The National Health Interview Survey (NHIS) primarily monitors health status using which method?",
      options: [
        "Remote analysis of digital photographs of participants' teeth",
        "Personal household interviews on a broad range of health topics",
        "Telephone calls limited strictly to tobacco-use questions",
        "Clinical intraoral examinations conducted in dental offices"
      ],
      correctAnswer: 1
    },
    {
      id: 91332,
      question: "The Medical Expenditure Panel Survey (MEPS) collects information primarily about which of the following?",
      options: [
        "The cost and use of health care and health insurance coverage",
        "The number of school-based dental sealant programs per state",
        "The fluoride concentration of community public water systems",
        "The clinical severity of periodontitis around individual teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 91333,
      question: "Basic screening for oral conditions involves which of the following?",
      options: [
        "Direct visual observation using a tongue blade, mirror, and lighting",
        "Remote scoring of digital photographs by multiple expert examiners",
        "A full clinical examination resulting in a complete treatment plan",
        "Detailed visual-tactile assessment with dental instruments and a light"
      ],
      correctAnswer: 0
    },
    {
      id: 91334,
      question: "An epidemiologic examination differs from basic screening in that it entails which of the following?",
      options: [
        "A dichotomous yes/no observation made without any instruments",
        "Detailed visual-tactile assessment with dental instruments and a light",
        "Only a verbal questionnaire with no examination of the mouth",
        "Remote scoring of photographs taken by community volunteers"
      ],
      correctAnswer: 1
    },
    {
      id: 91335,
      question: "Why is the basic screening approach generally not appropriate for research?",
      options: [
        "It produces data that cannot be compared among any populations",
        "It can only be performed by licensed physicians, not examiners",
        "It uses dichotomous (yes/no) measures rather than precise measures",
        "It requires far more expensive equipment than research allows"
      ],
      correctAnswer: 2
    },
    {
      id: 91336,
      question: "Surveys used in community oral health assessment are best characterized as which of the following?",
      options: [
        "Long-term clinical studies that follow individuals for decades",
        "Experimental trials that test new treatments on patient groups",
        "Descriptive and cross-sectional, estimating status at a point in time",
        "Diagnostic procedures that result in personalized treatment plans"
      ],
      correctAnswer: 2
    },
    {
      id: 91337,
      question: "Which organization designed the Basic Screening Survey tools for Preschool/School Children and Older Adults?",
      options: [
        "The World Health Organization (WHO) for global surveillance",
        "The Federal Interagency Workgroup on Healthy People 2030",
        "The Association of State and Territorial Dental Directors (ASTDD)",
        "The National Institutes of Health (NIH) Cancer Institute"
      ],
      correctAnswer: 2
    },
    {
      id: 91338,
      question: "The WHO's Basic Oral Health Survey tool was designed primarily for which purpose?",
      options: [
        "Tracking the profits of dental practices in the United States",
        "Global surveillance used by WHO member countries",
        "Scoring fluorosis remotely from digital photographs only",
        "Clinical diagnosis of individual patients in private offices"
      ],
      correctAnswer: 1
    },
    {
      id: 91339,
      question: "On the Basic Screening Survey, who may make observations of oral health status?",
      options: [
        "Only licensed physicians working in hospital emergency rooms",
        "Dentists, dental hygienists, or other appropriate healthcare workers",
        "Only researchers holding an advanced epidemiology doctorate",
        "Only the survey participants themselves through self-report"
      ],
      correctAnswer: 1
    },
    {
      id: 91340,
      question: "A dental index is best defined as which of the following?",
      options: [
        "An abbreviated measurement of the amount or condition of oral disease",
        "A complete written treatment plan for an individual dental patient",
        "A list of the fees charged for various dental procedures performed",
        "A directory of all dental clinics located within a given community"
      ],
      correctAnswer: 0
    },
    {
      id: 91341,
      question: "Which attribute of an effective dental index refers to its accuracy in measuring what is intended?",
      options: [
        "Sensitivity",
        "Acceptability",
        "Reliability",
        "Validity"
      ],
      correctAnswer: 3
    },
    {
      id: 91342,
      question: "Which attribute of a dental index refers to measuring consistently with reproducible, stable results?",
      options: [
        "Validity",
        "Utility",
        "Specificity",
        "Reliability"
      ],
      correctAnswer: 3
    },
    {
      id: 91343,
      question: "In the context of dental indices, sensitivity refers to which of the following?",
      options: [
        "The index correctly identifies the absence of the variable",
        "Small degrees of difference in the variable can be detected",
        "The criteria are clear, objective, and simple to calculate",
        "Statistics can be applied to the data collected with the index"
      ],
      correctAnswer: 1
    },
    {
      id: 91344,
      question: "In a dental index, specificity refers to which of the following?",
      options: [
        "The index correctly identifies the absence of the variable",
        "The index criteria are clinically meaningful overall",
        "Small degrees of difference in the variable can be detected",
        "The index measures consistently at different times"
      ],
      correctAnswer: 0
    },
    {
      id: 91345,
      question: "Which index is the best known and most widely used for measuring coronal caries?",
      options: [
        "The Decayed, Missing, Filled (DMF) Index",
        "The Community Periodontal Index (CPI)",
        "The Root Caries Index (RCI)",
        "Dean's Fluorosis Index (DFI)"
      ],
      correctAnswer: 0
    },
    {
      id: 91346,
      question: "Why is the DMF index considered irreversible?",
      options: [
        "It measures only the current active decay in the mouth",
        "It cannot be repeated once it has been scored one time",
        "It can only be applied to primary teeth in young children",
        "It indicates the cumulative, lifetime caries experience"
      ],
      correctAnswer: 3
    },
    {
      id: 91347,
      question: "In the DMF index, what does a high M (missing) component indicate?",
      options: [
        "That caries prevention efforts have completely succeeded",
        "That no further preventive programs are needed at all",
        "That the population is currently receiving adequate treatment",
        "A need for education and earlier intervention to avoid extractions"
      ],
      correctAnswer: 3
    },
    {
      id: 91348,
      question: "In DMF scoring, what does a high F (filled) component indicate?",
      options: [
        "A need to immediately stop all treatment programs",
        "That the population has no caries experience at all",
        "That the population is receiving dental treatment",
        "A failure of all caries prevention in the population"
      ],
      correctAnswer: 2
    },
    {
      id: 91349,
      question: "Why are lower-case letters (dmf, df, def) used instead of upper-case letters (DMF)?",
      options: [
        "To show that the index is used for fluorosis rather than caries",
        "To indicate that the index measures periodontal disease instead",
        "To signify the use of the index on primary teeth in children",
        "To signify the use of the index only on adult permanent teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 91350,
      question: "The Early Childhood Caries (ECC) Classification system is based on which of the following?",
      options: [
        "The presence of swelling, color, and bleeding of gingiva",
        "The number of dmf surfaces and the child's age",
        "The percentage of root surfaces decayed or filled",
        "The number of permanent teeth lost to tooth decay"
      ],
      correctAnswer: 1
    },
    {
      id: 91351,
      question: "The Root Caries Index (RCI) measurement is generally based on which of the following?",
      options: [
        "The number of quadrants showing any sign of gingival bleeding",
        "The proportion of teeth lost specifically to periodontal disease",
        "The total number of permanent molars sealed in the mouth",
        "The proportion of root surfaces decayed or filled relative to those at risk"
      ],
      correctAnswer: 3
    },
    {
      id: 91352,
      question: "How is the presence of dental sealants traditionally assessed in populations?",
      options: [
        "Through analysis of dental insurance claims data only",
        "Through a basic screening or epidemiologic examination procedure",
        "Through telephone interviews asking participants to self-report",
        "Through review of birth certificate records in each state"
      ],
      correctAnswer: 1
    },
    {
      id: 91353,
      question: "On the Basic Screening Survey, dental sealants are scored using which approach?",
      options: [
        "A remote digital photographic analysis by multiple examiners",
        "A detailed per-surface count using a No. 23 explorer on all molars",
        "A self-reported questionnaire completed by the participant",
        "A dichotomous (yes/no) measure of at least one sealant, per person"
      ],
      correctAnswer: 3
    },
    {
      id: 91354,
      question: "Besides examining individuals, how does the ASTDD measure sealant use across states?",
      options: [
        "By tallying the number of dental schools located in each state",
        "By assessing the number of school-based sealant programs per state",
        "By counting the number of private dental offices in each state",
        "By reviewing the fluoride concentration of each state's water"
      ],
      correctAnswer: 1
    },
    {
      id: 91355,
      question: "The term periodontal disease is best described as which of the following?",
      options: [
        "A condition measured only by counting the number of missing teeth",
        "A disease that can only be assessed through self-report questions",
        "A single, uniform disease entity affecting all teeth identically",
        "A group of closely related different diseases with similar presentation"
      ],
      correctAnswer: 3
    },
    {
      id: 91356,
      question: "The Modified Gingival Index (MGI) was adapted from the Gingival Index by doing which of the following?",
      options: [
        "Adding a probing requirement to increase the precision of scoring",
        "Combining gingivitis and periodontitis scores onto a single scale",
        "Restricting its use to only the so-called Ramfjord teeth",
        "Eliminating the probing requirement to avoid trauma and increase reliability"
      ],
      correctAnswer: 3
    },
    {
      id: 91357,
      question: "Why are composite periodontal indices now considered invalid and discarded?",
      options: [
        "They relied entirely on remote digital photographic analysis",
        "They scored gingivitis and periodontitis on the same scale",
        "They could only be used on primary teeth in young children",
        "They required expensive equipment unavailable to most surveys"
      ],
      correctAnswer: 1
    },
    {
      id: 91358,
      question: "Recent NHANES surveys have measured periodontal status using which method?",
      options: [
        "Full-mouth clinical probing of every tooth by two dentists",
        "Counting only the number of teeth lost to periodontal disease",
        "Patient self-report of periodontal status and related factors",
        "Remote scoring of digital photographs by expert examiners"
      ],
      correctAnswer: 0
    },
    {
      id: 91359,
      question: "Why was the periodontal disease objective age range changed to adults aged 45 and older?",
      options: [
        "The change was required by private dental insurance companies",
        "Older adults were found to never develop periodontal disease",
        "Younger adults were too difficult and costly to examine",
        "Earlier sampling of only younger adults underestimated prevalence"
      ],
      correctAnswer: 3
    },
    {
      id: 91360,
      question: "The Community Periodontal Index (CPI) was developed by which organization?",
      options: [
        "The Centers for Disease Control and Prevention",
        "The World Health Organization (WHO)",
        "The American Academy of Periodontology",
        "The Association of State and Territorial Dental Directors"
      ],
      correctAnswer: 1
    },
    {
      id: 91361,
      question: "The specific teeth historically measured in the Periodontal Disease Index (PDI) are known by what name?",
      options: [
        "The sentinel teeth",
        "The marker teeth",
        "The Ramfjord teeth",
        "The index teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 91362,
      question: "Edentulism is best defined as which of the following?",
      options: [
        "The presence of at least one natural tooth in the mouth",
        "Complete tooth loss, with no remaining teeth regardless of cause",
        "The retention of all natural teeth into older adulthood",
        "The loss of exactly six or more teeth from decay or gum disease"
      ],
      correctAnswer: 1
    },
    {
      id: 91363,
      question: "An individual with at least one natural tooth is described by which term?",
      options: [
        "Retained",
        "Exfoliated",
        "Edentulous",
        "Dentate"
      ],
      correctAnswer: 3
    },
    {
      id: 91364,
      question: "In the 2020 NHANES, how was the cause of tooth loss handled during examination?",
      options: [
        "Tooth loss was not assessed at all in the 2020 survey period",
        "No attempt was made to differentiate caries from periodontal causes",
        "Only teeth lost to orthodontic treatment were recorded as missing",
        "Every tooth was precisely classified by its specific cause of loss"
      ],
      correctAnswer: 1
    },
    {
      id: 91365,
      question: "It is recommended that tooth loss be measured in older adults using which approach?",
      options: [
        "A basic screening approach",
        "A full epidemiologic examination only",
        "Remote digital photographic analysis",
        "Dental insurance claims review only"
      ],
      correctAnswer: 0
    },
    {
      id: 91366,
      question: "Which two programs collect population data on oral and pharyngeal cancer (OPC) occurrence?",
      options: [
        "The Behavioral Risk Factor System and the Medical Expenditure Survey",
        "The World Health Organization and the Federal Interagency Workgroup",
        "The Association of State and Territorial Dental Directors and the ADA",
        "The CDC National Program of Cancer Registries and the NIH SEER program"
      ],
      correctAnswer: 3
    },
    {
      id: 91367,
      question: "What is identified as the biggest risk factor for oral and pharyngeal cancer (OPC)?",
      options: [
        "The presence of dental sealants on molars",
        "The consumption of fluoridated drinking water",
        "The retention of all natural teeth into old age",
        "The use of tobacco in all of its forms"
      ],
      correctAnswer: 3
    },
    {
      id: 91368,
      question: "Data on the number of deaths resulting from OPC are obtained from which source?",
      options: [
        "Water Fluoridation Reporting System monitoring records",
        "Death certificates collected through the National Vital Statistics System",
        "Clinical sealant examinations performed in school programs",
        "Self-reported telephone interviews conducted by the BRFSS"
      ],
      correctAnswer: 1
    },
    {
      id: 91369,
      question: "Why is detecting OPC at the earliest stage (Stage 1, localized) important?",
      options: [
        "It is associated with an increased survival rate",
        "It eliminates the need for any tobacco surveillance",
        "It increases the number of teeth a patient retains",
        "It reduces the cost of community water fluoridation"
      ],
      correctAnswer: 0
    },
    {
      id: 91370,
      question: "The Global Tobacco Surveillance System (GTSS) was developed through collaboration among which entities?",
      options: [
        "The ASTDD, the ADA, and private dental insurance companies",
        "The NIH, the SEER program, and state dental licensing boards",
        "The CDC, the WHO, and the Canadian Public Health Association",
        "The FIW, the MEPS program, and the National Cancer Institute"
      ],
      correctAnswer: 2
    },
    {
      id: 91371,
      question: "The Global Youth Tobacco Survey (GYTS) within the GTSS is conducted with which group?",
      options: [
        "Third-year dentistry and medicine students only",
        "Adults aged 65 years and older in nursing homes",
        "Teachers and administrators from participating schools",
        "Youth aged 13–15 years in schools"
      ],
      correctAnswer: 3
    },
    {
      id: 91372,
      question: "On the older adult Basic Screening Survey, malocclusion is assessed by measuring which of the following?",
      options: [
        "The number of permanent teeth lost to periodontal disease only",
        "The proportion of root surfaces that are decayed or filled",
        "The presence of at least one dental sealant per person",
        "Posterior functional contacts, indicating whether teeth oppose and function"
      ],
      correctAnswer: 3
    },
    {
      id: 91373,
      question: "How are craniofacial anomalies such as cleft lip and palate usually expressed in the U.S.?",
      options: [
        "As a dichotomous yes/no score during basic screening surveys",
        "As a per-surface count using the Decayed, Missing, Filled index",
        "As a self-reported telephone interview question on the BRFSS",
        "As a proportion or rate based on recordings on birth certificates"
      ],
      correctAnswer: 3
    },
    {
      id: 91374,
      question: "Dean's Fluorosis Index (DFI), also called the Community Fluorosis Index (CFI), is used to measure what?",
      options: [
        "The proportion of root surfaces that are decayed or filled",
        "The prevalence and severity of dental fluorosis in the population",
        "The swelling, color, and bleeding of the gingival tissues",
        "The cumulative lifetime caries experience in permanent teeth"
      ],
      correctAnswer: 1
    },
    {
      id: 91375,
      question: "Dean's Fluorosis Index scores fluorosis on which scale?",
      options: [
        "A 0 to 4 scale representing categories from normal to severe",
        "An ordinal scale of bleeding severity around each tooth",
        "A 1 to 10 scale based on the number of teeth affected",
        "A dichotomous yes/no scale of presence or absence only"
      ],
      correctAnswer: 0
    },
    {
      id: 91376,
      question: "Why is scoring nonfluoride opacities helpful when assessing fluorosis?",
      options: [
        "It allows fluorosis to be scored entirely through self-report",
        "It speeds up the examination by eliminating the need to score teeth",
        "It removes the need to differentiate fluorosis from caries lesions",
        "It helps control for fluorosis measurement error and misclassification"
      ],
      correctAnswer: 3
    },
    {
      id: 91377,
      question: "Which is listed as an advantage of using digital imaging to score fluorosis?",
      options: [
        "It allows a tactile examination of all tooth surfaces directly",
        "It is faster, easier, and more cost-effective than clinical examination",
        "It provides a permanent record that can be archived for repeated scoring",
        "It is entirely free of any technique sensitivity or image variation"
      ],
      correctAnswer: 2
    },
    {
      id: 91378,
      question: "Which is listed as an advantage of clinical examination (versus digital imaging) for fluorosis?",
      options: [
        "It can be kept for longitudinal assessment and examiner training",
        "It allows blinding of examiners to minimize potential bias",
        "It provides a permanent record that can be archived for later use",
        "It is fast, easy, cost-effective, and allows a tactile examination"
      ],
      correctAnswer: 3
    },
    {
      id: 91379,
      question: "On the Basic Screening Survey, the urgency criterion is especially linked to which of the following?",
      options: [
        "The proportion of the population that is caries-free",
        "The cumulative lifetime caries experience score",
        "The presence of dental sealants on permanent molars",
        "The need for referral for oral health care"
      ],
      correctAnswer: 3
    },
    {
      id: 91380,
      question: "Referral when a need for dental care is observed during screening is described as which of the following?",
      options: [
        "A task that can only be performed by a licensed physician",
        "A necessary component and an ethical obligation",
        "A practice that is discouraged in public health surveillance",
        "An optional step left entirely to the examiner's discretion"
      ],
      correctAnswer: 1
    },
    {
      id: 91381,
      question: "Community water fluoridation is measured by which of the following?",
      options: [
        "The percentage of people served by optimally fluoridated public systems",
        "The number of states that operate an oral cancer registry",
        "The total number of dental sealants placed in school programs",
        "The proportion of adults who have lost all of their natural teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 91382,
      question: "Surveillance data on the fluoridation status of public water systems are obtained from which source?",
      options: [
        "The Surveillance, Epidemiology, and End Results (SEER) program",
        "The Medical Expenditure Panel Survey (MEPS)",
        "The Water Fluoridation Reporting System (WFRS)",
        "The Behavioral Risk Factor Surveillance System (BRFSS)"
      ],
      correctAnswer: 2
    },
    {
      id: 91383,
      question: "My Water's Fluoride is best described as which of the following?",
      options: [
        "A clinical index used to score dental fluorosis on a 0 to 4 scale",
        "A registry of oral and pharyngeal cancer deaths by state and county",
        "A source of fluoridation surveillance information available to the public",
        "A telephone survey of adult behaviors that influence health status"
      ],
      correctAnswer: 2
    },
    {
      id: 91384,
      question: "A common measure of access to and use of the oral healthcare system is which of the following?",
      options: [
        "Having a dental visit in the past year, called dental attendance",
        "The cumulative lifetime caries experience measured by the DMF index",
        "The percentage of people served by fluoridated water systems",
        "The number of root surfaces that are decayed or filled per person"
      ],
      correctAnswer: 0
    },
    {
      id: 91385,
      question: "The biennial National Study of Long-Term Care Providers (NSLTCP) collects data from which sources?",
      options: [
        "Administrators of residential care communities and adult day services centers",
        "Third-year students pursuing degrees in dentistry and medicine",
        "State and tribal fluoridation managers monitoring water quality",
        "School teachers and administrators participating in tobacco surveys"
      ],
      correctAnswer: 0
    },
    {
      id: 91386,
      question: "Oral health-related quality of life (OHRQOL) builds on which broader concepts?",
      options: [
        "The leading health indicators and the core public health functions",
        "Quality of life (QOL) and health-related quality of life (HRQOL)",
        "The Decayed, Missing, Filled index and the Root Caries Index",
        "Basic screening surveys and full epidemiologic examinations"
      ],
      correctAnswer: 1
    },
    {
      id: 91387,
      question: "Measuring health-related quality of life (HRQOL) is characterized as which of the following?",
      options: [
        "Possible only through clinical intraoral examination procedures",
        "Restricted to counting the number of teeth lost in a population",
        "Subjective and based on an individual's self-report of perceptions",
        "Entirely objective and easier to measure than health outcomes"
      ],
      correctAnswer: 2
    },
    {
      id: 91388,
      question: "How is OHRQOL primarily measured?",
      options: [
        "By measuring physical, psychological, and social dimensions with questionnaires",
        "By reviewing dental insurance claims and cost data from insurers",
        "By scoring fluorosis remotely from digital photographs of teeth",
        "By counting the number of decayed, missing, and filled teeth only"
      ],
      correctAnswer: 0
    },
    {
      id: 91389,
      question: "A state dental public health program organized within a state health department is referred to as which of the following?",
      options: [
        "A Global Tobacco Surveillance System program",
        "A Federally Qualified Health Center program",
        "A National Oral Health Surveillance System",
        "A State Oral Health Program (SOHP)"
      ],
      correctAnswer: 3
    },
    {
      id: 91390,
      question: "Assessment of the infrastructure and capacity of the oral healthcare system involves examining which components?",
      options: [
        "Only the fluoride concentration of community water systems",
        "Only the number of teeth lost to caries in the population",
        "Funding, workforce, resources, program structure, and activities",
        "Only the retail prices of toothpaste and oral hygiene products"
      ],
      correctAnswer: 2
    },
    {
      id: 91391,
      question: "The ASTDD Guidelines for State and Territorial Health Programs are framed around which foundation?",
      options: [
        "The core public health functions and 10 essential public health services",
        "The seven attributes of an effective clinical dental index",
        "The eight competency domains used to certify health educators",
        "The five overarching goals of the Healthy People 2030 framework"
      ],
      correctAnswer: 0
    },
    {
      id: 91392,
      question: "The ASTDD Competencies for State Oral Health Programs are categorized under how many domains?",
      options: [
        "Five domains",
        "Twelve domains",
        "Seven domains",
        "Ten domains"
      ],
      correctAnswer: 2
    },
    {
      id: 91393,
      question: "Which is one of the competency domains for strong state oral health programs?",
      options: [
        "Build Support with stakeholders to promote oral health",
        "Accredit dental schools located within each U.S. state",
        "Set retail prices for dental products sold to consumers",
        "Eliminate all government involvement in public health"
      ],
      correctAnswer: 0
    },
    {
      id: 91394,
      question: "How does the ASTDD serve as an evaluation mechanism for state oral health programs?",
      options: [
        "By annually surveying SOHPs to collect data on best-practice parameters",
        "By setting the fees that dentists must charge for their services",
        "By performing clinical examinations on every resident of each state",
        "By directly funding every local fluoride varnish program nationwide"
      ],
      correctAnswer: 0
    },
    {
      id: 91395,
      question: "Which is identified as a major challenge for state oral health surveillance moving forward?",
      options: [
        "A complete absence of any oral diseases in the population",
        "An excess of federal funding that cannot be spent in time",
        "Too many trained dental public health professionals available",
        "Limited infrastructure, insufficient resources, and workforce shortages"
      ],
      correctAnswer: 3
    },
    {
      id: 91396,
      question: "Reliability analyses from recent NHANES periods showed that using dental hygienists as examiners resulted in which of the following?",
      options: [
        "A complete inability to measure caries, sealants, or probing depths",
        "Data quality far below the acceptable level for surveillance",
        "An acceptable level of data quality similar to using dentists",
        "Results that could not be compared with dentist examinations"
      ],
      correctAnswer: 2
    },
    {
      id: 91397,
      question: "Compared with an epidemiological survey using the DMFT index, the unit cost of a BSS screening is which of the following?",
      options: [
        "More cost-efficient",
        "Far more expensive",
        "Impossible to determine",
        "Exactly equal in cost"
      ],
      correctAnswer: 0
    },
    {
      id: 91398,
      question: "How have states reported success in finding cost-efficient methods of oral health surveillance?",
      options: [
        "By ending participation in the National Oral Health Surveillance System",
        "By linking to existing systems and adding self-report oral health questions",
        "By relying solely on private dental practices to report data",
        "By eliminating all data collection on oral health indicators"
      ],
      correctAnswer: 1
    },
    {
      id: 91399,
      question: "Public health surveillance is the ongoing systematic collection, analysis, and interpretation of health-related data.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91400,
      question: "Healthy People objectives are established each cycle as twenty-year national health objectives.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91401,
      question: "The Decayed, Missing, Filled (DMF) Index is considered irreversible because it reflects cumulative lifetime caries experience.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91402,
      question: "An epidemiologic examination uses only direct visual observation with a tongue blade and no dental instruments.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91403,
      question: "The use of tobacco in all of its forms is the biggest risk factor for oral and pharyngeal cancer.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91404,
      question: "Composite periodontal indices that scored gingivitis and periodontitis on the same scale are still considered valid today.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91405,
      question: "Edentulism refers to complete tooth loss, meaning no remaining teeth regardless of the cause of loss.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91406,
      question: "Dean's Fluorosis Index scores fluorosis on a dichotomous yes/no scale of presence or absence only.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91407,
      question: "The National Oral Health Surveillance System (NOHSS) was established through collaboration between the CDC Division of Oral Health and the ASTDD.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
  ],
  "5. Population Health": [
    {
      id: 91408,
      question: "How many oral diseases and conditions account for most of the global oral disease burden?",
      options: [
        "Three oral diseases and conditions",
        "Five oral diseases and conditions",
        "Seven oral diseases and conditions",
        "Nine oral diseases and conditions"
      ],
      correctAnswer: 2
    },
    {
      id: 91409,
      question: "Which oral condition is the most prevalent worldwide?",
      options: [
        "Oral and pharyngeal cancer",
        "Untreated dental caries",
        "Severe periodontitis",
        "Cleft lip and cleft palate"
      ],
      correctAnswer: 1
    },
    {
      id: 91410,
      question: "Noma (cancrum oris) is best described as which of the following?",
      options: [
        "A reversible gum inflammation caused by poor oral hygiene",
        "A disfiguring form of gangrene that destroys orofacial tissues",
        "A malignant squamous cell tumor of the tongue and pharynx",
        "A common birth defect affecting the lip and palate of newborns"
      ],
      correctAnswer: 1
    },
    {
      id: 91411,
      question: "Noma primarily occurs in which group?",
      options: [
        "Adolescents with high socioeconomic status and education",
        "Wealthy older adults with excellent access to dental care",
        "Young malnourished children aged 2 to 6 years in extreme poverty",
        "Middle-aged adults in highly developed urban nations"
      ],
      correctAnswer: 2
    },
    {
      id: 91412,
      question: "The Pan American Health Organization (PAHO) is best described as which of the following?",
      options: [
        "The WHO Regional Office for the Americas tracking oral health indicators",
        "A private company that sells dental insurance across the nation",
        "A federal agency that licenses dentists in the United States",
        "An organization that funds all school-based sealant programs"
      ],
      correctAnswer: 0
    },
    {
      id: 91413,
      question: "Dental caries is described in the chapter as which of the following?",
      options: [
        "A genetic disorder present at birth in most newborns",
        "A rare condition that affects only older adults in poverty",
        "A disease that has been completely eradicated in the U.S.",
        "One of the most common and preventable chronic diseases of children"
      ],
      correctAnswer: 3
    },
    {
      id: 91414,
      question: "According to the chapter, the burden of oral diseases in the U.S. is best described as which of the following?",
      options: [
        "Limited entirely to people living in large urban cities",
        "Spread unevenly throughout the population, with profound disparities",
        "Distributed equally and fairly across all population groups",
        "Concentrated only among wealthy, well-insured individuals"
      ],
      correctAnswer: 1
    },
    {
      id: 91415,
      question: "Which groups are noted as experiencing the poorest oral health?",
      options: [
        "Only middle-income adults living in suburban communities",
        "The poor of all ages, especially children and older adults in poverty",
        "Wealthy individuals with private dental insurance coverage",
        "People living exclusively in fluoridated urban areas"
      ],
      correctAnswer: 1
    },
    {
      id: 91416,
      question: "Socioeconomic status (SES) is associated with oral diseases because individuals in poverty do which of the following?",
      options: [
        "Experience fewer serious consequences from oral disease",
        "Have greater access to care and higher oral health literacy",
        "Receive more frequent preventive dental visits than others",
        "Lack resources for preventive care and have lower oral health literacy"
      ],
      correctAnswer: 3
    },
    {
      id: 91417,
      question: "Among adolescents 14 to 17 years old, dental caries has been reported to be how common compared with asthma?",
      options: [
        "Six times more common than asthma",
        "Four times more common than asthma",
        "Eight times more common than asthma",
        "Two times more common than asthma"
      ],
      correctAnswer: 1
    },
    {
      id: 91418,
      question: "What is identified as a cause of the general decline in caries prevalence in children since the 1980s?",
      options: [
        "Community water fluoridation, other fluorides, and dental sealants",
        "A reduction in the total number of children in the population",
        "The complete removal of fluoride from public water systems",
        "The elimination of all sugar from children's diets nationwide"
      ],
      correctAnswer: 0
    },
    {
      id: 91419,
      question: "How does the prevalence of caries experience in children relate to family income?",
      options: [
        "Caries experience decreases as family income increases",
        "Caries experience is unrelated to family income at all",
        "Caries experience is identical across all income levels",
        "Caries experience increases as family income increases"
      ],
      correctAnswer: 0
    },
    {
      id: 91420,
      question: "According to the Oral Health Surveillance Report (2011–2016), what percentage of adults 65 and older had experienced dental caries?",
      options: [
        "About 56%",
        "Over 96%",
        "About 76%",
        "About 36%"
      ],
      correctAnswer: 1
    },
    {
      id: 91421,
      question: "Despite their effectiveness, dental sealants are described in the chapter as which of the following?",
      options: [
        "Equally distributed across all income and racial groups",
        "Underutilized, with most states not meeting the need in high-risk schools",
        "Overused in nearly every school across the entire nation",
        "Required by federal law for all children in public schools"
      ],
      correctAnswer: 1
    },
    {
      id: 91422,
      question: "In the 3–5-year-old group, children from low-income families had a higher rate of sealants in primary teeth likely because of which factors?",
      options: [
        "A federal law banning sealants for higher-income children",
        "A complete lack of access to any dental care services",
        "Higher caries risk and an increase in Medicaid coverage",
        "Lower caries risk and reduced need for any treatment"
      ],
      correctAnswer: 2
    },
    {
      id: 91423,
      question: "Community water fluoridation is described as which of the following?",
      options: [
        "A method that increases oral health disparities in communities",
        "A cornerstone of dental caries prevention benefiting all ages and SES",
        "A program available exclusively in rural farming communities",
        "A treatment that benefits only wealthy, well-insured adults"
      ],
      correctAnswer: 1
    },
    {
      id: 91424,
      question: "What is the Healthy People 2030 goal for the proportion of people served by optimally fluoridated community water systems?",
      options: [
        "87.1% by 2030",
        "57.1% by 2030",
        "77.1% by 2030",
        "67.1% by 2030"
      ],
      correctAnswer: 2
    },
    {
      id: 91425,
      question: "In 2016, the proportion of the U.S. population with access to fluoridated community water was 72.8%, a drop attributed to which factor?",
      options: [
        "A sudden decision by most states to stop fluoridating water",
        "A federal law that banned community water fluoridation",
        "A large decrease in the total U.S. population that year",
        "A methodology change in data analysis introduced that year"
      ],
      correctAnswer: 3
    },
    {
      id: 91426,
      question: "Of the 30 largest U.S. cities, which one is noted as not being fluoridated?",
      options: [
        "Boston, Massachusetts",
        "Phoenix, Arizona",
        "Houston, Texas",
        "Portland, Oregon"
      ],
      correctAnswer: 3
    },
    {
      id: 91427,
      question: "In the 2009–2014 NHANES, periodontitis was classified using case definitions developed by which collaboration?",
      options: [
        "A workgroup of the CDC and the American Academy of Periodontology",
        "The World Health Organization and the National Cancer Institute",
        "The American Dental Association and private insurance companies",
        "The Health Resources and Services Administration and the ADEA"
      ],
      correctAnswer: 0
    },
    {
      id: 91428,
      question: "The 2009–2014 NHANES results revealed that what percentage of adults 30 and older sampled had periodontitis?",
      options: [
        "32%",
        "52%",
        "42%",
        "62%"
      ],
      correctAnswer: 2
    },
    {
      id: 91429,
      question: "According to the 2009–2014 NHANES, which group had the highest prevalence of severe periodontitis?",
      options: [
        "Adults aged 65 years and older, and smokers",
        "Children under 18 years from high-income families",
        "Non-Hispanic white adults above 400% of the poverty level",
        "Adults aged 30 to 44 years who were nonsmokers"
      ],
      correctAnswer: 0
    },
    {
      id: 91430,
      question: "The most recent clinical gingivitis data (NHANES III, 1988–1994) indicated that what proportion of adults 35–44 had gingivitis?",
      options: [
        "Nearly all (90%)",
        "Nearly half (48%)",
        "About one-tenth (10%)",
        "About one-quarter (25%)"
      ],
      correctAnswer: 1
    },
    {
      id: 91431,
      question: "According to the Oral Health Surveillance Report, the prevalence of complete edentulism in adults 65 and older during 2011–2016 was which of the following?",
      options: [
        "27.3%, unchanged from 27.2% in 1999–2004",
        "7.3%, a decrease from 17.2% in 1999–2004",
        "37.3%, an increase from 27.2% in 1999–2004",
        "17.3%, a decrease from 27.2% in 1999–2004"
      ],
      correctAnswer: 3
    },
    {
      id: 91432,
      question: "The American College of Prosthodontists anticipates tooth loss and the need for denture care to do which of the following in upcoming decades?",
      options: [
        "Remain exactly the same as it was in the 1960s",
        "Decrease, because fewer people will reach older adulthood",
        "Increase, because of the increasing numbers of older adults",
        "Disappear entirely as dental care continues to improve"
      ],
      correctAnswer: 2
    },
    {
      id: 91433,
      question: "Most oral and pharyngeal cancers (OPC) are which type of malignancy?",
      options: [
        "Sarcomas",
        "Squamous cell carcinomas",
        "Adenocarcinomas",
        "Basal cell carcinomas"
      ],
      correctAnswer: 1
    },
    {
      id: 91434,
      question: "OPC linked to human papillomavirus (HPV) tend to occur in patients who are which of the following?",
      options: [
        "Exclusively female with no history of any tobacco use",
        "Older, with heavy tobacco and alcohol use and lower SES",
        "Equally distributed across all age and socioeconomic groups",
        "Younger, with less tobacco and alcohol exposure and higher SES"
      ],
      correctAnswer: 3
    },
    {
      id: 91435,
      question: "According to the 2017–2018 NHANES, who performed the majority of reported oral cancer examinations?",
      options: [
        "Other non-dental professionals (nearly 77%)",
        "Medical professionals (nearly 77%)",
        "The patient's dentist (nearly 77%)",
        "The patient's dental hygienist (nearly 77%)"
      ],
      correctAnswer: 2
    },
    {
      id: 91436,
      question: "Cleft lip (CL) and cleft palate (CP) are described in the chapter as which of the following?",
      options: [
        "A rare form of oral cancer in newborns",
        "A reversible condition treated without surgery",
        "A disease caused only by poor oral hygiene",
        "The most common birth defects"
      ],
      correctAnswer: 3
    },
    {
      id: 91437,
      question: "Which is identified as a maternal risk factor for the fetus developing cleft lip or cleft palate?",
      options: [
        "Receiving regular preventive dental care during pregnancy",
        "Maintaining a healthy diet and weight during pregnancy",
        "Smoking, alcohol overuse, or certain epilepsy medicines during pregnancy",
        "Drinking optimally fluoridated water during pregnancy"
      ],
      correctAnswer: 2
    },
    {
      id: 91438,
      question: "Care for individuals with orofacial clefts is described as most effective when delivered by which approach?",
      options: [
        "A multidisciplinary team providing services across the lifespan",
        "A single general dentist working alone in private practice",
        "Self-care by the family with no professional involvement",
        "A one-time surgery requiring no further follow-up care"
      ],
      correctAnswer: 0
    },
    {
      id: 91439,
      question: "Approximately what proportion of craniofacial injuries are sports related?",
      options: [
        "About one-third",
        "About two-thirds",
        "About three-quarters",
        "About one-half"
      ],
      correctAnswer: 0
    },
    {
      id: 91440,
      question: "Which interventions are recommended to reduce craniofacial injuries, especially during organized sports?",
      options: [
        "Passenger restraints, helmets, protective gear, and mouth guards",
        "More frequent professional teeth cleanings for all athletes",
        "Mandatory dental sealants for all school-aged children",
        "Increased fluoride in community drinking water supplies"
      ],
      correctAnswer: 0
    },
    {
      id: 91441,
      question: "Most current fluorosis research focuses on which population and why?",
      options: [
        "Newborns, to track birth defects related to maternal nutrition",
        "Adolescents, to evaluate effects of a lifetime of increased fluoride exposure",
        "Older adults, to study tooth loss from periodontal disease",
        "Middle-aged adults, to measure their dental insurance coverage"
      ],
      correctAnswer: 1
    },
    {
      id: 91442,
      question: "After analyzing the 2011–2014 fluorosis data, the CDC National Center for Health Statistics suggested which of the following?",
      options: [
        "The increase in prevalence was not biologically plausible and a measurement error may have occurred",
        "The increase was fully accurate and required no further review",
        "Fluorosis had been completely eliminated from the population",
        "Fluorosis could no longer be measured using any known index"
      ],
      correctAnswer: 0
    },
    {
      id: 91443,
      question: "What is the current primary model for oral health care in the U.S.?",
      options: [
        "A fully government-run universal dental care system",
        "A system in which all care is delivered through schools",
        "The private practice delivery model with a safety net",
        "A nonprofit-only model with no private practices"
      ],
      correctAnswer: 2
    },
    {
      id: 91444,
      question: "The dental safety net is best described as which of the following?",
      options: [
        "A network available only to wealthy, fully insured patients",
        "A program that guarantees free dental care to every citizen",
        "A single uniform national system with identical services everywhere",
        "A patchwork of organizations and providers that is not uniform among communities"
      ],
      correctAnswer: 3
    },
    {
      id: 91445,
      question: "Under the private practice model, where do most dentists tend to locate?",
      options: [
        "Primarily in low-income and rural underserved areas",
        "In high-income areas that can support them, more than low-income areas",
        "Evenly across high-income and low-income areas alike",
        "Only in government facilities and public health clinics"
      ],
      correctAnswer: 1
    },
    {
      id: 91446,
      question: "Which of the following is listed as an internal barrier to accessing oral health care?",
      options: [
        "Dental hygiene supervision requirements set by law",
        "Fear of dental care and lack of awareness of oral health importance",
        "Lack of availability of providers in the community",
        "Narrow scope of dental hygiene practice in the state"
      ],
      correctAnswer: 1
    },
    {
      id: 91447,
      question: "Which of the following is listed as an external barrier to accessing oral health care?",
      options: [
        "Low personal health literacy and lack of education",
        "Fear of dental care and denial of one's diagnosis",
        "Lack of availability of providers and lack of transportation",
        "Personal cultural values, habits, and individual attitudes"
      ],
      correctAnswer: 2
    },
    {
      id: 91448,
      question: "The number of children, adolescents, and adults who used the oral healthcare system in the previous year was described as which of the following for Healthy People 2020?",
      options: [
        "An unmeasurable benchmark",
        "A developmental objective only",
        "A leading health indicator",
        "A discontinued objective"
      ],
      correctAnswer: 2
    },
    {
      id: 91449,
      question: "Nearly what proportion of 2017–2018 NHANES participants reported being unable to obtain needed dental care during the previous year?",
      options: [
        "Nearly 20%",
        "Nearly 80%",
        "Nearly 40%",
        "Nearly 60%"
      ],
      correctAnswer: 0
    },
    {
      id: 91450,
      question: "Which factors are cited as explaining a decrease in financial barriers to dental care from 1997 to 2016?",
      options: [
        "An increase in the cost of all dental procedures nationwide",
        "A reduction in the total number of dentists in practice",
        "Economic recovery, flattening of dental fees, and more public coverage",
        "The elimination of Medicaid and CHIP dental coverage"
      ],
      correctAnswer: 2
    },
    {
      id: 91451,
      question: "Dental insurance coverage is also referred to as which of the following?",
      options: [
        "Out-of-pocket payment",
        "Direct patient payment",
        "Fee-for-service payment",
        "Third-party payment"
      ],
      correctAnswer: 3
    },
    {
      id: 91452,
      question: "About what proportion of insured individuals have private dental insurance versus public benefits?",
      options: [
        "About one-third private and about two-thirds public",
        "Nearly all private and almost none public",
        "About half private and about half public",
        "About two-thirds private and about one-third public"
      ],
      correctAnswer: 3
    },
    {
      id: 91453,
      question: "How does private dental insurance differ from private health insurance?",
      options: [
        "Dental-plan premiums cost less, but enrollees pay greater out-of-pocket costs",
        "Dental and health plans have identical premiums and out-of-pocket costs",
        "Dental-plan premiums cost more, and enrollees pay less out-of-pocket",
        "Dental plans require no premiums and cover all costs fully"
      ],
      correctAnswer: 0
    },
    {
      id: 91454,
      question: "Medicare is best described in relation to dental coverage as which of the following?",
      options: [
        "A program covering all routine dental care for low-income children",
        "A state program that fully funds dental care for pregnant women",
        "The primary source of comprehensive dental coverage for older adults",
        "A health program for older adults that is not a current source of dental coverage"
      ],
      correctAnswer: 3
    },
    {
      id: 91455,
      question: "Under Medicaid, dental coverage is required for which group as part of EPSDT benefits?",
      options: [
        "All adult enrollees",
        "All child enrollees",
        "Only pregnant women",
        "Only older adults"
      ],
      correctAnswer: 1
    },
    {
      id: 91456,
      question: "Medicaid minimum dental benefits for children must cover which of the following?",
      options: [
        "Relief of pain and infections, tooth restoration, and health maintenance",
        "Only hospital-based oral surgery for medical conditions",
        "Only cosmetic procedures such as whitening and veneers",
        "Only orthodontic treatment for adolescents and adults"
      ],
      correctAnswer: 0
    },
    {
      id: 91457,
      question: "Adult dental coverage under Medicaid is best described as which of the following?",
      options: [
        "Federally required to be comprehensive in every state",
        "Considered optional, with states determining what benefits are provided",
        "Identical to children's coverage in all 50 states",
        "Prohibited by federal law in all circumstances"
      ],
      correctAnswer: 1
    },
    {
      id: 91458,
      question: "CHIP is best described as which of the following?",
      options: [
        "A federal program providing dental coverage only to older adults",
        "A private insurance plan purchased directly by individuals",
        "A joint state-federal program financing coverage for children not eligible for Medicaid",
        "A program that covers only emergency adult dental care"
      ],
      correctAnswer: 2
    },
    {
      id: 91459,
      question: "In the indemnity (fee-for-service) dental benefits plan, reimbursement is based on which of the following?",
      options: [
        "A barter exchange of goods between provider and patient",
        "The usual, customary, and reasonable (UCR) fee",
        "A flat encounter fee regardless of services provided",
        "A fixed capitation payment per enrolled patient"
      ],
      correctAnswer: 1
    },
    {
      id: 91460,
      question: "Capitation as a payment mechanism is best described as which of the following?",
      options: [
        "A fee set for each service and charged each time it is performed",
        "Reimbursement based on an average of fees for a geographic area",
        "A negotiated exchange of goods or services without using money",
        "A fixed payment for all or most care a group needs during a contract period"
      ],
      correctAnswer: 3
    },
    {
      id: 91461,
      question: "A copayment is best described as which of the following?",
      options: [
        "A percentage of the fee that the patient must pay each visit",
        "An amount paid out of pocket before insurance begins to pay",
        "A maximum dollar limit the plan will pay each year",
        "A fixed amount the patient pays at each visit to discourage overuse"
      ],
      correctAnswer: 3
    },
    {
      id: 91462,
      question: "A deductible is best described as which of the following?",
      options: [
        "A fixed dollar amount paid by the patient at each visit",
        "An amount the patient must pay out of pocket before the plan pays",
        "A percentage of each fee shared between patient and plan",
        "The maximum dollar amount a plan will pay each year"
      ],
      correctAnswer: 1
    },
    {
      id: 91463,
      question: "National dental care expenditures in 2016 were approximately which of the following?",
      options: [
        "About $12 billion, accounting for 30% of all healthcare expenditures",
        "About $124 billion, accounting for 3.7% of all healthcare expenditures",
        "About $500 billion, accounting for 25% of all healthcare expenditures",
        "About $50 billion, accounting for 15% of all healthcare expenditures"
      ],
      correctAnswer: 1
    },
    {
      id: 91464,
      question: "The decline in uninsured children from 15.8% in 2010 to 10.3% in 2015 is attributed to which factor?",
      options: [
        "A reduction in the total number of children in the U.S.",
        "The elimination of Medicaid dental benefits for children",
        "The increase in children's dental coverage resulting from the ACA",
        "A federal law banning private dental insurance for children"
      ],
      correctAnswer: 2
    },
    {
      id: 91465,
      question: "The dental insurance situation for adults aged 65 and older is described as which of the following?",
      options: [
        "Fully provided through the Medicare program for all seniors",
        "Better than coverage for any other adult age group",
        "A staggering dearth of coverage, with about 62% uninsured in 2014",
        "Comprehensive coverage, with nearly all older adults insured"
      ],
      correctAnswer: 2
    },
    {
      id: 91466,
      question: "The current dental workforce is described in relation to need and demand as which of the following?",
      options: [
        "Unable to meet present-day need and demand because of inadequate supply",
        "Shrinking only because demand for care is rapidly declining",
        "More than sufficient to meet all current and future demand",
        "Exactly balanced with present-day need and demand"
      ],
      correctAnswer: 0
    },
    {
      id: 91467,
      question: "Based on DHHS projections, what was expected regarding dentists by 2025?",
      options: [
        "The complete elimination of the dental profession",
        "A significant surplus of dentists",
        "A significant shortage of dentists",
        "An exact balance of supply and demand"
      ],
      correctAnswer: 2
    },
    {
      id: 91468,
      question: "The dentist-to-population ratio in 2018 was estimated at approximately which of the following?",
      options: [
        "About 61 dentists per 100,000 people",
        "About 100 dentists per 100,000 people",
        "About 30 dentists per 100,000 people",
        "About 150 dentists per 100,000 people"
      ],
      correctAnswer: 0
    },
    {
      id: 91469,
      question: "Dental hygiene is described as having which employment outlook?",
      options: [
        "No expected change in employment levels through 2028",
        "An expected decline of 11% through 2028 as demand falls",
        "A complete elimination of the profession by 2028",
        "An expected growth of 11% through 2028, among the fastest-growing occupations"
      ],
      correctAnswer: 3
    },
    {
      id: 91470,
      question: "Where do dental therapists practice primarily?",
      options: [
        "Only in hospital operating rooms performing surgery",
        "Exclusively in private high-income suburban practices",
        "In public health settings, though more are entering private practice",
        "Solely in dental schools as classroom instructors"
      ],
      correctAnswer: 2
    },
    {
      id: 91471,
      question: "Regarding diversity of the oral health workforce, the chapter notes which trend?",
      options: [
        "Nonwhite dental hygiene graduates decreased steadily after 2011",
        "Nonwhite dental hygiene graduates increased from 23.8% in 2011 to 31.8% in 2018",
        "The workforce became entirely white between 2011 and 2018",
        "Diversity figures remained completely unchanged since 2011"
      ],
      correctAnswer: 1
    },
    {
      id: 91472,
      question: "The number of accredited dental hygiene programs increased dramatically from which figures?",
      options: [
        "From 56 in 1990 to 66 in 2018",
        "From 66 in 1990 to 56 in 2018",
        "From 327 in 1990 to 202 in 2018",
        "From 202 in 1990 to 327 in 2018"
      ],
      correctAnswer: 3
    },
    {
      id: 91473,
      question: "Maldistribution of dental professionals contributes to poor access to dental care, especially in which areas?",
      options: [
        "Rural and inner-city areas",
        "Areas with the highest dentist-to-population ratios",
        "Wealthy suburban areas",
        "Densely populated downtown areas"
      ],
      correctAnswer: 0
    },
    {
      id: 91474,
      question: "A dental health professional shortage area (dental HPSA) is identified by which agency?",
      options: [
        "The Health Resources and Services Administration (HRSA)",
        "The Association of State and Territorial Dental Directors",
        "The American Dental Association (ADA)",
        "The Centers for Disease Control and Prevention (CDC)"
      ],
      correctAnswer: 0
    },
    {
      id: 91475,
      question: "A HPSA dental designation occurs when the population-to-provider ratio is higher than which threshold?",
      options: [
        "10,000 to 1",
        "500 to 1",
        "5,000 to 1",
        "1,000 to 1"
      ],
      correctAnswer: 2
    },
    {
      id: 91476,
      question: "HRSA scores a dental HPSA on a scale of 0 to 26, with a higher score indicating which of the following?",
      options: [
        "Lesser need",
        "No need at all",
        "An adequate workforce",
        "Greater need"
      ],
      correctAnswer: 3
    },
    {
      id: 91477,
      question: "The number of dental HPSAs designated by HRSA has done which of the following over time?",
      options: [
        "Decreased steadily, from 6782 in 1993 to 792 in 2019",
        "Been eliminated entirely by the year 2019",
        "Remained exactly the same from 1993 to 2019",
        "Grown exponentially, from 792 in 1993 to 6782 in 2019"
      ],
      correctAnswer: 3
    },
    {
      id: 91478,
      question: "In 2018, about what proportion of dentists accepted Medicaid or CHIP for child dental services?",
      options: [
        "About 19%",
        "About 39%",
        "About 89%",
        "About 69%"
      ],
      correctAnswer: 1
    },
    {
      id: 91479,
      question: "To strengthen the dental public health infrastructure, the chapter recommends which of the following?",
      options: [
        "Legal authority to use personnel efficiently and cost-effectively",
        "Eliminating direct reimbursement for dental hygienists",
        "Limiting the scope of practice for dental therapists further",
        "Reducing the total number of dental hygienists in practice"
      ],
      correctAnswer: 0
    },
    {
      id: 91480,
      question: "The number of older adults (ages 65 and over) is expected to do which of the following during 2016–2060?",
      options: [
        "Almost double, from 49.2 million to 94.7 million",
        "Decrease by about half over the period",
        "Remain completely unchanged through 2060",
        "Fall below the number of children by 2034"
      ],
      correctAnswer: 0
    },
    {
      id: 91481,
      question: "How is racial diversity of the U.S. population expected to change by 2060?",
      options: [
        "Increase, with the non-Hispanic white population decreasing to 44.3%",
        "Remain completely unchanged from current levels",
        "Decrease, with the non-Hispanic white population growing sharply",
        "Become entirely non-Hispanic white across the nation"
      ],
      correctAnswer: 0
    },
    {
      id: 91482,
      question: "The ASTDD evaluation of state oral health program (SOHP) infrastructure generally demonstrated which finding?",
      options: [
        "That infrastructure and capacity were universally excellent",
        "That SOHPs no longer needed any federal or state funding",
        "A need to strengthen the infrastructure and capacity of SOHPs",
        "That all SOHPs were fully staffed and adequately funded"
      ],
      correctAnswer: 2
    },
    {
      id: 91483,
      question: "According to the ASTDD, placing dental public health programs under a broader organizational umbrella has which effect?",
      options: [
        "It guarantees full funding for the oral health program",
        "It greatly increases the effectiveness of the program",
        "It has no effect whatsoever on program effectiveness",
        "It reduces the effectiveness of a state oral health program"
      ],
      correctAnswer: 3
    },
    {
      id: 91484,
      question: "The ASTDD recommends that a state dental director should have which of the following?",
      options: [
        "A full-time position with a dental background and public health experience",
        "A part-time position with no dental or public health background",
        "A temporary contract position lasting less than one year",
        "A purely administrative role with no clinical knowledge required"
      ],
      correctAnswer: 0
    },
    {
      id: 91485,
      question: "In the 2011 Pew evaluation, how did most states perform against the policy benchmarks for children's oral health?",
      options: [
        "The benchmarks could not be measured for any state",
        "Most did not have key policies in place, and no state met all benchmarks",
        "Nearly every state met all of the policy benchmarks",
        "All states exceeded every benchmark by a wide margin"
      ],
      correctAnswer: 1
    },
    {
      id: 91486,
      question: "SOHPs are described as being funded by which of the following?",
      options: [
        "A single source of funding from private dental insurers",
        "Out-of-pocket payments collected directly from patients",
        "Profits earned from selling dental products to consumers",
        "A variety of means, including state revenues, foundations, and federal grants"
      ],
      correctAnswer: 3
    },
    {
      id: 91487,
      question: "Community health centers are best described as which of the following?",
      options: [
        "Private dental offices located in high-income suburban areas",
        "Federal hospitals that provide only emergency surgical care",
        "Community-based, patient-directed organizations serving vulnerable populations",
        "For-profit clinics serving only well-insured wealthy patients"
      ],
      correctAnswer: 2
    },
    {
      id: 91488,
      question: "What proportion of community health center patients receive oral health services?",
      options: [
        "More than 90%, because all centers provide dental care",
        "None, because centers do not offer any oral health care",
        "Less than 25%, because not all centers have an oral health component",
        "Exactly 50%, evenly split among all patients served"
      ],
      correctAnswer: 2
    },
    {
      id: 91489,
      question: "Teledentistry (TD) is best described as which of the following?",
      options: [
        "A model that expands capacity by providing a remote workforce",
        "A method available only to wealthy, fully insured patients",
        "A system that eliminates the need for any licensed dentists",
        "A program that replaces all in-person dental care nationwide"
      ],
      correctAnswer: 0
    },
    {
      id: 91490,
      question: "How does teledentistry help reach underserved areas with no dentists?",
      options: [
        "It removes the need for any oral health professionals at all",
        "It requires every patient to travel to a distant dental office",
        "It limits care strictly to patients in large urban centers",
        "Nondentists onsite consult with remote dentists to expand the workforce"
      ],
      correctAnswer: 3
    },
    {
      id: 91491,
      question: "Which is identified as a barrier that still limits the use of teledentistry?",
      options: [
        "A complete lack of any technology to support remote care",
        "Varying state laws and inconsistent insurance reimbursement",
        "Federal laws that prohibit teledentistry in every state",
        "A total absence of patient demand for remote dental care"
      ],
      correctAnswer: 1
    },
    {
      id: 91492,
      question: "In the Alaska Tribal Health System program, who provides dental services to isolated rural regions where there are no dentists?",
      options: [
        "Traveling private-practice oral surgeons",
        "Out-of-state volunteer dental students",
        "Alaska Dental Health Aide Therapists (DHATs)",
        "Hospital-based emergency room physicians"
      ],
      correctAnswer: 2
    },
    {
      id: 91493,
      question: "Which factor is expected to impact future changes in the oral health workforce?",
      options: [
        "The elimination of every dental school in the country",
        "A total end to all interprofessional collaborative practice",
        "A complete halt to all immigration into the United States",
        "Expanded scope of practice for dental hygienists and dental therapists"
      ],
      correctAnswer: 3
    },
    {
      id: 91494,
      question: "According to the chapter's Guiding Principles, what is described as critical for improved oral health outcomes to come to fruition?",
      options: [
        "Political will at all government levels",
        "The complete privatization of all dental care",
        "The removal of all public health programs",
        "An end to community water fluoridation efforts"
      ],
      correctAnswer: 0
    },
    {
      id: 91495,
      question: "Which is listed as a key element necessary to achieve improved oral health in future decades?",
      options: [
        "A reduction in the diversity of the dental workforce nationwide",
        "Fewer partnerships between public and private agencies",
        "Elimination of evidence-based population-based interventions",
        "A culturally diverse, educated, competent dental public health workforce"
      ],
      correctAnswer: 3
    },
    {
      id: 91496,
      question: "Untreated dental caries is the most prevalent oral condition worldwide.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91497,
      question: "Noma primarily occurs in wealthy older adults who have excellent access to dental care.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91498,
      question: "Community water fluoridation benefits Americans of all ages and socioeconomic status and helps reduce oral health disparities.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91499,
      question: "Medicare is currently a major source of comprehensive dental coverage for adults aged 65 and older.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91500,
      question: "Under Medicaid, dental coverage is required for all child enrollees as part of EPSDT benefits.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91501,
      question: "A dental health professional shortage area (HPSA) is designated when the population-to-provider ratio is higher than 5,000 to 1.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91502,
      question: "Most dentists in the U.S. choose to practice in low-income and rural underserved areas rather than high-income areas.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91503,
      question: "Teledentistry can expand the capacity of state oral health programs and community health centers by providing a remote workforce.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91504,
      question: "Capitation is the most commonly used payment mechanism in dentistry today.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
  ],
  "6. Oral Health Programs in the Community": [
    {
      id: 91505,
      question: "School-based dental sealant programs have been shown to reduce dental caries by up to what amount?",
      options: [
        "Up to 60%",
        "Up to 75%",
        "Up to 45%",
        "Up to 30%"
      ],
      correctAnswer: 0
    },
    {
      id: 91506,
      question: "Water fluoridation decreases tooth decay by about what percentage today?",
      options: [
        "About 47%",
        "About 27%",
        "About 67%",
        "About 87%"
      ],
      correctAnswer: 1
    },
    {
      id: 91507,
      question: "The best practice approach is best defined as which of the following?",
      options: [
        "A strategy chosen solely by a single dentist's personal preference",
        "A public health strategy supported by evidence for its impact and effectiveness",
        "A program funded entirely by private dental insurance companies",
        "A method that relies only on tradition without any scientific basis"
      ],
      correctAnswer: 1
    },
    {
      id: 91508,
      question: "As the largest grant-making agency in the federal government for health programs, which agency funds services at the local level?",
      options: [
        "The Department of Health and Human Services (DHHS)",
        "The Association of State and Territorial Dental Directors",
        "The American Dental Hygienists' Association",
        "The Environmental Protection Agency (EPA)"
      ],
      correctAnswer: 0
    },
    {
      id: 91509,
      question: "State oral health programs (SOHPs) are best described as which of the following?",
      options: [
        "Programs that exist in only a few states across the nation",
        "Private dental practices serving only high-income state residents",
        "Federal agencies that license all dentists working in each state",
        "A major source of planning, funding, and coordinating oral health programs in states"
      ],
      correctAnswer: 3
    },
    {
      id: 91510,
      question: "SOHPs are funded by which of the following?",
      options: [
        "Profits earned from selling dental products to consumers",
        "State general revenues and national sources from DHHS divisions",
        "Private dental insurance premiums collected from patients",
        "Out-of-pocket payments made directly by treated patients"
      ],
      correctAnswer: 1
    },
    {
      id: 91511,
      question: "According to the ASTDD, oral health coalitions help SOHPs do which of the following?",
      options: [
        "Implement and promote comprehensive oral health services in communities",
        "Eliminate community involvement in oral health decisions",
        "Replace the need for any state oral health program funding",
        "Restrict oral health services to wealthy population groups"
      ],
      correctAnswer: 0
    },
    {
      id: 91512,
      question: "Which of the following is identified as a role of oral health coalitions?",
      options: [
        "Duplicating services already provided by other organizations",
        "Limiting the scope of services to a single narrow issue",
        "Maximizing the power of individuals and groups through joint action",
        "Increasing competition and distrust among partner groups"
      ],
      correctAnswer: 2
    },
    {
      id: 91513,
      question: "The Wisconsin Oral Health Coalition's Seal-A-Smile program focuses on which of the following?",
      options: [
        "Integrating dental hygienists into prenatal medical teams only",
        "Distributing dental insurance to uninsured older adults",
        "Providing school-based dental sealants to improve children's oral health",
        "Operating mobile dental clinics for rural farm workers"
      ],
      correctAnswer: 2
    },
    {
      id: 91514,
      question: "Many local health department dental clinics are described as which of the following?",
      options: [
        "Operated solely by volunteers with no government funding",
        "Privately funded, serving only fully insured wealthy patients",
        "Limited strictly to emergency oral surgery in hospitals",
        "Federally funded, offering services on a sliding scale and accepting Medicaid"
      ],
      correctAnswer: 3
    },
    {
      id: 91515,
      question: "The Future Smiles of Northern Nevada program is best described as which of the following?",
      options: [
        "A nonprofit school-based oral health program serving a vulnerable population",
        "A research lab studying fluoride concentrations in well water",
        "A federal agency that licenses dentists in two Nevada counties",
        "A private dental practice serving high-income suburban families"
      ],
      correctAnswer: 0
    },
    {
      id: 91516,
      question: "To be eligible for free lunches through the National School Lunch Program, children must be from families with incomes at or below which level?",
      options: [
        "185% of the federal poverty level",
        "130% of the federal poverty level",
        "200% of the federal poverty level",
        "250% of the federal poverty level"
      ],
      correctAnswer: 1
    },
    {
      id: 91517,
      question: "How many steps does the Community Health Program Planning Process (CHPPP) have?",
      options: [
        "Six steps",
        "Four steps",
        "Three steps",
        "Five steps"
      ],
      correctAnswer: 3
    },
    {
      id: 91518,
      question: "In the CHPPP, identifying the primary health issues corresponds to which step of the dental hygiene process of care?",
      options: [
        "Implementation",
        "Evaluation",
        "Documentation",
        "Assessment"
      ],
      correctAnswer: 3
    },
    {
      id: 91519,
      question: "In the CHPPP, implementing the selected health interventions corresponds to which step of the dental hygiene process of care?",
      options: [
        "Planning, establishing goals for the patient",
        "Assessment, collecting and reviewing patient data",
        "Implementation, completing the treatment plan",
        "Documentation, recording the treatment outcomes"
      ],
      correctAnswer: 2
    },
    {
      id: 91520,
      question: "Which of the following is identified as a key question used to establish health priorities?",
      options: [
        "Which dentist in the community has the largest private office?",
        "What is the magnitude of the problem and how many people are affected?",
        "How can community members be excluded from the decision?",
        "How much profit can the dental practice earn from the program?"
      ],
      correctAnswer: 1
    },
    {
      id: 91521,
      question: "When a community's basic needs for food and security are not being met, what happens to dental needs?",
      options: [
        "Dental needs are completely eliminated from consideration",
        "Dental needs are fully funded by the federal government",
        "Dental needs automatically become the highest priority",
        "Dental needs become a low priority for the community"
      ],
      correctAnswer: 3
    },
    {
      id: 91522,
      question: "Using dental survey data previously collected by other organizations is referred to as which of the following?",
      options: [
        "Qualitative data",
        "Primary data",
        "Outcome data",
        "Secondary data"
      ],
      correctAnswer: 3
    },
    {
      id: 91523,
      question: "A goal in program planning is best described as which of the following?",
      options: [
        "A short-term activity delivered during program implementation",
        "A broadly based ambitious statement of the impact of an intervention",
        "A specific, measurable statement of a desired end result",
        "A detailed step-by-step instruction for performing a skill"
      ],
      correctAnswer: 1
    },
    {
      id: 91524,
      question: "Objectives in program planning must include which of the following?",
      options: [
        "Broad verbs such as understand, value, or learn that cannot be measured",
        "Vague descriptions that avoid stating any measurable outcomes",
        "Only the name of the dentist who will conduct the program",
        "Action verbs that communicate specific, measurable activities and outcomes"
      ],
      correctAnswer: 3
    },
    {
      id: 91525,
      question: "Process objectives are best described as which of the following?",
      options: [
        "Actionable statements describing activities and strategies delivered in a program",
        "Descriptions of the funding sources used to operate a program",
        "Broad ambitious statements from which other objectives are derived",
        "Statements of the long-term health status changes in the population"
      ],
      correctAnswer: 0
    },
    {
      id: 91526,
      question: "Outcome objectives are best described as which of the following?",
      options: [
        "Statements describing only the program's budget and timeline",
        "Short-term statements describing the activities and services delivered",
        "Broad goals from which specific objectives will later be developed",
        "Statements of the specific intended effects of a program on the priority population"
      ],
      correctAnswer: 3
    },
    {
      id: 91527,
      question: "Which category of outcome objectives explains what program participants will learn from an educational program?",
      options: [
        "Environmental objectives",
        "Behavioral objectives",
        "Process objectives",
        "Learning objectives"
      ],
      correctAnswer: 3
    },
    {
      id: 91528,
      question: "Behavioral objectives are best described as which of the following?",
      options: [
        "Statements describing actions participants will take to improve a health issue",
        "Statements describing the activities delivered during a program",
        "Statements about changes to the physical and social surroundings",
        "Statements explaining what participants will learn from a program"
      ],
      correctAnswer: 0
    },
    {
      id: 91529,
      question: "Environmental objectives are best described as which of the following?",
      options: [
        "Statements describing actions participants will take to improve health",
        "Statements explaining how emotional, physical, and social surroundings will change",
        "Short-term statements describing the program's delivered activities",
        "Statements describing what participants will learn from a program"
      ],
      correctAnswer: 1
    },
    {
      id: 91530,
      question: "In a SMART + C objective, the letter S stands for which characteristic?",
      options: [
        "Sustainable",
        "Standardized",
        "Specific",
        "Scientific"
      ],
      correctAnswer: 2
    },
    {
      id: 91531,
      question: "In the expanded SMART + C objective format, the added letter C stands for which characteristic?",
      options: [
        "Consistent",
        "Challenging",
        "Comparable",
        "Comprehensive"
      ],
      correctAnswer: 1
    },
    {
      id: 91532,
      question: "In a SMART + C objective, the letter M (measurable) means which of the following?",
      options: [
        "The objective stretches the group toward a significant improvement",
        "Information about the objective can be collected, detected, or obtained",
        "The objective is relevant to the overall mission of the program",
        "The objective has a target date by which it will be achieved"
      ],
      correctAnswer: 1
    },
    {
      id: 91533,
      question: "On what basis should an intervention or activity be selected during program planning?",
      options: [
        "The personal preference of a single program administrator",
        "Best practices established by scientific evidence of effectiveness",
        "Whichever option is the least expensive regardless of evidence",
        "The intervention that requires the least community involvement"
      ],
      correctAnswer: 1
    },
    {
      id: 91534,
      question: "Formative (process) evaluation is best described as which of the following?",
      options: [
        "A final judgment of whether a fully operational program met its goals",
        "An internal assessment of program processes during implementation",
        "A one-time evaluation conducted only after the program ends",
        "A method that measures only the program's long-term impact"
      ],
      correctAnswer: 1
    },
    {
      id: 91535,
      question: "Using a smaller population with the intent to expand a program later is called which of the following?",
      options: [
        "Summative evaluation",
        "Pilot testing",
        "Secondary analysis",
        "Outcome assessment"
      ],
      correctAnswer: 1
    },
    {
      id: 91536,
      question: "Summative evaluation is best described as which of the following?",
      options: [
        "A judgment of whether a fully operational program met its goals and objectives",
        "A preliminary review conducted before a program begins operating",
        "An internal assessment of activities while the program is taking place",
        "A test of a program on a small population before full launch"
      ],
      correctAnswer: 0
    },
    {
      id: 91537,
      question: "When summative evaluation focuses on long-term, sustained changes from program activities, it is referred to as which of the following?",
      options: [
        "Formative evaluation",
        "Impact evaluation",
        "Process evaluation",
        "Pilot evaluation"
      ],
      correctAnswer: 1
    },
    {
      id: 91538,
      question: "According to the chapter, what is the bottom line in program evaluation?",
      options: [
        "Avoiding any negative outcomes regardless of the actual data",
        "Keeping the results private from the community and stakeholders",
        "Maximizing the profit earned by the dental practice involved",
        "Accountability to consumers, providers, agencies, and stakeholders"
      ],
      correctAnswer: 3
    },
    {
      id: 91539,
      question: "If a program evaluation concludes that objectives were not met, this means which of the following?",
      options: [
        "The objectives should be ignored when reporting the results",
        "The program is not necessarily a failure if it becomes a learning experience",
        "The program was a complete failure with no redeeming value",
        "The program must be permanently abandoned without analysis"
      ],
      correctAnswer: 1
    },
    {
      id: 91540,
      question: "Community water fluoridation is best defined as which of the following?",
      options: [
        "Applying fluoride varnish to the teeth of community members",
        "Removing all naturally occurring fluoride from the public water supply",
        "Prescribing fluoride supplement tablets to all schoolchildren",
        "Adding a controlled amount of fluoride to the public water supply to an optimal level"
      ],
      correctAnswer: 3
    },
    {
      id: 91541,
      question: "Who first noticed brown stains and few decayed teeth in patients, leading to the discovery of fluoride's role?",
      options: [
        "Dr. Frederick McKay in Colorado",
        "Dr. Robert Quock in California",
        "Dr. H. Trendley Dean at the NIH",
        "Dr. Frank Hodges in Michigan"
      ],
      correctAnswer: 0
    },
    {
      id: 91542,
      question: "What was the first U.S. city to adjust the fluoride content of its drinking water?",
      options: [
        "Portland, Oregon, in the 1950s",
        "Fairmont, Minnesota, in the 1960s",
        "Laredo, Texas, in the 1930s",
        "Grand Rapids, Michigan, in the 1940s"
      ],
      correctAnswer: 3
    },
    {
      id: 91543,
      question: "Early studies of adjusted water fluoridation demonstrated what reduction of dental caries in children's permanent teeth?",
      options: [
        "A 40% to 60% reduction",
        "A 10% to 20% reduction",
        "A 5% to 15% reduction",
        "A 70% to 90% reduction"
      ],
      correctAnswer: 0
    },
    {
      id: 91544,
      question: "The diffusion or halo effect of fluoridation refers to which of the following?",
      options: [
        "People in nonfluoridated areas benefiting from processed foods and beverages",
        "The discoloration of teeth caused by excessive fluoride intake",
        "The decline in fluoridation as cities switch to other sources",
        "Fluoride being completely removed from a community's water supply"
      ],
      correctAnswer: 0
    },
    {
      id: 91545,
      question: "Regarding fluoridation and adverse health effects, the chapter states which of the following?",
      options: [
        "Fluoridation has been shown to increase the risk of bone fracture",
        "Fluoridation is proven to cause cancer in long-term residents",
        "Strong evidence links fluoridation to several systemic disorders",
        "No credible evidence supports an association with any adverse health effect"
      ],
      correctAnswer: 3
    },
    {
      id: 91546,
      question: "The primary mechanism of action of fluoride in caries inhibition is which of the following?",
      options: [
        "Posteruptive, through remineralization of the enamel",
        "Preeruptive, through replacement during enamel formation only",
        "Mechanical removal of plaque from the tooth surfaces",
        "Systemic only, with no topical effect on the teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 91547,
      question: "Because the posteruptive effect is the primary benefit, the benefits of water fluoridation depend on which of the following?",
      options: [
        "A single application of fluoride during childhood only",
        "The complete avoidance of all other fluoride sources",
        "Daily consumption of the fluoridated tap water throughout life",
        "Living only in a community with deep artesian wells"
      ],
      correctAnswer: 2
    },
    {
      id: 91548,
      question: "A recent economic analysis demonstrated that community water fluoridation had what average return on investment?",
      options: [
        "About 20 to 1 (20 dollars saved per dollar invested)",
        "About 5 to 1 (5 dollars saved per dollar invested)",
        "About 2 to 1 (2 dollars saved per dollar invested)",
        "About 50 to 1 (50 dollars saved per dollar invested)"
      ],
      correctAnswer: 0
    },
    {
      id: 91549,
      question: "What is the current optimal level of fluoride recommended for community water fluoridation since 2015?",
      options: [
        "0.7 mg/L regardless of climatic conditions",
        "1.2 mg/L depending on the average temperature",
        "2.0 mg/L based on the local water source",
        "4.0 mg/L as a safe drinking water standard"
      ],
      correctAnswer: 0
    },
    {
      id: 91550,
      question: "Why was the optimal fluoride level changed to a single value in 2015?",
      options: [
        "A complete elimination of fluorosis from the population",
        "A decrease in the total number of community water systems",
        "A federal law banning fluoride in all drinking water",
        "Increased fluoride sources, rising fluorosis, and air conditioning use"
      ],
      correctAnswer: 3
    },
    {
      id: 91551,
      question: "The Environmental Protection Agency (EPA) requires defluoridation when the natural fluoride level of community water exceeds which amount?",
      options: [
        "Greater than 1.2 mg/L",
        "Greater than 0.7 mg/L",
        "Greater than 2.0 mg/L",
        "Greater than 4.0 mg/L"
      ],
      correctAnswer: 3
    },
    {
      id: 91552,
      question: "Antifluoridationists base their opposition to fluoridation on beliefs that fluoride does which of the following?",
      options: [
        "Is the safest and most effective public health measure available",
        "Should be added at much higher concentrations to the water",
        "Provides equal benefit to all ages and socioeconomic groups",
        "Is toxic, does not prevent decay, is costly, and infringes on rights"
      ],
      correctAnswer: 3
    },
    {
      id: 91553,
      question: "For antifluoridationists to be defeated, a fluoridation campaign must be executed in which manner?",
      options: [
        "A secretive manner hidden from the public",
        "A spontaneous, disorganized manner",
        "A well-planned, unified manner",
        "A manner that avoids educating the community"
      ],
      correctAnswer: 2
    },
    {
      id: 91554,
      question: "Why is distributing fluoride toothpaste not considered a cost-effective public health program?",
      options: [
        "Fluoride toothpaste is available only by prescription from a dentist",
        "Fluoride toothpaste is already readily available and heavily marketed to the public",
        "Fluoride toothpaste has been proven completely ineffective at preventing caries",
        "Fluoride toothpaste is too expensive for any community program to provide"
      ],
      correctAnswer: 1
    },
    {
      id: 91555,
      question: "How often is fluoride varnish recommended to be applied for optimal benefit, depending on risk level?",
      options: [
        "Once every two years",
        "Once every five years",
        "Once in a person's lifetime",
        "Two to four times a year"
      ],
      correctAnswer: 3
    },
    {
      id: 91556,
      question: "Compared with tray application of fluoride gel, fluoride varnish offers which advantage?",
      options: [
        "Complete prevention of all pit-and-fissure caries in molars",
        "A systemic effect that works even without tooth contact",
        "Ease of application with less discomfort and lower potential for harm",
        "A permanent coating like a sealant that never needs reapplication"
      ],
      correctAnswer: 2
    },
    {
      id: 91557,
      question: "In a structured school-based fluoride mouthrinse program, children typically rinse with which solution?",
      options: [
        "10 mL of 0.2% sodium fluoride for 60 seconds, weekly",
        "5 mL of 1.2% stannous fluoride for 30 seconds, monthly",
        "20 mL of 0.05% sodium fluoride for 2 minutes, yearly",
        "10 mL of 38% silver diamine fluoride for 5 minutes, daily"
      ],
      correctAnswer: 0
    },
    {
      id: 91558,
      question: "Dietary fluoride supplements are recommended only for which children?",
      options: [
        "Children over the age of 16 years in any community",
        "Children living in nonfluoridated areas, available only by prescription",
        "Children living in optimally fluoridated communities only",
        "All children regardless of where they live or their water source"
      ],
      correctAnswer: 1
    },
    {
      id: 91559,
      question: "What is described as a major disadvantage of community-based dietary fluoride supplement programs?",
      options: [
        "The high cost of the equipment needed to dispense them",
        "The complete lack of any caries-preventive effect",
        "The need for daily compliance over an extended period of time",
        "The requirement that a dentist apply them in a clinic"
      ],
      correctAnswer: 2
    },
    {
      id: 91560,
      question: "Silver diamine fluoride (38% SDF) was approved by the FDA in 2014 to treat sensitivity but is endorsed for off-label use to do which of the following?",
      options: [
        "Replace the need for community water fluoridation",
        "Whiten teeth and improve their cosmetic appearance",
        "Prevent caries and arrest cavitated carious lesions",
        "Treat periodontal disease and gingival inflammation"
      ],
      correctAnswer: 2
    },
    {
      id: 91561,
      question: "Which are described as the main contributors to an increase in dental fluorosis?",
      options: [
        "School-based dental sealant programs in high-risk schools",
        "Community water fluoridation programs operating alone",
        "Fluoridated water, infant formula, and swallowed toothpaste",
        "Fluoride mouthrinse programs conducted weekly in schools"
      ],
      correctAnswer: 2
    },
    {
      id: 91562,
      question: "To help prevent fluorosis, how much fluoride toothpaste is recommended for children younger than 3 years?",
      options: [
        "A full toothbrush of fluoride toothpaste",
        "No toothpaste of any kind at all",
        "A smear of fluoride toothpaste",
        "A pea-sized amount of fluoride toothpaste"
      ],
      correctAnswer: 2
    },
    {
      id: 91563,
      question: "Dental sealants are designed to prevent which type of caries?",
      options: [
        "Smooth surface caries",
        "Root surface caries",
        "Pit-and-fissure caries",
        "Interproximal caries"
      ],
      correctAnswer: 2
    },
    {
      id: 91564,
      question: "Studies have shown that sealant placement in permanent molars prevents what percentage of caries after 2 years?",
      options: [
        "20% of dental caries",
        "40% of dental caries",
        "60% of dental caries",
        "80% of dental caries"
      ],
      correctAnswer: 3
    },
    {
      id: 91565,
      question: "School-based sealant programs (SBSPs) generally focus on providing sealants to which children?",
      options: [
        "Adults over the age of 65 in nursing facilities",
        "Adolescents aged 16 to 19 years in high school",
        "Children younger than 3 years old in Head Start",
        "Children aged 6 to 11 years or in grades 3 through 5"
      ],
      correctAnswer: 3
    },
    {
      id: 91566,
      question: "A school-linked sealant program differs from a school-based program in that the sealants are which of the following?",
      options: [
        "Provided only to children who already have a dental home",
        "Delivered at a different site such as a clinic or private dental office",
        "Applied directly at the school using mobile or portable equipment",
        "Restricted to children who are not enrolled in any school"
      ],
      correctAnswer: 1
    },
    {
      id: 91567,
      question: "According to the ASTDD, why is targeting children shortly after tooth eruption considered a best practice?",
      options: [
        "It allows sealants to be placed without any screening",
        "It maximizes the time of greatest susceptibility to caries",
        "It eliminates the need for any parental permission",
        "It reduces the cost of the sealant material needed"
      ],
      correctAnswer: 1
    },
    {
      id: 91568,
      question: "In the CDC recommendations for school-based sealant programs, which teeth receive highest priority for sealant placement?",
      options: [
        "Third molars (wisdom teeth)",
        "Permanent maxillary lateral incisors",
        "Primary canines and incisors",
        "First and second permanent molars"
      ],
      correctAnswer: 3
    },
    {
      id: 91569,
      question: "How are schools targeted for school-based sealant programs to reach high-caries-risk children?",
      options: [
        "Schools that already have a full-time dentist on staff",
        "Schools with the lowest enrollment in the entire district",
        "Schools with a high rate of children in free or reduced-price meal programs",
        "Schools located only in wealthy suburban neighborhoods"
      ],
      correctAnswer: 2
    },
    {
      id: 91570,
      question: "Oral health education (OHE) is best defined as which of the following?",
      options: [
        "The process of teaching people about oral health to help prevent oral disease",
        "The clinical placement of dental sealants on children's molars",
        "The provision of restorative dental treatment to patients",
        "The addition of fluoride to a community's public water supply"
      ],
      correctAnswer: 0
    },
    {
      id: 91571,
      question: "According to the chapter, local programming limited to only oral health education has which result?",
      options: [
        "It eliminates the need for fluorides and sealants entirely",
        "It guarantees optimal oral health in every population group",
        "It has not resulted in improving children's oral health on its own",
        "It is the single most effective way to prevent all oral disease"
      ],
      correctAnswer: 2
    },
    {
      id: 91572,
      question: "Which is described as a characteristic of an effective teacher?",
      options: [
        "Has a thorough command of the topic and uses active, hands-on learning",
        "Reads directly from notes without engaging the audience at all",
        "Avoids giving any feedback to students on their performance",
        "Uses only a single instructional technique for every topic"
      ],
      correctAnswer: 0
    },
    {
      id: 91573,
      question: "A lesson plan is described as which of the following?",
      options: [
        "An optional document rarely used in community education",
        "A clinical treatment plan for an individual dental patient",
        "A necessary step in planning an oral health presentation",
        "A summary written only after a presentation is finished"
      ],
      correctAnswer: 2
    },
    {
      id: 91574,
      question: "Among teaching methods, the lecture method has which disadvantage?",
      options: [
        "It can only be used with very small groups of fewer than five people",
        "It allows no active participation and encourages one-way communication",
        "It is unable to convey information to a large audience at once",
        "It requires expensive technology that most settings cannot afford"
      ],
      correctAnswer: 1
    },
    {
      id: 91575,
      question: "The discussion teaching method has which advantage?",
      options: [
        "It requires no background knowledge from any participants",
        "It works best with very young children who cannot yet read",
        "It allows interaction and two-way communication among participants",
        "It guarantees that the group always reaches a clear conclusion"
      ],
      correctAnswer: 2
    },
    {
      id: 91576,
      question: "The Whole School, Whole Community, Whole Child (WSCC) model promoted by the CDC is best described as which of the following?",
      options: [
        "A student-centered model emphasizing community support and evidence-based practices",
        "A surveillance model for tracking oral cancer rates nationwide",
        "A financing model for distributing dental insurance to families",
        "A clinical model for treating individual patients in private offices"
      ],
      correctAnswer: 0
    },
    {
      id: 91577,
      question: "The success of a school-based oral health program (SBOHP) is described as depending on which of the following?",
      options: [
        "Its restriction to children who already have a dental home",
        "Its complete separation from all other school activities",
        "Its integration with other school health programs",
        "Its reliance on a single dentist working in isolation"
      ],
      correctAnswer: 2
    },
    {
      id: 91578,
      question: "In the Miles of Smiles–Laredo program, which screening tool is used for dental screening?",
      options: [
        "The Community Periodontal Index (CPI)",
        "Dean's Fluorosis Index (DFI)",
        "The Basic Screening Survey (BSS)",
        "The Decayed, Missing, Filled (DMF) Index"
      ],
      correctAnswer: 2
    },
    {
      id: 91579,
      question: "The Head Start (HS) program was originally founded in what year and as part of what initiative?",
      options: [
        "1965, as part of President Johnson's War on Poverty",
        "1995, as part of the Early Head Start expansion",
        "2010, as part of the Affordable Care Act reform",
        "2017, as part of the Consolidated Appropriations Act"
      ],
      correctAnswer: 0
    },
    {
      id: 91580,
      question: "The Head Start program was designed to serve children of which age and background?",
      options: [
        "Children aged 6 to 11 from middle-income families",
        "Older adults aged 65 and over in nursing facilities",
        "Children from birth to age 5 from low-income families",
        "Adolescents aged 12 to 17 from any income level"
      ],
      correctAnswer: 2
    },
    {
      id: 91581,
      question: "Early Head Start (EHS), established in 1995, serves children of which age range?",
      options: [
        "From 6 weeks after birth until the child turns 3 years old",
        "From 3 years old until the child turns 5 years old",
        "From 5 years old until the child enters kindergarten",
        "From birth until the child turns 12 months old only"
      ],
      correctAnswer: 0
    },
    {
      id: 91582,
      question: "Head Start programs are required to establish and maintain which of the following?",
      options: [
        "A mobile dental clinic owned by the program",
        "A Health Services Advisory Committee (HSAC)",
        "A private dental insurance plan for all families",
        "A community water fluoridation monitoring system"
      ],
      correctAnswer: 1
    },
    {
      id: 91583,
      question: "According to the Head Start Program Performance Standards, what must programs assist every enrolled family in establishing?",
      options: [
        "A community health coalition",
        "A private insurance policy",
        "A dental home",
        "A fluoridated water supply"
      ],
      correctAnswer: 2
    },
    {
      id: 91584,
      question: "Which is a way that dental hygienists can be a valuable resource to Head Start programs?",
      options: [
        "Setting the federal income eligibility limits for HS enrollment",
        "Offering screenings, preventive services, education, and referral for treatment",
        "Determining the racial and ethnic composition of enrollees",
        "Awarding the federal grant funding directly to HS agencies"
      ],
      correctAnswer: 1
    },
    {
      id: 91585,
      question: "In the Dental Hygienist Liaison program, how many dental hygienists from each state volunteer to promote oral health?",
      options: [
        "One dental hygienist from each state",
        "Twenty dental hygienists from each state",
        "Five dental hygienists from each state",
        "Ten dental hygienists from each state"
      ],
      correctAnswer: 0
    },
    {
      id: 91586,
      question: "Failure to receive primary preventive care results in which of the following?",
      options: [
        "The complete elimination of all oral disease in a population",
        "The need for more costly secondary and tertiary preventive treatment",
        "A guarantee that no further dental care will ever be needed",
        "An automatic reduction in the cost of all future dental care"
      ],
      correctAnswer: 1
    },
    {
      id: 91587,
      question: "Dental hygienists initiating treatment in community settings without a dentist present is referred to as which of the following?",
      options: [
        "Direct access",
        "Remote consultation",
        "General supervision",
        "Indirect supervision"
      ],
      correctAnswer: 0
    },
    {
      id: 91588,
      question: "According to the AAPD, the dental home should be established no later than what age?",
      options: [
        "12 months of age",
        "3 years of age",
        "21 years of age",
        "5 years of age"
      ],
      correctAnswer: 0
    },
    {
      id: 91589,
      question: "According to the ADA, not having a dental home is described as which of the following?",
      options: [
        "An advantage for people who rarely need dental treatment",
        "A requirement for enrollment in community health centers",
        "A risk factor for dental caries for children and adults of all ages",
        "A benefit that reduces the cost of dental care for families"
      ],
      correctAnswer: 2
    },
    {
      id: 91590,
      question: "The I-Smile program is best described as which of the following?",
      options: [
        "A private insurance plan sold to high-income Iowa families",
        "A federal program that licenses dentists across all 50 states",
        "A statewide dental home program connecting Iowans with dental and community resources",
        "A research study measuring fluoride levels in Iowa wells"
      ],
      correctAnswer: 2
    },
    {
      id: 91591,
      question: "The number of Americans aged 65 and older is projected to do which of the following from 2018 to 2060?",
      options: [
        "Remain completely unchanged through 2060",
        "Decrease by about half over the period",
        "Nearly double, from 52 million to 95 million",
        "Fall below the number of children under age 5"
      ],
      correctAnswer: 2
    },
    {
      id: 91592,
      question: "Why do many older adults experience a financial barrier to oral health care?",
      options: [
        "They live on a fixed income and lose dental insurance when they retire",
        "They are never eligible for any public insurance program",
        "They have more dental coverage than any other age group",
        "They are required by law to pay double for all dental services"
      ],
      correctAnswer: 0
    },
    {
      id: 91593,
      question: "Apple Tree Dental is best described as which of the following?",
      options: [
        "A federal agency that sets dental policy for older adults nationwide",
        "A nonprofit that brings dental care to older adults in long-term care via mobile equipment",
        "A private insurance company serving only wealthy retirees",
        "A research institute studying tooth loss in younger adults"
      ],
      correctAnswer: 1
    },
    {
      id: 91594,
      question: "The financing of dental public health is best described as which of the following?",
      options: [
        "Provided solely through profits from private dental practices",
        "Funded entirely by patient out-of-pocket payments alone",
        "Simple, with a single guaranteed source of permanent funding",
        "Complex, with a combination of public and private monies supporting programs"
      ],
      correctAnswer: 3
    },
    {
      id: 91595,
      question: "The Maternal and Child Health Services (MCHS) block grant (Title V) is described as which of the following?",
      options: [
        "A program that funds only oral health care for older adults",
        "A private grant available only to wealthy dental practices",
        "The oldest and one of the largest federal block grant programs",
        "A state program with no federal funding involvement at all"
      ],
      correctAnswer: 2
    },
    {
      id: 91596,
      question: "The Women, Infants, and Children (WIC) Program provides grants for which of the following?",
      options: [
        "Comprehensive restorative dental treatment for older adults",
        "Community water fluoridation infrastructure for large cities",
        "Orthodontic treatment for low-income adolescents nationwide",
        "Supplemental foods, nutrition education, immunizations, and healthcare referrals"
      ],
      correctAnswer: 3
    },
    {
      id: 91597,
      question: "A community health center that receives grants under Section 330 of the Public Health Service Act is referred to as which of the following?",
      options: [
        "A Health Services Advisory Committee (HSAC)",
        "A Federally Qualified Health Center (FQHC)",
        "A State Oral Health Program (SOHP)",
        "A Maternal and Child Health Services grantee"
      ],
      correctAnswer: 1
    },
    {
      id: 91598,
      question: "The ADA Give Kids a Smile program is best described as which of the following?",
      options: [
        "A program treating children without access to dental care free of charge",
        "A federal insurance program covering all children's dental care",
        "A research program studying caries rates in wealthy children",
        "A licensing program for new pediatric dentists nationwide"
      ],
      correctAnswer: 0
    },
    {
      id: 91599,
      question: "Donated Dental Services (DDS), operated by the Dental Lifeline Network, provides free care to which population?",
      options: [
        "Only children enrolled in Head Start programs nationwide",
        "Only wealthy adults seeking cosmetic dental procedures",
        "Only college students providing community service hours",
        "People who are disabled, aged 65 or older, or medically fragile"
      ],
      correctAnswer: 3
    },
    {
      id: 91600,
      question: "Community water fluoridation is recognized as one of the top 10 public health measures of the 20th century.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91601,
      question: "The Community Health Program Planning Process (CHPPP) has five steps that parallel the dental hygiene process of care.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91602,
      question: "Formative evaluation is conducted only after a program has been fully completed to judge whether it met its goals.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91603,
      question: "Dental sealants are designed to prevent smooth surface caries rather than pit-and-fissure caries.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91604,
      question: "The current optimal level of fluoride recommended for community water fluoridation since 2015 is 0.7 mg/L regardless of climate.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91605,
      question: "Dietary fluoride supplements are recommended for all children, including those living in optimally fluoridated areas.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91606,
      question: "Head Start programs are required to assist every enrolled family in establishing a dental home.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 91607,
      question: "Objectives written with broad verbs such as understand, value, or learn are specific and easily measurable.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 91608,
      question: "The Head Start program was founded in 1965 as part of President Johnson's War on Poverty.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
  ],
  "7. The State of Oral Health in Canada": [
    {
      id: 917001,
      question: "How does the World Health Organization define oral health?",
      options: [
        "A state free from mouth and facial pain, oral and throat cancer, infection, gum disease, decay and tooth loss",
        "A state in which the teeth are perfectly straight, white, free of stains and never require any treatment",
        "A condition reached only after a person has received braces, fillings and professional whitening of teeth",
        "A measure of how many dental appointments a person attends within a given calendar year of their life"
      ],
      correctAnswer: 0
    },
    {
      id: 917002,
      question: "Worldwide, what proportion of school-aged children and of adults are affected by tooth decay?",
      options: [
        "Around 10-20% of school-aged children and roughly half of all adults have some tooth decay",
        "Around 60-90% of school-aged children and nearly 100% of adults have tooth decay",
        "Around 30-40% of school-aged children and about one quarter of adults have tooth decay",
        "Around 5-15% of school-aged children and fewer than ten percent of adults have decay"
      ],
      correctAnswer: 1
    },
    {
      id: 917003,
      question: "How is dental caries described in terms of its place among chronic diseases?",
      options: [
        "It is a rare hereditary disorder that cannot be prevented and affects only a small share of people",
        "It is an infectious tropical disease that has now been almost completely eliminated worldwide",
        "It is the most common yet preventable chronic disease on the planet and a major public health challenge",
        "It is an age-related condition that appears only after sixty and rarely affects younger people"
      ],
      correctAnswer: 2
    },
    {
      id: 917004,
      question: "Roughly how many school-days are estimated to be missed each year in Canada due to dental-related illness?",
      options: [
        "About 12.5 million school-days are missed each year because of dental-related illness",
        "About 250 thousand school-days are missed each year because of dental-related illness",
        "About 40.4 million school-days are missed each year because of dental-related illness",
        "About 2.26 million school-days are missed each year because of dental-related illness"
      ],
      correctAnswer: 3
    },
    {
      id: 917005,
      question: "Tooth decay accounts for what share of day surgeries performed on Canadian children aged 1 to 5?",
      options: [
        "Tooth decay accounts for about one-third of all day surgeries on children aged 1 to 5",
        "Tooth decay accounts for about one-tenth of all day surgeries on children aged 1 to 5",
        "Tooth decay accounts for about three-quarters of all day surgeries on children aged 1 to 5",
        "Tooth decay accounts for about one-half of all day surgeries on children aged 1 to 5"
      ],
      correctAnswer: 0
    },
    {
      id: 917006,
      question: "According to the Global Burden of Disease data cited by the CDA, where does untreated decay of permanent teeth rank in prevalence?",
      options: [
        "Untreated caries of permanent teeth ranks 6th, affecting about 11% of the population",
        "Untreated caries of permanent teeth ranks 1st, affecting about 35% of the population",
        "Untreated caries of permanent teeth ranks 9th, affecting about 9% of the population",
        "Untreated caries of permanent teeth ranks 36th, affecting about 2% of the population"
      ],
      correctAnswer: 1
    },
    {
      id: 917007,
      question: "What was the estimated global economic impact of dental diseases in 2010 according to the CDA report?",
      options: [
        "The global economic impact of dental diseases amounted to about US$144 billion in 2010",
        "The global economic impact of dental diseases amounted to about US$13 billion in 2010",
        "The global economic impact of dental diseases amounted to about US$442 billion in 2010",
        "The global economic impact of dental diseases amounted to about US$1 trillion in 2010"
      ],
      correctAnswer: 2
    },
    {
      id: 917008,
      question: "Recent findings suggest oral diseases account for productivity losses of how much per year in Canada alone?",
      options: [
        "Oral diseases account for productivity losses of over $1 million per year in Canada alone",
        "Oral diseases account for productivity losses of over $100 billion per year in Canada alone",
        "Oral diseases account for productivity losses of over $50 million per year in Canada alone",
        "Oral diseases account for productivity losses of over $1 billion per year in Canada alone"
      ],
      correctAnswer: 3
    },
    {
      id: 917009,
      question: "According to the CDA, what proportion of the world's population is in need of appropriate and affordable oral health care?",
      options: [
        "More than 70% of the world's population, mostly in low- and middle-income countries, needs such care",
        "Fewer than 10% of the world's population, mostly in high-income countries, needs such care",
        "Roughly 25% of the world's population, mostly in upper-income countries, needs such care",
        "About 50% of the world's population, evenly spread across all income groups, needs care"
      ],
      correctAnswer: 0
    },
    {
      id: 917010,
      question: "Among the countries compared by the OECD, which had the highest average percentage visiting a dentist in the past year?",
      options: [
        "Canada had the highest average, with about 64.6% of its population visiting a dentist",
        "France had the highest average, with about 74.9% of its population visiting a dentist",
        "The United States had the highest average, with about 42.4% visiting a dentist",
        "Denmark had the highest average, with about 35.3% of its population visiting"
      ],
      correctAnswer: 1
    },
    {
      id: 917011,
      question: "What does the DMFT index represent and in whom is it usually measured?",
      options: [
        "Daily mouth and fluoride treatments, usually measured in newborns for international comparison",
        "Dental membership and family treatment, usually measured in seniors for national comparison",
        "Decayed, missing and filled teeth, usually measured in 12-year-olds for international comparison",
        "Decay, malocclusion, fillings and trauma, usually measured in adults for regional comparison"
      ],
      correctAnswer: 2
    },
    {
      id: 917012,
      question: "What was the mean DMFT score reported for Canadian 12-year-olds, compared with the OECD average?",
      options: [
        "Canada's mean DMFT was 2.50, worse than the OECD average of about 1.6 in 2006",
        "Canada's mean DMFT was 6.00, worse than the OECD average of about 1.6 in 2006",
        "Canada's mean DMFT was 3.20, equal to the OECD average of about 1.6 in 2006",
        "Canada's mean DMFT was 1.02, better than the OECD average of about 1.6 in 2006"
      ],
      correctAnswer: 3
    },
    {
      id: 917013,
      question: "In 2010, what proportion of Canadians aged 60-79 had no natural teeth (edentulism)?",
      options: [
        "About 22% of Canadians aged 60-79 had no natural teeth in 2010",
        "About 6% of Canadians aged 60-79 had no natural teeth in 2010",
        "About 38% of Canadians aged 60-79 had no natural teeth in 2010",
        "About 50% of Canadians aged 60-79 had no natural teeth in 2010"
      ],
      correctAnswer: 0
    },
    {
      id: 917014,
      question: "Why is edentulism considered an important oral health measure?",
      options: [
        "Losing all natural teeth permanently prevents any future gum disease and lowers a person's cancer risk",
        "Losing all natural teeth can change eating patterns, cause nutrient deficiency, weight loss and speech difficulty",
        "Losing all natural teeth is harmless and mainly affects a person's appearance rather than their health",
        "Losing all natural teeth automatically qualifies a person for free government dental coverage for life"
      ],
      correctAnswer: 1
    },
    {
      id: 917015,
      question: "Which countries recorded the lowest 12-year-old DMFT scores in the OECD comparison table?",
      options: [
        "Japan and Norway, both with a DMFT of around 1.7",
        "New Zealand and Australia, both with a DMFT of 1.6",
        "Germany and the United Kingdom, both with a DMFT of 0.7",
        "Canada and the United States, both with a DMFT of 1.3"
      ],
      correctAnswer: 2
    },
    {
      id: 917016,
      question: "The 2010 Health Canada report on dental health was based on which survey?",
      options: [
        "The Canadian Community Volunteer Survey conducted by the dental colleges",
        "The Global Oral Health Status Report conducted by the World Bank group",
        "The Inuit Oral Health Survey conducted by provincial dental societies",
        "The Canadian Health Measures Survey conducted by Statistics Canada"
      ],
      correctAnswer: 3
    },
    {
      id: 917017,
      question: "How did the percentage of Canadians consulting a dentist per year change from the early 1970s to the late 2000s?",
      options: [
        "It increased from about 49.5% to about 74.5%",
        "It increased from about 23.6% to about 64.6%",
        "It decreased from about 86% to about 75% over the period",
        "It stayed roughly the same at just above 60% over time"
      ],
      correctAnswer: 0
    },
    {
      id: 917018,
      question: "How did the percentage of children with at least one decayed tooth change over the 40-year period studied?",
      options: [
        "It decreased from about 96.6% to about 58.8%",
        "It decreased from about 74% to about 23.6%",
        "It decreased from about 49.5% to about 23.6%",
        "It increased from about 23.6% to about 74% over time"
      ],
      correctAnswer: 1
    },
    {
      id: 917019,
      question: "How did the percentage of adults with no natural teeth change over the 40-year period studied?",
      options: [
        "It decreased from about 74% to about 23.6%",
        "It decreased from about 96.6% to about 58.8%",
        "It decreased from about 23.6% to about 6.4%",
        "It increased from about 6.4% to about 23.6% over time"
      ],
      correctAnswer: 2
    },
    {
      id: 917020,
      question: "What proportion of Canadians were reported to have no dental insurance?",
      options: [
        "About 6% of Canadians have no dental insurance at all",
        "About 53% of Canadians have no dental insurance at all",
        "About 84% of Canadians have no dental insurance at all",
        "About 32% of Canadians have no dental insurance"
      ],
      correctAnswer: 3
    },
    {
      id: 917021,
      question: "What share of Canadians rated their own oral health as good or excellent?",
      options: [
        "About 84% of Canadians reported their oral health as good or excellent",
        "About 73% of Canadians reported their oral health as good or excellent",
        "About 64% of Canadians reported their oral health as good or excellent",
        "About 32% of Canadians reported their oral health as good or excellent"
      ],
      correctAnswer: 0
    },
    {
      id: 917022,
      question: "What share of Canadians reported brushing twice or more per day?",
      options: [
        "About 28% of Canadians brush twice or more per day",
        "About 73% of Canadians brush twice or more per day",
        "About 84% of Canadians brush twice or more per day",
        "About 53% of Canadians brush twice or more per day"
      ],
      correctAnswer: 1
    },
    {
      id: 917023,
      question: "How did treatment needs differ between lower-income and higher-income Canadians?",
      options: [
        "About 26% of lower-income Canadians had a need identified, compared with about 47% of the higher-income group",
        "About 84% of lower-income Canadians had a need identified, compared with about 32% of the higher-income group",
        "About 47% of lower-income Canadians had a need identified, compared with about 26% of the higher-income group",
        "About 6% of lower-income Canadians had a need identified, compared with about 53% of the higher-income group"
      ],
      correctAnswer: 2
    },
    {
      id: 917024,
      question: "Overall, how did oral health outcomes compare between lower-income and higher-income Canadian families?",
      options: [
        "Lower-income families had outcomes that were generally identical to those of higher-income families",
        "Lower-income families had about two times better outcomes on many measures than higher-income families",
        "Lower-income families had slightly better outcomes, mainly because they visited dentists more often",
        "Lower-income families had about two times worse outcomes on many measures than higher-income families"
      ],
      correctAnswer: 3
    },
    {
      id: 917025,
      question: "What did the Inuit Oral Health Survey (2008-2009) find compared with non-Indigenous Canadians?",
      options: [
        "More Inuit reported poor oral health, food avoidance and oral pain, and most had untreated disease",
        "More Inuit reported excellent oral health, with very few cases of decay or pain at any age",
        "Inuit oral health was identical to that of the rest of Canada across every age group studied",
        "Inuit had far fewer extractions and far more fillings than non-Indigenous Canadians overall"
      ],
      correctAnswer: 0
    },
    {
      id: 917026,
      question: "Among Inuit adolescents, how did extractions compare with fillings relative to non-Indigenous adolescents?",
      options: [
        "Inuit adolescents had 2.3 extractions per 100 fillings, versus about ten extractions per 100 for non-Indigenous",
        "Inuit adolescents had 20.3 extractions per 100 fillings, versus about one extraction per 100 fillings for non-Indigenous",
        "Inuit adolescents had the same low extraction-to-filling ratio as non-Indigenous Canadian adolescents",
        "Inuit adolescents had 1.0 extraction per 100 fillings, versus about twenty for non-Indigenous adolescents"
      ],
      correctAnswer: 1
    },
    {
      id: 917027,
      question: "According to the CDA, which two factors are the most important determinants of dental care utilization in Canada?",
      options: [
        "Province of residence and age are the two most important determinants of dental care utilization",
        "Gender and education level are the two most important determinants of dental care utilization",
        "Income and dental insurance are the two most important determinants of dental care utilization",
        "Fluoride exposure and diet are the two most important determinants of dental care utilization"
      ],
      correctAnswer: 2
    },
    {
      id: 917028,
      question: "In what four main ways do Canadians typically finance their own dental care?",
      options: [
        "Hospital billing, medicare coverage, charity grants and international aid transfer payments",
        "Provincial medicare, federal medicare, municipal taxes and employer pension contributions",
        "Bank loans, health spending accounts, mandatory premiums and provincial sales taxes",
        "Third-party insurance, private insurance, out-of-pocket payment and government-subsidized programs"
      ],
      correctAnswer: 3
    },
    {
      id: 917029,
      question: "In 2015, which source represented the largest share of dental service expenditures in Canada?",
      options: [
        "Private insurance, at about 56.2% of dental service expenditures",
        "Private direct out-of-pocket payment, at about 37.6% of expenditures",
        "Public provincial governments, at about 4.0% of expenditures",
        "Public federal government direct funding, at about 2.2% of total"
      ],
      correctAnswer: 0
    },
    {
      id: 917030,
      question: "What were the estimated total dental service expenditures in Canada in 2015, and the public-sector share?",
      options: [
        "About $13.6 billion total, with the public sector accounting for $12.7 billion (about 93.8%)",
        "About $13.6 billion total, with the public sector accounting for $846 million (about 6.2%)",
        "About $219.2 billion total, with the public sector accounting for $846 million (about 6.2%)",
        "About $6.3 billion total, with the public sector accounting for $5.4 billion (about 86%)"
      ],
      correctAnswer: 1
    },
    {
      id: 917031,
      question: "What was the estimated total per capita spending on dental services in Canada?",
      options: [
        "About $959.00 per Canadian, compared with $378.60 on drugs and $23.60 on physician services",
        "About $23.60 per Canadian, compared with $355 on drugs and $946 on physician services",
        "About $378.60 per Canadian, compared with $959 on drugs and $946 on physician services",
        "About $946.00 per Canadian, compared with $378.60 on drugs and $959 on physician services"
      ],
      correctAnswer: 2
    },
    {
      id: 917032,
      question: "What was the population-to-dentist ratio in Canada in January 2016?",
      options: [
        "About 45,961 people for every dentist in Canada",
        "About 16,220 people for every dentist in Canada",
        "About 718 people for every dentist in Canada",
        "About 1,622 people for every dentist in Canada"
      ],
      correctAnswer: 3
    },
    {
      id: 917033,
      question: "To which groups are public-sector dental expenditures in Canada primarily targeted?",
      options: [
        "Children, seniors, eligible Indigenous individuals and people with disabilities",
        "High-income earners, business owners, professionals and self-employed people",
        "Tourists, temporary workers, students and international visiting researchers",
        "Athletes, military contractors, retirees abroad and dual-citizen residents"
      ],
      correctAnswer: 0
    },
    {
      id: 917034,
      question: "Dental services financed by the federal government are available to which of the following groups?",
      options: [
        "All employed adults, their spouses, their children and their extended family members",
        "Military personnel, Indigenous status holders, veterans, federal prisoners, refugees and the RCMP",
        "Only residents of rural and remote communities who lack access to a local dentist",
        "Provincial prisoners, social-assistance recipients and low-income seniors in care"
      ],
      correctAnswer: 1
    },
    {
      id: 917035,
      question: "Of Health Canada's roughly $246 million in dental expenditures, which program received the largest share?",
      options: [
        "The Children's Oral Health Initiative, at about $231 million (94% of the total)",
        "The Dental Therapy Program, at about $231 million (94% of the total)",
        "The Non-Insured Health Benefits Program, at about $231 million (94% of the total)",
        "The Department of National Defence program, at about $231 million (94%)"
      ],
      correctAnswer: 2
    },
    {
      id: 917036,
      question: "Many publicly funded oral health services in the provinces are delivered by which professionals?",
      options: [
        "Family physicians and registered nurses working within general hospital settings",
        "Pharmacists and pharmacy technicians operating from community drug stores",
        "Oral surgeons and anaesthesiologists working only within university teaching clinics",
        "Allied oral health care professionals such as dental hygienists and dental therapists"
      ],
      correctAnswer: 3
    },
    {
      id: 917037,
      question: "In the CDA report, the term 'children' refers to which age range?",
      options: [
        "All Canadians from 0 to 18 years of age",
        "All Canadians from 6 to 12 years of age",
        "All Canadians from 0 to 6 years of age",
        "All Canadians from 1 to 5 years of age"
      ],
      correctAnswer: 0
    },
    {
      id: 917038,
      question: "Which three peoples make up Canada's Indigenous population, as noted in the report?",
      options: [
        "Inuit, refugees and new immigrants, each with unique heritages and beliefs",
        "First Nations, Inuit and Metis, each with unique heritages, languages and beliefs",
        "First Nations, settlers and Metis, each with unique heritages and languages",
        "Inuit, Metis and seniors, each with distinct cultural practices and languages"
      ],
      correctAnswer: 1
    },
    {
      id: 917039,
      question: "What is the CDA's recommended timing for a child's first visit to the dentist?",
      options: [
        "By 36 months of age, or within 12 months of the first tooth erupting",
        "By 60 months of age, or once all baby teeth have fully erupted",
        "By 12 months of age, or within 6 months of the first tooth erupting",
        "By 24 months of age, or within 18 months of the first tooth erupting"
      ],
      correctAnswer: 2
    },
    {
      id: 917040,
      question: "What proportion of Canada's water supply was reported to be fluoridated?",
      options: [
        "About 70% of Canada's water supply is fluoridated currently",
        "About 6% of Canada's water supply is fluoridated currently",
        "About 84% of Canada's water supply is fluoridated currently",
        "Only about 37% of Canada's water supply is fluoridated"
      ],
      correctAnswer: 3
    },
    {
      id: 917041,
      question: "What were the three specific priorities highlighted by the Canadian Oral Health Roundtable?",
      options: [
        "A common position on water fluoridation, oral health standards in long-term care, and education for children and parents",
        "Free national dental care, mandatory dental insurance, and dental clinics in every public school building",
        "Banning sugary drinks, taxing toothpaste, and training more oral surgeons at universities nationwide",
        "Building mobile clinics, importing more dentists, and replacing fluoride with newer cavity treatments"
      ],
      correctAnswer: 0
    },
    {
      id: 917042,
      question: "What did the Canadian Oral Health Roundtable recommend for residents of long-term care facilities?",
      options: [
        "Annual extraction of all remaining teeth, replacement with dentures, and removal of all fluoride products",
        "Regular oral health assessments, a referral process to a dentist, and a daily mouth-care plan implemented by staff",
        "Mandatory weekly hospital visits, sedation for all cleanings, and a ban on visits by dental hygienists",
        "Self-directed care only, no staff involvement, and oral checks performed solely by family members"
      ],
      correctAnswer: 1
    },
    {
      id: 917043,
      question: "Which province purchased two mobile dental clinics to help increase seniors' access to oral health care?",
      options: [
        "Manitoba, through the Healthy Smile Happy Child partnership program",
        "Ontario, through the Ontario Dental Association and TVOKids show",
        "Alberta, through the Alberta Dental Association and College",
        "Nova Scotia, through its HealthyTeeth and HealthyTeeth+ websites"
      ],
      correctAnswer: 2
    },
    {
      id: 917044,
      question: "What is Manitoba's 'Healthy Smile Happy Child' program designed to do?",
      options: [
        "Provide free dentures and full-mouth rehabilitation to low-income senior residents",
        "Operate a fleet of mobile dental clinics serving rural and remote First Nations",
        "Run a public-education television show scripted by the provincial dental association",
        "Take an upstream approach to engage communities in preventing early childhood caries"
      ],
      correctAnswer: 3
    },
    {
      id: 917045,
      question: "What did the Newfoundland and Labrador Dental Association develop with provincial government funding?",
      options: [
        "A universal program covering children from birth to 13 years, active and supported for ten years",
        "A universal program covering all seniors in long-term care, active and supported for ten years",
        "A mobile dental fleet covering rural adults, active and supported for over twenty years",
        "A free first-visit campaign for children up to age three, active for more than ten years"
      ],
      correctAnswer: 0
    },
    {
      id: 917046,
      question: "According to a 2005 survey, roughly how much volunteer dental care did Canadian dentists provide, in today's values?",
      options: [
        "About $8 million in volunteer dental services, reaching over 30,000 Canadians",
        "About $125 million in volunteer dental services, reaching over 300,000 Canadians",
        "About $846 million in volunteer dental services, reaching over 3 million Canadians",
        "About $13.6 billion in volunteer dental services, reaching all Canadians in need"
      ],
      correctAnswer: 1
    },
    {
      id: 917047,
      question: "The CDHA's 2010 brief refers to the Report on the Oral Health Component of the 2007-2009 survey as what?",
      options: [
        "A clinical treatment manual that gives step-by-step instructions for treating decay",
        "A marketing study that gives advice on attracting more patients to dental practices",
        "An oral health report card that gives a snapshot of the oral health status of Canadians",
        "A legal ruling that gives provinces the power to insure all dental care under medicare"
      ],
      correctAnswer: 2
    },
    {
      id: 917048,
      question: "On equity issues such as access to dental care, how did a 2010 Commonwealth Fund report rank Canada's health system?",
      options: [
        "Canada ranked first out of seven countries on equity issues",
        "Canada ranked second out of seven countries on equity issues",
        "Canada ranked seventh out of seven countries on equity issues",
        "Canada ranked fifth out of seven countries on equity issues"
      ],
      correctAnswer: 3
    },
    {
      id: 917049,
      question: "According to the CDHA brief, how much more common was having no insurance among low-income families versus higher-income families?",
      options: [
        "About two and a half times more common, at 49.8% versus 19.8%",
        "About ten times more common, at 49.8% versus around 5% of families",
        "About the same in both groups, at roughly 20% of families each",
        "About one and a half times more common, at 30% versus 20% of families"
      ],
      correctAnswer: 0
    },
    {
      id: 917050,
      question: "What did the CDHA recommend regarding federal investment in public health dental hygiene human resources?",
      options: [
        "Investing 100 million dollars one time only to fully privatize dental hygiene services",
        "Investing 10 million dollars each year in a designated fund to bolster these resources",
        "Investing 1 billion dollars each year to provide universal dental care for all Canadians",
        "Investing 1 million dollars each year to study whether dental hygienists are needed"
      ],
      correctAnswer: 1
    },
    {
      id: 917051,
      question: "According to the CDHA brief, how much was spent on dental care in Canada in 2009 and what share came from private sources?",
      options: [
        "About $13.6 billion was spent, with 6% coming from private sources",
        "About $10 billion was spent, with 70% coming from private sources",
        "About $6.3 billion was spent, with 94% coming from private sources",
        "About $846 million was spent, with 40% coming from private sources"
      ],
      correctAnswer: 2
    },
    {
      id: 917052,
      question: "In terms of costs by disease category, where does dental care fall according to the CDHA brief?",
      options: [
        "It follows cancer and respiratory disease but exceeds the cost of cardiovascular disease",
        "It is the single most costly disease category, ahead of all cardiovascular conditions",
        "It is the least costly disease category, well below respiratory disease and cancer",
        "It follows cardiovascular disease and exceeds the costs for respiratory disease and cancer"
      ],
      correctAnswer: 3
    },
    {
      id: 917053,
      question: "How did per capita expenditures on dental care change in Canada between 1960 and 2008?",
      options: [
        "They increased from $6.16 to $361.62 per capita",
        "They increased from $23.60 to $378.60 per capita",
        "They decreased from $361.62 to $6.16 per capita",
        "They increased from $6.16 to $959.00 per capita"
      ],
      correctAnswer: 0
    },
    {
      id: 917054,
      question: "What share of all dental expenditures in Canada came from public funding, according to the CDHA brief?",
      options: [
        "About 70%, of which the federal government contributes 40% and the provinces 60%",
        "Only about 6%, of which the federal government contributes 40% and the provinces 60%",
        "About 94%, of which the federal government contributes 60% and the provinces 40%",
        "About 50%, of which the federal government contributes 50% and the provinces 50%"
      ],
      correctAnswer: 1
    },
    {
      id: 917055,
      question: "How many oral health care providers were working in public health in Canada, according to the CDHA brief?",
      options: [
        "About 42,633 of 45,961 providers, including most dental hygienists, were in public health",
        "About 10,000 of 42,633 providers, including 453 dental hygienists, were in public health",
        "Only 718 of 42,633 providers, including 453 dental hygienists, were in public health",
        "Only 453 of 718 providers, none of them dental hygienists, were in public health"
      ],
      correctAnswer: 2
    },
    {
      id: 917056,
      question: "How long had Canada gone without collecting oral health data before the 2010 report?",
      options: [
        "Canada had not collected comparable oral health data for about three years",
        "Canada had not collected comparable oral health data for about fifty years",
        "Canada had not collected comparable oral health data for about ten years",
        "Canada had not collected comparable oral health data for about thirty years"
      ],
      correctAnswer: 3
    },
    {
      id: 917057,
      question: "How does the CDHA brief describe early childhood caries (ECC) in North America?",
      options: [
        "As the most common chronic childhood disease, labelled a pandemic in North America",
        "As a rare childhood disorder that has largely been eliminated in North America",
        "As a minor cosmetic issue affecting only the appearance of baby teeth in children",
        "As a non-preventable genetic condition unrelated to diet or oral hygiene habits"
      ],
      correctAnswer: 0
    },
    {
      id: 917058,
      question: "What does the CDHA identify as a key limitation of the 2005 Canadian Oral Health Strategy?",
      options: [
        "The absence of any measurable goals or specific objectives for any future year",
        "The absence of an implementation plan to put its goals and objectives into practice",
        "The absence of input from oral health professionals during its development process",
        "The absence of provincial participation in the wide consultation that created it"
      ],
      correctAnswer: 1
    },
    {
      id: 917059,
      question: "What change to the Canadian Health Measures Survey did the CDHA recommend?",
      options: [
        "Removing the oral health component from the survey to reduce overall costs",
        "Conducting the entire survey every single year rather than periodically",
        "Incorporating an oral health component into the survey every five years",
        "Limiting the oral health component to high-income provinces only going forward"
      ],
      correctAnswer: 2
    },
    {
      id: 917060,
      question: "How does the WHO Global oral health status report describe the worldwide reach of oral diseases?",
      options: [
        "They affect an estimated 350 million people and are among the rarest of recorded conditions",
        "They affect an estimated 35 million people and are limited mainly to low-income countries",
        "They affect an estimated 13 billion people and have been declining steadily since 1990",
        "They affect an estimated 3.5 billion people and are the most widespread of more than 300 conditions"
      ],
      correctAnswer: 3
    },
    {
      id: 917061,
      question: "Where do most people affected by oral diseases live, according to the WHO report?",
      options: [
        "Three out of four people affected live in middle-income countries",
        "Three out of four people affected live in high-income countries",
        "Three out of four people affected live in low-income countries",
        "Three out of four people affected live in the WHO African Region"
      ],
      correctAnswer: 0
    },
    {
      id: 917062,
      question: "Which oral disease has the highest number of cases worldwide, according to GBD data in the WHO report?",
      options: [
        "Severe periodontal disease, with around 2 billion cases worldwide",
        "Untreated caries of permanent teeth, with around 2 billion cases",
        "Untreated caries of deciduous teeth, with around 2 billion cases",
        "Edentulism (total tooth loss), with around 2 billion cases worldwide"
      ],
      correctAnswer: 1
    },
    {
      id: 917063,
      question: "How did global case numbers of oral diseases change between 1990 and 2019?",
      options: [
        "They fell by more than 1 billion, a 50% decrease driven by better global prevention",
        "They stayed almost flat, growing only about 3% while population grew about 45%",
        "They grew by more than 1 billion, a 50% increase that outpaced population growth of about 45%",
        "They grew by about 100 million, far slower than the population growth of 45%"
      ],
      correctAnswer: 2
    },
    {
      id: 917064,
      question: "How is a disability-adjusted life year (DALY) defined in the WHO report?",
      options: [
        "It represents the total cost of one year of dental treatment per person",
        "It represents the number of teeth lost over one year of a person's life",
        "It represents one year of life gained through a public health intervention",
        "It represents the loss of the equivalent of one year of full health"
      ],
      correctAnswer: 3
    },
    {
      id: 917065,
      question: "What did the historic resolution adopted by the World Health Assembly in May 2021 (WHA74.5) call for?",
      options: [
        "Embedding oral health within the noncommunicable disease agenda and including it in health coverage",
        "Removing oral health from all national health budgets and shifting every dental cost onto patients",
        "Replacing all the world's dentists with general physicians given brief training in oral procedures",
        "Banning the sale of fluoride toothpaste worldwide until further long-term safety studies finish"
      ],
      correctAnswer: 0
    },
    {
      id: 917066,
      question: "Which is identified as the main cause of dental caries in the WHO report?",
      options: [
        "The consumption of fluoride, which shows a clear dose-effect relationship with caries",
        "The consumption of free sugars, which shows a clear dose-effect relationship with caries",
        "Exposure to tobacco smoke, which shows a clear dose-effect relationship with caries",
        "A lack of physical activity, which shows a clear dose-effect relationship with caries"
      ],
      correctAnswer: 1
    },
    {
      id: 917067,
      question: "What does the WHO recommend regarding intake of free sugars?",
      options: [
        "Less than 50% of total energy intake, with a conditional recommendation to reduce to 25%",
        "Less than 1% of total energy intake, with a conditional recommendation to eliminate it",
        "Less than 10% of total energy intake, with a conditional recommendation to reduce further to 5%",
        "Less than 30% of total energy intake, with a conditional recommendation to reduce to 20%"
      ],
      correctAnswer: 2
    },
    {
      id: 917068,
      question: "Which set of common risk factors do oral diseases share with other noncommunicable diseases?",
      options: [
        "Genetic inheritance, advancing age and the natural eruption of teeth",
        "Cold climate, high altitude and prolonged exposure to direct sunlight",
        "Fluoride exposure, frequent tooth brushing and regular dental visits",
        "Tobacco use, harmful alcohol use and unhealthy diets high in sugar"
      ],
      correctAnswer: 3
    },
    {
      id: 917069,
      question: "According to the WHO report, what is the global prevalence of tobacco use among people aged 15 and older?",
      options: [
        "About 22.3% overall, with men using tobacco at far higher rates than women",
        "About 5.3% overall, with women using tobacco at far higher rates than men",
        "About 45% overall, split almost equally between men and women globally",
        "About 8% overall, mainly concentrated in high-income countries worldwide"
      ],
      correctAnswer: 0
    },
    {
      id: 917070,
      question: "Which association between oral and general health has the strongest and most consistent evidence?",
      options: [
        "An association between untreated caries and seasonal influenza infections",
        "An association between severe periodontal disease and diabetes mellitus",
        "An association between edentulism and improved long-term cardiovascular health",
        "An association between gingivitis and a reduced risk of developing any cancer"
      ],
      correctAnswer: 1
    },
    {
      id: 917071,
      question: "What was the goal of Japan's 8020 Campaign, launched in 1989?",
      options: [
        "To ensure people completed 80 dental visits by age 20 so that all future tooth loss is prevented",
        "To ensure that 80% of all people over age 20 received a free set of dentures within one decade",
        "To ensure people still had 20 of their teeth at age 80 to maintain nutrition and social well-being",
        "To ensure people brushed their teeth 20 times each week so as to reach age 80 free of any decay"
      ],
      correctAnswer: 2
    },
    {
      id: 917072,
      question: "What was the estimated total direct expenditure for oral diseases worldwide in 2019, per the WHO report?",
      options: [
        "About US$442 billion, roughly 25% of global direct health expenditures",
        "About US$50 billion, roughly 0.5% of global direct health expenditures",
        "About US$134 billion, roughly 50% of global direct health expenditures",
        "About US$387 billion, roughly 4.8% of global direct health expenditures"
      ],
      correctAnswer: 3
    },
    {
      id: 917073,
      question: "How does per capita dental expenditure compare between low-income and high-income countries?",
      options: [
        "Low-income countries spend about US$0.52 per capita while high-income spend about US$260, roughly 500 times more",
        "Low-income countries spend about US$260 per capita while high-income spend about US$0.52, far less per person",
        "Low-income and high-income countries spend almost identical amounts of about US$50 per capita each",
        "Low-income countries spend about US$50 per capita while high-income spend about US$100, only twice as much"
      ],
      correctAnswer: 0
    },
    {
      id: 917074,
      question: "Which country has the single highest total direct dental expenditure, according to the WHO report?",
      options: [
        "China, at about US$134 billion, followed by the United States at about US$61 billion",
        "The United States, at about US$134 billion, followed by China at about US$61 billion",
        "India, at about US$134 billion, followed by Japan at about US$61 billion worldwide",
        "Germany, at about US$134 billion, followed by France at about US$61 billion globally"
      ],
      correctAnswer: 1
    },
    {
      id: 917075,
      question: "How is dental caries defined in the WHO report?",
      options: [
        "A sudden hereditary cracking of tooth tissues caused by chewing on hard objects",
        "A reversible swelling of the gums caused by an excess of fluoride in toothpaste",
        "A gradual loss and breakdown of tooth tissues when sugars are converted by bacteria into acids",
        "An age-related thinning of the jawbone that loosens and eventually removes teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 917076,
      question: "What is the estimated global prevalence of untreated caries of permanent teeth, per the WHO report?",
      options: [
        "About 43% of the relevant population, representing more than 2 billion cases",
        "About 19% of the relevant population, representing more than 2 billion cases",
        "About 7% of the relevant population, representing more than 2 billion cases",
        "About 29% of the relevant population, representing more than 2 billion cases"
      ],
      correctAnswer: 3
    },
    {
      id: 917077,
      question: "How is severe periodontal disease defined and how widespread is it, per the WHO report?",
      options: [
        "A pocket of more than 6 mm depth; about 19% of people over 15, or more than 1 billion cases",
        "A pocket of more than 1 mm depth; about 45% of people over 15, or more than 3 billion cases",
        "Any visible bleeding of the gums; about 7% of people over 15, or about 350 million cases",
        "Loss of more than 9 teeth in total; about 11% of people over 6, or about 510 million cases"
      ],
      correctAnswer: 0
    },
    {
      id: 917078,
      question: "At roughly what age does severe periodontal disease reach its highest prevalence?",
      options: [
        "Around 6 years of age, soon after eruption",
        "Around 55 to 60 years of age",
        "Around 20 years of age, in early adulthood",
        "Around 80 years of age, in advanced old age"
      ],
      correctAnswer: 1
    },
    {
      id: 917079,
      question: "How is edentulism defined in the WHO report, and what is its global prevalence?",
      options: [
        "Loss of one or more teeth; a global average prevalence of about 45%, or 3.5 billion cases",
        "A pocket deeper than 6 mm; a global average prevalence of about 19%, or 1 billion cases",
        "Complete toothlessness; a global average prevalence of about 7%, or more than 350 million cases",
        "Decay of all baby teeth; a global average prevalence of about 43%, or 514 million cases"
      ],
      correctAnswer: 2
    },
    {
      id: 917080,
      question: "Among people older than 60, what is the global average prevalence of edentulism?",
      options: [
        "About 6.8%, meaning roughly one in fifteen people older than 60 have no teeth",
        "About 45%, meaning nearly half of all people older than 60 have no teeth left",
        "About 10.5%, meaning roughly one in ten people older than 60 have no teeth",
        "About 22.7%, meaning almost one in four people older than 60 have no teeth left"
      ],
      correctAnswer: 3
    },
    {
      id: 917081,
      question: "How many new cases and deaths from lip and oral cavity cancer were estimated worldwide in 2020?",
      options: [
        "About 377,713 new cases and 177,757 deaths",
        "About 177,757 new cases and 377,713 deaths",
        "About 37,713 new cases and 17,757 deaths in total",
        "About 3.5 million new cases and 1.7 million deaths"
      ],
      correctAnswer: 0
    },
    {
      id: 917082,
      question: "How do oral cancer incidence rates compare between men and women, per the WHO report?",
      options: [
        "The incidence rate for women (13.1 per 100,000) is more than 2.5 times higher than for men (5 per 100,000)",
        "The incidence rate for men (13.1 per 100,000) is more than 2.5 times higher than for women (5 per 100,000)",
        "The incidence rate is almost identical for men and women, at about 5 per 100,000 each",
        "The incidence rate for men is only slightly higher than for women, by less than ten percent"
      ],
      correctAnswer: 1
    },
    {
      id: 917083,
      question: "Which country alone accounts for about 36% of new oral cancer cases worldwide?",
      options: [
        "China, with more than 130,000 new cases reported in 2020",
        "The United States, with more than 130,000 new cases in 2020",
        "India, with more than 130,000 new cases reported in 2020",
        "Brazil, with more than 130,000 new cases reported in 2020"
      ],
      correctAnswer: 2
    },
    {
      id: 917084,
      question: "Which are identified as the main risk factors for lip, oral cavity and oropharyngeal cancers?",
      options: [
        "High sugar intake, poor brushing and missing dental visits, acting alone or together",
        "Fluoride exposure, cold weather and frequent travel, acting alone or in combination",
        "Genetic inheritance, advancing age and tooth eruption, acting alone or together",
        "Tobacco use, alcohol consumption and betel quid use, acting alone or in combination"
      ],
      correctAnswer: 3
    },
    {
      id: 917085,
      question: "How does chewing betel quid affect the risk of oral cavity cancer, per the WHO report?",
      options: [
        "Chewing it without tobacco raises risk about 2.5-fold, and with tobacco about 7.74-fold",
        "Chewing it without tobacco lowers risk about 2.5-fold, and with tobacco about 7.74-fold",
        "Chewing it has no measurable effect on oral cancer risk with or without tobacco",
        "Chewing it without tobacco raises risk about 100-fold, and with tobacco about 500-fold"
      ],
      correctAnswer: 0
    },
    {
      id: 917086,
      question: "Which human papillomavirus types are now the most common cause of oropharyngeal cancers?",
      options: [
        "HPV types 1 and 2 only",
        "HPV types 16 and 18",
        "HPV types 6 and 11 only",
        "HPV types 31 and 33 only"
      ],
      correctAnswer: 1
    },
    {
      id: 917087,
      question: "How common are orofacial clefts among newborns worldwide, per the WHO report?",
      options: [
        "They affect roughly 1 in 10 newborns, with more than 90% of cases in high-income countries only",
        "They affect roughly 1 in 100,000 newborns, evenly spread across all country income groups",
        "They affect roughly 1 in 1000 to 1500 newborns, with more than 90% of cases in low- and middle-income countries",
        "They affect roughly 1 in 50 newborns, with more than 90% of cases in the WHO European Region"
      ],
      correctAnswer: 2
    },
    {
      id: 917088,
      question: "What is noma, and which children does it mostly affect?",
      options: [
        "A mild reversible gum inflammation that resolves on its own, mostly affecting healthy children aged 12 to 18 in wealthy regions",
        "A hereditary tooth disorder that is rarely serious, mostly affecting newborns in high-income countries with good nutrition",
        "A cosmetic staining of the teeth from betel quid that is harmless, mostly affecting adults aged 40 and over in Asia",
        "A gangrenous disease of the mouth and face that is fatal in about 90% of untreated cases, mostly affecting children aged 2 to 6 in extreme poverty"
      ],
      correctAnswer: 3
    },
    {
      id: 917089,
      question: "How large is the global oral health workforce estimated to be, per the WHO report?",
      options: [
        "Nearly 4 million people, including about 2.5 million dentists",
        "Nearly 40 million people, including about 25 million dentists",
        "Nearly 400,000 people, including about 250,000 dentists",
        "Nearly 4 billion people, including about 2.5 billion dentists"
      ],
      correctAnswer: 0
    },
    {
      id: 917090,
      question: "How does the dentist-to-population ratio compare between high-income and low-income countries?",
      options: [
        "Low-income countries have about 6.85 dentists per 10,000, more than 12 times the high-income ratio of 0.57",
        "High-income countries have about 6.85 dentists per 10,000, more than 12 times the low-income ratio of 0.57",
        "High-income and low-income countries have an almost identical ratio of about 3.28 dentists per 10,000",
        "High-income countries have about 0.57 dentists per 10,000, only twice the low-income ratio of 0.28"
      ],
      correctAnswer: 1
    },
    {
      id: 917091,
      question: "What fluoride concentration in toothpaste do WHO and other public health agencies recommend?",
      options: [
        "Between 1 ppm and 10 ppm, used with twice-daily brushing",
        "Between 5000 ppm and 7500 ppm, used with weekly brushing",
        "Between 1000 ppm and 1500 ppm, used with twice-daily brushing",
        "Between 100 ppm and 200 ppm, used with monthly brushing"
      ],
      correctAnswer: 2
    },
    {
      id: 917092,
      question: "By roughly how much can water fluoridation reduce dental caries, according to the WHO report?",
      options: [
        "By an estimated 1% to 5%, depending on the study, location and population",
        "By an estimated 80% to 95%, depending on the study, location and population",
        "By an estimated 100%, eliminating caries entirely regardless of location",
        "By an estimated 25% to 60%, depending on the study, location and population"
      ],
      correctAnswer: 3
    },
    {
      id: 917093,
      question: "How does water fluoridation affect health equity, per the WHO report?",
      options: [
        "It does not discriminate by social class and provides universal benefit, helping to reduce inequalities",
        "It mainly benefits high-income groups and therefore tends to widen health inequalities",
        "It benefits only adults and offers no protection to children within a community",
        "It must be purchased individually, so only insured residents can receive its benefits"
      ],
      correctAnswer: 0
    },
    {
      id: 917094,
      question: "In the Philippines Fit for School program, what did daily group toothbrushing with fluoride toothpaste achieve?",
      options: [
        "It prevented up to 5% of new caries lesions and slightly increased school absence",
        "It prevented up to 38% of new caries lesions and reduced days of absence",
        "It prevented up to 90% of new caries lesions and eliminated all school absence",
        "It had no measurable effect on caries lesions or on rates of school absence"
      ],
      correctAnswer: 1
    },
    {
      id: 917095,
      question: "What share of countries have oral health surveillance data on their populations, per the WHO report?",
      options: [
        "More than two thirds of all countries have such surveillance data",
        "Almost every country has detailed such surveillance data available",
        "Fewer than one third of all countries have such surveillance data",
        "Exactly half of all countries have such surveillance data on record"
      ],
      correctAnswer: 2
    },
    {
      id: 917096,
      question: "What does the Minamata Convention on Mercury address in relation to dentistry?",
      options: [
        "Banning the use of fluoride toothpaste, which contains traces of mercury",
        "Requiring mercury fillings in all children to strengthen their teeth early",
        "Eliminating all dental x-ray machines because they release mercury vapour",
        "Phasing down the use of dental amalgam, which consists of about 50% mercury"
      ],
      correctAnswer: 3
    },
    {
      id: 917097,
      question: "Under the Minamata Convention, for which patients is the use of dental amalgam to be avoided?",
      options: [
        "Deciduous teeth, patients under 15 years, and pregnant or breastfeeding women",
        "Permanent teeth, patients over 65 years, and adults with private insurance",
        "All adult patients regardless of age, but never children or pregnant women",
        "Only patients in low-income countries, with no restriction in wealthy nations"
      ],
      correctAnswer: 0
    },
    {
      id: 917098,
      question: "How were oral health services affected during the first phase of the COVID-19 pandemic in 2020?",
      options: [
        "About 6% of countries reported partial disruption and 1% reported complete disruption",
        "About 60% of countries reported partial disruption and 17% reported severe or complete disruption",
        "Almost no countries reported any disruption to their oral health services at all",
        "Every country reported that oral health services continued completely unaffected"
      ],
      correctAnswer: 1
    },
    {
      id: 917099,
      question: "What share of all global antibiotic prescriptions are estimated to come from dental prescriptions?",
      options: [
        "About 50% of all global antibiotic prescriptions",
        "About 1% of all global antibiotic prescriptions",
        "About 10% of all global antibiotic prescriptions",
        "About 75% of all global antibiotic prescriptions"
      ],
      correctAnswer: 2
    },
    {
      id: 917100,
      question: "Which country is highlighted as having achieved universal health coverage that includes an oral health benefits package?",
      options: [
        "Japan, which has had universal health coverage since 1989",
        "The United States, which reached coverage through the 2010 reform",
        "Nigeria, which reached coverage through its noma control program",
        "Thailand, which has had universal health coverage since 2002"
      ],
      correctAnswer: 3
    },
    {
      id: 917101,
      question: "According to the WHO report, how are oral diseases distributed across social groups?",
      options: [
        "They are socially patterned, showing a social gradient that disproportionately affects vulnerable groups",
        "They are distributed at random, affecting every social group across society equally and purely by chance",
        "They mainly affect the wealthiest groups, who tend to consume far more processed food and sweet drinks",
        "They affect only isolated rural communities and almost never appear among any urban population groups"
      ],
      correctAnswer: 0
    },
    {
      id: 917102,
      question: "How are oral health inequalities defined in the WHO report?",
      options: [
        "As natural differences in oral health that are unavoidable and accepted as fair outcomes",
        "As differences in oral health status that are avoidable and deemed unfair, unacceptable and unjust",
        "As differences in dental fees charged between private clinics in the same city",
        "As variation in the number of dentists that each country decides to train each year"
      ],
      correctAnswer: 1
    },
    {
      id: 917103,
      question: "In the primary oral health care pyramid described by the WHO, how do cost and need relate across the levels?",
      options: [
        "Need and demand are highest at the top, where the least expensive care is also provided",
        "Cost and need are equal at every level of the pyramid from bottom to top",
        "Need and demand are highest at the lower levels, while the most expensive care sits at the top",
        "The most expensive care sits at the bottom, where need and demand are lowest"
      ],
      correctAnswer: 2
    },
    {
      id: 917104,
      question: "What does the WHO report identify as the dominant model in the practice of dentistry?",
      options: [
        "A prevention-focused, community-based approach relying mainly on low-cost self-care",
        "A purely public, government-run approach that excludes all private practitioners",
        "A volunteer-driven, charity-based approach that provides nearly all care free of charge",
        "A treatment-focused, surgical and interventionist approach relying on costly high-tech equipment"
      ],
      correctAnswer: 3
    },
    {
      id: 917105,
      question: "What characteristic of dentistry was brought to light as a key challenge by the COVID-19 pandemic?",
      options: [
        "Its isolation from the mainstream health system, which is an almost universal feature worldwide",
        "Its complete integration with hospital systems, which made it impossible to deliver care",
        "Its reliance on public funding, which left private dentists with no patients to treat",
        "Its lack of any infection control, which had never before been considered in dentistry"
      ],
      correctAnswer: 0
    },
    {
      id: 917106,
      question: "Based on a wide range of metrics, the CDA states that Canada is among the world leaders in the overall oral health of its citizens.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 917107,
      question: "According to the CDA report, the majority of responsibility for health care planning and delivery in Canada lies with the federal government rather than the provinces and territories.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 917108,
      question: "The CDA reports that about three out of every four Canadians visit a dental professional at least once per year.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 917109,
      question: "In Canada, dental care is largely a publicly insured service that is fully covered for all citizens under medicare.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 917110,
      question: "The WHO report states that the combined number of oral disease cases globally is about 1 billion higher than the cases of the five main noncommunicable diseases combined.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 917111,
      question: "According to the WHO report, oral diseases are largely impossible to prevent and require complex, high-technology treatment in every case.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 917112,
      question: "The WHO report notes that untreated caries in deciduous teeth is the single most common chronic childhood disease.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 917113,
      question: "The CDHA brief argues that Canada's public funding covers a higher share of total health spending than the OECD average.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 917114,
      question: "The WHO report identifies sugar consumption, all forms of tobacco use, and harmful alcohol use as key modifiable risk factors shared between oral diseases and other noncommunicable diseases.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 917115,
      question: "According to the WHO report, the negative side effect of fluorosis only occurs when fluoride is ingested in excess during the formation of the teeth.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 917116,
      question: "The CDA report states that there is a single 'one-size-fits-all' remedy for the oral health of vulnerable groups across all of Canada.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 917117,
      question: "The CDHA brief estimates that about 40.36 million hours were lost from normal activities, school or work in the previous 12 months due to check-ups or problems with teeth.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ]
};
